import React, { createContext, forwardRef, createElement, Component, Fragment, useContext, useState, useEffect, useLayoutEffect, useRef, useMemo, useCallback, Children, PureComponent } from 'react';

function _setPrototypeOf$1(o, p) {
  _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$1(o, p);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf$1(subClass, superClass);
}

/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  return tag;
}

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(options) {
    this.isSpeedy = options.speedy === undefined ? process.env.NODE_ENV === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      var _tag = createStyleElement(this);

      var before;

      if (this.tags.length === 0) {
        before = this.before;
      } else {
        before = this.tags[this.tags.length - 1].nextSibling;
      }

      this.container.insertBefore(_tag, before);
      this.tags.push(_tag);
    }

    var tag = this.tags[this.tags.length - 1];

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is a really hot path
        // we check the second character first because having "i"
        // as the second character will happen less often than
        // having "@" as the first character
        var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools

        sheet.insertRule(rule, // we need to insert @import rules before anything else
        // otherwise there will be an error
        // technically this means that the @import rules will
        // _usually_(not always since there could be multiple style tags)
        // be the first ones in prod and generally later in dev
        // this shouldn't really matter in the real world though
        // @import is generally only used for font faces from google fonts and etc.
        // so while this could be technically correct then it would be slower and larger
        // for a tiny bit of correctness that won't matter in the real world
        isImportRule ? 0 : sheet.cssRules.length);
      } catch (e) {
        if (process.env.NODE_ENV !== 'production') {
          console.warn("There was a problem inserting the following rule: \"" + rule + "\"", e);
        }
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };

  return StyleSheet;
}();

function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

var weakMemoize = function weakMemoize(func) {
  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // $FlowFixMe
      return cache.get(arg);
    }

    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var delimiter = '/*|*/';
var needle = delimiter + '}';

function toSheet(block) {
  if (block) {
    Sheet.current.insert(block + '}');
  }
}

var Sheet = {
  current: null
};
var ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
  switch (context) {
    // property
    case 1:
      {
        switch (content.charCodeAt(0)) {
          case 64:
            {
              // @import
              Sheet.current.insert(content + ';');
              return '';
            }
          // charcode for l

          case 108:
            {
              // charcode for b
              // this ignores label
              if (content.charCodeAt(2) === 98) {
                return '';
              }
            }
        }

        break;
      }
    // selector

    case 2:
      {
        if (ns === 0) return content + delimiter;
        break;
      }
    // at-rule

    case 3:
      {
        switch (ns) {
          // @font-face, @page
          case 102:
          case 112:
            {
              Sheet.current.insert(selectors[0] + content);
              return '';
            }

          default:
            {
              return content + (at === 0 ? delimiter : '');
            }
        }
      }

    case -2:
      {
        content.split(needle).forEach(toSheet);
      }
  }
};
var removeLabel = function removeLabel(context, content) {
  if (context === 1 && // charcode for l
  content.charCodeAt(0) === 108 && // charcode for b
  content.charCodeAt(2) === 98 // this ignores label
  ) {
      return '';
    }
};

var isBrowser$2 = typeof document !== 'undefined';
var rootServerStylisCache = {};
var getServerStylisCache = isBrowser$2 ? undefined : weakMemoize(function () {
  var getCache = weakMemoize(function () {
    return {};
  });
  var prefixTrueCache = {};
  var prefixFalseCache = {};
  return function (prefix) {
    if (prefix === undefined || prefix === true) {
      return prefixTrueCache;
    }

    if (prefix === false) {
      return prefixFalseCache;
    }

    return getCache(prefix);
  };
});

var createCache = function createCache(options) {
  if (options === undefined) options = {};
  var key = options.key || 'css';
  var stylisOptions;

  if (options.prefix !== undefined) {
    stylisOptions = {
      prefix: options.prefix
    };
  }

  var stylis = new stylis_min(stylisOptions);

  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var inserted = {}; // $FlowFixMe

  var container;

  if (isBrowser$2) {
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function (node) {
      var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe

      attrib.split(' ').forEach(function (id) {
        inserted[id] = true;
      });

      if (node.parentNode !== container) {
        container.appendChild(node);
      }
    });
  }

  var _insert;

  if (isBrowser$2) {
    stylis.use(options.stylisPlugins)(ruleSheet);

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      Sheet.current = sheet;

      if (process.env.NODE_ENV !== 'production' && serialized.map !== undefined) {
        var map = serialized.map;
        Sheet.current = {
          insert: function insert(rule) {
            sheet.insert(rule + map);
          }
        };
      }

      stylis(selector, serialized.styles);

      if (shouldCache) {
        cache.inserted[name] = true;
      }
    };
  } else {
    stylis.use(removeLabel);
    var serverStylisCache = rootServerStylisCache;

    if (options.stylisPlugins || options.prefix !== undefined) {
      stylis.use(options.stylisPlugins); // $FlowFixMe

      serverStylisCache = getServerStylisCache(options.stylisPlugins || rootServerStylisCache)(options.prefix);
    }

    var getRules = function getRules(selector, serialized) {
      var name = serialized.name;

      if (serverStylisCache[name] === undefined) {
        serverStylisCache[name] = stylis(selector, serialized.styles);
      }

      return serverStylisCache[name];
    };

    _insert = function _insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      var rules = getRules(selector, serialized);

      if (cache.compat === undefined) {
        // in regular mode, we don't set the styles on the inserted cache
        // since we don't need to and that would be wasting memory
        // we return them so that they are rendered in a style tag
        if (shouldCache) {
          cache.inserted[name] = true;
        }

        if ( // using === development instead of !== production
        // because if people do ssr in tests, the source maps showing up would be annoying
        process.env.NODE_ENV === 'development' && serialized.map !== undefined) {
          return rules + serialized.map;
        }

        return rules;
      } else {
        // in compat mode, we put the styles on the inserted cache so
        // that emotion-server can pull out the styles
        // except when we don't want to cache it which was in Global but now
        // is nowhere but we don't want to do a major right now
        // and just in case we're going to leave the case here
        // it's also not affecting client side bundle size
        // so it's really not a big deal
        if (shouldCache) {
          cache.inserted[name] = rules;
        } else {
          return rules;
        }
      }
    };
  }

  if (process.env.NODE_ENV !== 'production') {
    // https://esbench.com/bench/5bf7371a4cd7e6009ef61d0a
    var commentStart = /\/\*/g;
    var commentEnd = /\*\//g;
    stylis.use(function (context, content) {
      switch (context) {
        case -1:
          {
            while (commentStart.test(content)) {
              commentEnd.lastIndex = commentStart.lastIndex;

              if (commentEnd.test(content)) {
                commentStart.lastIndex = commentEnd.lastIndex;
                continue;
              }

              throw new Error('Your styles have an unterminated comment ("/*" without corresponding "*/").');
            }

            commentStart.lastIndex = 0;
            break;
          }
      }
    });
    stylis.use(function (context, content, selectors) {
      switch (context) {
        case -1:
          {
            var flag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';
            var unsafePseudoClasses = content.match(/(:first|:nth|:nth-last)-child/g);

            if (unsafePseudoClasses && cache.compat !== true) {
              unsafePseudoClasses.forEach(function (unsafePseudoClass) {
                var ignoreRegExp = new RegExp(unsafePseudoClass + ".*\\/\\* " + flag + " \\*\\/");
                var ignore = ignoreRegExp.test(content);

                if (unsafePseudoClass && !ignore) {
                  console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
                }
              });
            }

            break;
          }
      }
    });
  }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  return cache;
};

var isBrowser$1 = typeof document !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className]);
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser$1 === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }

  if (cache.inserted[serialized.name] === undefined) {
    var stylesForSSR = '';
    var current = serialized;

    do {
      var maybeStyles = cache.insert("." + className, current, cache.sheet, true);

      if (!isBrowser$1 && maybeStyles !== undefined) {
        stylesForSSR += maybeStyles;
      }

      current = current.next;
    } while (current !== undefined);

    if (!isBrowser$1 && stylesForSSR.length !== 0) {
      return stylesForSSR;
    }
  }
};

/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = memoize(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (process.env.NODE_ENV !== 'production') {
  var contentValuePattern = /(attr|calc|counters?|url)\(/;
  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;
  var msPattern = /^-ms-/;
  var hyphenPattern = /-(.)/g;
  var hyphenatedCache = {};

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    var processed = oldProcessStyleValue(key, value);

    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
      hyphenatedCache[key] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
        return _char.toUpperCase();
      }) + "?");
    }

    return processed;
  };
}

var shouldWarnAboutInterpolatingClassNameFromCss = true;

function handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (process.env.NODE_ENV !== 'production' && interpolation.toString() === 'NO_COMPONENT_SELECTOR') {
      throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
    }

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (process.env.NODE_ENV !== 'production' && interpolation.map !== undefined) {
            styles += interpolation.map;
          }

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
        } else if (process.env.NODE_ENV !== 'production') {
          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }

        break;
      }

    case 'string':
      if (process.env.NODE_ENV !== 'production') {
        var matched = [];
        var replaced = interpolation.replace(animationRegex, function (match, p1, p2) {
          var fakeVarName = "animation" + matched.length;
          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
          return "${" + fakeVarName + "}";
        });

        if (matched.length) {
          console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
        }
      }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];

  if (process.env.NODE_ENV !== 'production' && couldBeSelectorInterpolation && shouldWarnAboutInterpolatingClassNameFromCss && cached !== undefined) {
    console.error('Interpolating a className from css`` is not recommended and will cause problems with composition.\n' + 'Interpolating a className from css`` will be completely unsupported in a future major version of Emotion');
    shouldWarnAboutInterpolatingClassNameFromCss = false;
  }

  return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i], false);
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && process.env.NODE_ENV !== 'production') {
          throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value, false);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (process.env.NODE_ENV !== 'production' && _key === 'undefined') {
                  console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
                }

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var sourceMapPattern;

if (process.env.NODE_ENV !== 'production') {
  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//;
} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings, false);
  } else {
    if (process.env.NODE_ENV !== 'production' && strings[0] === undefined) {
      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
    }

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);

    if (stringMode) {
      if (process.env.NODE_ENV !== 'production' && strings[i] === undefined) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
      }

      styles += strings[i];
    }
  }

  var sourceMap;

  if (process.env.NODE_ENV !== 'production') {
    styles = styles.replace(sourceMapPattern, function (match) {
      sourceMap = match;
      return '';
    });
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = murmur2(styles) + identifierName;

  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
    return {
      name: name,
      styles: styles,
      map: sourceMap,
      next: cursor,
      toString: function toString() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
      }
    };
  }

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};

var isBrowser = typeof document !== 'undefined';
var hasOwnProperty = Object.prototype.hasOwnProperty;

var EmotionCacheContext = /*#__PURE__*/createContext( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? createCache() : null);
var ThemeContext = /*#__PURE__*/createContext({});
EmotionCacheContext.Provider;

var withEmotionCache = function withEmotionCache(func) {
  var render = function render(props, ref) {
    return /*#__PURE__*/createElement(EmotionCacheContext.Consumer, null, function (cache) {
      return func(props, cache, ref);
    });
  }; // $FlowFixMe


  return /*#__PURE__*/forwardRef(render);
};

if (!isBrowser) {
  var BasicProvider = /*#__PURE__*/function (_React$Component) {
    _inheritsLoose(BasicProvider, _React$Component);

    function BasicProvider(props, context, updater) {
      var _this;

      _this = _React$Component.call(this, props, context, updater) || this;
      _this.state = {
        value: createCache()
      };
      return _this;
    }

    var _proto = BasicProvider.prototype;

    _proto.render = function render() {
      return /*#__PURE__*/createElement(EmotionCacheContext.Provider, this.state, this.props.children(this.state.value));
    };

    return BasicProvider;
  }(Component);

  withEmotionCache = function withEmotionCache(func) {
    return function (props) {
      return /*#__PURE__*/createElement(EmotionCacheContext.Consumer, null, function (context) {
        if (context === null) {
          return /*#__PURE__*/createElement(BasicProvider, null, function (newContext) {
            return func(props, newContext);
          });
        } else {
          return func(props, context);
        }
      });
    };
  };
}

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';

var render = function render(cache, props, theme, ref) {
  var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var type = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = serializeStyles(registeredStyles);

  if (process.env.NODE_ENV !== 'production' && serialized.name.indexOf('-') === -1) {
    var labelFromStack = props[labelPropName];

    if (labelFromStack) {
      serialized = serializeStyles([serialized, 'label:' + labelFromStack + ';']);
    }
  }

  var rules = insertStyles(cache, serialized, typeof type === 'string');
  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && (process.env.NODE_ENV === 'production' || key !== labelPropName)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  var ele = /*#__PURE__*/createElement(type, newProps);

  if (!isBrowser && rules !== undefined) {
    var _ref;

    var serializedNames = serialized.name;
    var next = serialized.next;

    while (next !== undefined) {
      serializedNames += ' ' + next.name;
      next = next.next;
    }

    return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("style", (_ref = {}, _ref["data-emotion-" + cache.key] = serializedNames, _ref.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref.nonce = cache.sheet.nonce, _ref)), ele);
  }

  return ele;
}; // eslint-disable-next-line no-undef


var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
  if (typeof props.css === 'function') {
    return /*#__PURE__*/createElement(ThemeContext.Consumer, null, function (theme) {
      return render(cache, props, theme, ref);
    });
  }

  return render(cache, props, null, ref);
});

if (process.env.NODE_ENV !== 'production') {
  Emotion.displayName = 'EmotionCssPropInternal';
}

var classnames$1 = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

withEmotionCache(function (props, context) {
  return /*#__PURE__*/createElement(ThemeContext.Consumer, null, function (theme) {
    var rules = '';
    var serializedHashes = '';
    var hasRendered = false;

    var css = function css() {
      if (hasRendered && process.env.NODE_ENV !== 'production') {
        throw new Error('css can only be used during render');
      }

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var serialized = serializeStyles(args, context.registered);

      if (isBrowser) {
        insertStyles(context, serialized, false);
      } else {
        var res = insertStyles(context, serialized, false);

        if (res !== undefined) {
          rules += res;
        }
      }

      if (!isBrowser) {
        serializedHashes += " " + serialized.name;
      }

      return context.key + "-" + serialized.name;
    };

    var cx = function cx() {
      if (hasRendered && process.env.NODE_ENV !== 'production') {
        throw new Error('cx can only be used during render');
      }

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return merge(context.registered, css, classnames$1(args));
    };

    var content = {
      css: css,
      cx: cx,
      theme: theme
    };
    var ele = props.children(content);
    hasRendered = true;

    if (!isBrowser && rules.length !== 0) {
      var _ref;

      return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("style", (_ref = {}, _ref["data-emotion-" + context.key] = serializedHashes.substring(1), _ref.dangerouslySetInnerHTML = {
        __html: rules
      }, _ref.nonce = context.sheet.nonce, _ref)), ele);
    }

    return ele;
  });
});

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/

var classnames = createCommonjsModule(function (module) {
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
});

/**
 * Display an icon.
 * Uses the included feathers icon set by default but you can add your own
 */
function Icon(_ref) {
  var _cn;

  var _ref$prefix = _ref.prefix,
      prefixFromProps = _ref$prefix === void 0 ? "fe" : _ref$prefix,
      name = _ref.name,
      className = _ref.className,
      link = _ref.link,
      isAriaHidden = _ref.isAriaHidden,
      payment = _ref.payment,
      flag = _ref.flag,
      thin = _ref.thin,
      rest = _objectWithoutProperties(_ref, ["prefix", "name", "className", "link", "isAriaHidden", "payment", "flag", "thin"]);

  var prefix = payment && "payment" || flag && "flag" || prefixFromProps;
  var classes = classnames("icon", (_cn = {}, _defineProperty(_cn, prefix, true), _defineProperty(_cn, "".concat(prefix, "-").concat(name), true), _defineProperty(_cn, "icon-thin", thin), _cn), className);
  var extraProps = isAriaHidden ? {
    "aria-hidden": true
  } : null;
  return !link ? /*#__PURE__*/React.createElement("i", _extends({
    className: classes
  }, rest)) : /*#__PURE__*/React.createElement("a", _extends({
    className: "icon"
  }, extraProps, rest), /*#__PURE__*/React.createElement("i", {
    className: classes
  }));
}

var standardColors = ["primary", "secondary", "success", "warning", "danger", "info"];
var additionalColors = ["light", "dark", "body", "muted", "reset", "black-50", "white-50"];
var extraColors = ["blue", "azure", "indigo", "purple", "pink", "red", "orange", "yellow", "lime", "green", "teal", "cyan"];
var lightColors = ["blue-lt", "azure-lt", "indigo-lt", "purple-lt", "pink-lt", "red-lt", "orange-lt", "yellow-lt", "lime-lt", "green-lt", "teal-lt", "cyan-lt"];
var socialColors = ["facebook", "twitter", "google", "youtube", "vimeo", "dribble", "github", "instagram", "pinterest", "vk", "rss", "flickr", "bitbucket", "tabler"];
var colors$1 = [].concat(standardColors, extraColors, socialColors);

var breakpointModifiers = ["sm", "md", "lg", "xl", "xxl"]; // type SizeNumbers = 0 | 1 | 2 | 3 | 4 | 5;

var capitalize = function capitalize(str) {
  return typeof str === "string" ? str.charAt(0).toUpperCase() + str.slice(1) : str;
}; // function createUseTablerComponent() {
//   return;
// }
// interface SpacingObject {
//   sm: SpacingValues;
//   md: SpacingValues;
//   lg: SpacingValues;
//   xl: SpacingValues;
//   xxl: SpacingValues;
// }
// const baseSpacingProperties: BaseSpacingTypes[] = ["p", "m"];
// const spacingSides: SpacingSideModifiers[] = ["t", "b", "s", "e", "x", "y"];
// const spacingSizes: SpacingBreakpointModifiers[] = [
//   "sm",
//   "md",
//   "lg",
//   "xl",
//   "xxl",
// ];
// const spacingValues: SpacingValues[] = [0, 1, 2, 3, 4, 5, "auto"];


function createBaseVariants(base, variants) {
  return base.map(function (b) {
    return [b].concat(_toConsumableArray(variants.map(function (v) {
      return "".concat(b).concat(v);
    })));
  }).flat();
}

function buildClassName(base, postfix, value, breakpoint) {
  var className = "".concat(base);

  if (postfix) {
    className = "".concat(className, "-").concat(postfix);
  }

  if (breakpoint && breakpoint !== "zero") {
    className = "".concat(className, "-").concat(breakpoint);
  }

  className = "".concat(className, "-").concat(value);
  return className;
}

function createPropNamesFromConfig(config) {
  var _config$options5, _config$options6;

  var postfixedNames = config.bases.map(function (base) {
    var _ref;

    return (_ref = config.postfixes || []) === null || _ref === void 0 ? void 0 : _ref.map(function (p) {
      var _config$options3;

      var fn = function fn(value) {
        var _config$options;

        return typeof value === "string" || typeof value === "number" ? buildClassName(base, config !== null && config !== void 0 && (_config$options = config.options) !== null && _config$options !== void 0 && _config$options.removePostfixFromClassName ? null : p, value, null) // `${base}-${p}-${value}`
        : Object.entries(value).map(function (_ref2) {
          var _config$options2;

          var _ref3 = _slicedToArray(_ref2, 2),
              breakpoint = _ref3[0],
              v = _ref3[1];

          return buildClassName(base, config !== null && config !== void 0 && (_config$options2 = config.options) !== null && _config$options2 !== void 0 && _config$options2.removePostfixFromClassName ? null : p, v, breakpoint);
        }) //`${base}-${p}-${breakpoint}-${v}`
        .join(" ");
      };

      return [["".concat(base).concat(capitalize(p)), fn]].concat(_toConsumableArray((_config$options3 = config.options) !== null && _config$options3 !== void 0 && _config$options3.responsive ? breakpointModifiers.map(function (breakpoint) {
        return ["".concat(base).concat(capitalize(p)).concat(capitalize(breakpoint)), function (value) {
          var _config$options4;

          return buildClassName(base, config !== null && config !== void 0 && (_config$options4 = config.options) !== null && _config$options4 !== void 0 && _config$options4.removePostfixFromClassName ? null : p, value, breakpoint);
        }];
      }) : []));
    });
  }).flat(2);
  var names = (_config$options5 = config.options) !== null && _config$options5 !== void 0 && _config$options5.noBaseProps ? postfixedNames : [].concat(_toConsumableArray(config.bases.map(function (base) {
    return ["".concat(base), function (value) {
      return typeof value === "string" || typeof value === "number" ? buildClassName(base, null, value, null) // `${base}-${value}`
      : Object.entries(value).map(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
            breakpoint = _ref5[0],
            v = _ref5[1];

        return buildClassName(base, null, v, breakpoint);
      }) // `${base}-${breakpoint}-${v}`
      .join(" ");
    }];
  })), _toConsumableArray(((_config$options6 = config.options) !== null && _config$options6 !== void 0 && _config$options6.responsive ? config.bases.map(function (base) {
    return breakpointModifiers.map(function (breakpoint) {
      return ["".concat(base).concat(capitalize(breakpoint)), function (value) {
        return buildClassName(base, null, value, breakpoint);
      }];
    });
  }) : []).flat(1)), _toConsumableArray(postfixedNames));
  return Object.fromEntries(names);
}

var alignTransformer = createPropNamesFromConfig({
  bases: ["align"],
  postfixes: ["items", "content", "self"],
  values: ["start", "end", "center", "baseline", "stretch"],
  options: {
    noBaseProps: true,
    responsive: true
  }
});
var borderTransformer = createPropNamesFromConfig({
  bases: ["border"],
  postfixes: [],
  values: [0, 1, 2, 3, 4, 5],
  options: {
    responsive: false
  }
});
var bgColorTransformer = createPropNamesFromConfig({
  bases: ["bg"],
  postfixes: ["color"],
  values: [].concat(_toConsumableArray(colors$1), _toConsumableArray(lightColors)),
  options: {
    responsive: false,
    noBaseProps: true,
    removePostfixFromClassName: true
  }
});
var displayTransformer = createPropNamesFromConfig({
  bases: ["d"],
  postfixes: [],
  values: ["flex", "inline-flex", "block", "inline-block", "none"],
  options: {
    responsive: true
  }
});
var flexTransformer = createPropNamesFromConfig({
  bases: ["flex"],
  postfixes: [],
  values: ["row", "column", "row-reverse", "column-reverse"],
  options: {
    responsive: true
  }
});
var flexExpandTransformer = createPropNamesFromConfig({
  bases: ["flex"],
  postfixes: ["grow", "shrink"],
  values: [1, 0],
  options: {
    noBaseProps: true,
    responsive: true
  }
});
var flexWrapTransformer = createPropNamesFromConfig({
  bases: ["flex"],
  postfixes: ["wrap"],
  values: ["wrap", "nowrap", "wrap-reverse"],
  options: {
    noBaseProps: true,
    responsive: true
  }
});
var gutterBase = createBaseVariants(["g"], ["x", "y"]);
var gutterTransformer = createPropNamesFromConfig({
  bases: gutterBase,
  postfixes: [],
  values: [0, 1, 2, 3, 4, 5, "sm", "md", "lg", "xl", "xxl"],
  options: {
    responsive: true
  }
});
var justifyTransformer = createPropNamesFromConfig({
  bases: ["justify"],
  postfixes: ["content"],
  values: ["start", "end", "center", "between", "around", "evenly"],
  options: {
    noBaseProps: true,
    responsive: true
  }
});
var lineHeightTransformer = createPropNamesFromConfig({
  bases: ["lh"],
  postfixes: [],
  values: [1, "sm", "base", "lg"]
});
var orderTransformer = createPropNamesFromConfig({
  bases: ["order"],
  postfixes: [],
  values: [0, 1, 2, 3, 4, 5, "first", "last"],
  options: {
    responsive: true
  }
});
var objectFitTransformer = createPropNamesFromConfig({
  bases: ["object"],
  postfixes: ["fit"],
  values: ["contain", "cover", "fill", "scale-down", "none"],
  options: {
    removePostfixFromClassName: true,
    noBaseProps: true
  }
});
var sizingTransformer = createPropNamesFromConfig({
  bases: ["w", "h"],
  postfixes: [],
  values: [1, 25, 50, 75, 100, "auto"]
});
var sizingViewportTransformer = createPropNamesFromConfig({
  bases: ["mw", "vw"],
  postfixes: [],
  values: [100]
});
var sizingMinViewportTransformer = createPropNamesFromConfig({
  bases: ["min"],
  postfixes: ["vw"],
  values: [100],
  options: {
    noBaseProps: true
  }
});
var spacingBase = createBaseVariants(["p", "m"], ["t", "b", "s", "e", "x", "y"]);
var spacingTransformer = createPropNamesFromConfig({
  bases: spacingBase,
  postfixes: [],
  values: [0, 1, 2, 3, 4, 5, "auto"],
  options: {
    responsive: true
  }
});
var textAlignTransformer = createPropNamesFromConfig({
  bases: ["text"],
  postfixes: ["align"],
  values: ["left", "right", "center"],
  options: {
    noBaseProps: true,
    responsive: true,
    removePostfixFromClassName: true
  }
});
var textColorTransformer = createPropNamesFromConfig({
  bases: ["text"],
  postfixes: ["color"],
  values: [].concat(_toConsumableArray(colors$1), _toConsumableArray(additionalColors)),
  options: {
    noBaseProps: true,
    removePostfixFromClassName: true
  }
});
var textTransformTransformer = createPropNamesFromConfig({
  bases: ["text"],
  postfixes: ["transform"],
  values: ["lowercase", "uppercase", "capitalize"],
  options: {
    noBaseProps: true,
    removePostfixFromClassName: true
  }
});
var trackingTransformer = createPropNamesFromConfig({
  bases: ["tracking"],
  postfixes: [],
  values: ["tight", "normal", "wide"]
});
var propTransformers = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, alignTransformer), borderTransformer), bgColorTransformer), displayTransformer), flexTransformer), flexExpandTransformer), flexWrapTransformer), gutterTransformer), justifyTransformer), lineHeightTransformer), objectFitTransformer), orderTransformer), sizingTransformer), sizingViewportTransformer), sizingMinViewportTransformer), spacingTransformer), textAlignTransformer), textColorTransformer), textTransformTransformer), trackingTransformer);

var ClassNamesContext = /*#__PURE__*/React.createContext({});
var ClassNamesProvider = function ClassNamesProvider(_ref) {
  var children = _ref.children,
      value = _ref.value;
  return /*#__PURE__*/React.createElement(ClassNamesContext.Provider, {
    value: value
  }, children);
};

/**
 * @TODO don't propagate className props to the element
 */
function createPropsParser(_ref) {
  var className = _ref.className,
      classNames = _ref.classNames;
  return function (props, classNameContext) {
    var _props$className = props.className,
        _className = _props$className === void 0 ? "" : _props$className,
        _props$classNames = props.classNames,
        _classNames = _props$classNames === void 0 ? "" : _props$classNames;

    return classnames(classNameContext, className, classNames && classNames(props), Object.entries(props).reduce(function (prev, _ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
          key = _ref3[0],
          value = _ref3[1];

      if (!value || !propTransformers[key]) {
        return prev;
      } // @ts-ignore


      return "".concat(prev, " ").concat(propTransformers[key](value));
    }, "").trim(), _className, _classNames);
  };
}
function createTablerElement(element) {
  var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      className = _ref4.className,
      component = _ref4.component,
      classNames = _ref4.classNames,
      modifyProps = _ref4.modifyProps,
      displayName = _ref4.displayName,
      defaultProps = _ref4.defaultProps,
      provideClassNames = _ref4.provideClassNames,
      Child = _ref4.child;

  var parseProps = createPropsParser({
    className: className,
    classNames: classNames
  });
  var InitialComponent = component || element || "div";
  var TablerComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
    var children = props.children,
        _props$className2 = props.className,
        className = _props$className2 === void 0 ? "" : _props$className2,
        rest = _objectWithoutProperties(props, ["children", "className"]);

    var _classNameContext = useContext(ClassNamesContext);

    var _className = parseProps(_objectSpread2({
      className: className
    }, rest), classnames(_classNameContext[displayName || ""], className.split(" ").map(function (c) {
      return _classNameContext[c];
    })));

    var _props = modifyProps ? modifyProps(rest) : rest;

    var Component = _props.as || InitialComponent;

    if (provideClassNames) {
      return /*#__PURE__*/React.createElement(ClassNamesContext.Provider, {
        value: provideClassNames
      }, /*#__PURE__*/React.createElement(Component, _extends({
        ref: ref,
        className: _className
      }, _props), Child ? /*#__PURE__*/React.createElement(Child, rest, children) : children));
    }

    return /*#__PURE__*/React.createElement(Component, _extends({
      ref: ref,
      className: _className
    }, _props), Child ? /*#__PURE__*/React.createElement(Child, props, children) : children);
  });

  if (displayName) {
    TablerComponent.displayName = displayName;
  }

  if (defaultProps) {
    TablerComponent.defaultProps = defaultProps;
  }

  return TablerComponent;
}

var Div = createTablerElement("div");
var Span = createTablerElement("span");
var Header$1 = createTablerElement("header");
var Section = createTablerElement("section");
var Nav$1 = createTablerElement("nav");
var Footer = createTablerElement("footer");
var A = createTablerElement("a");
var Button$1 = createTablerElement("button");
var P = createTablerElement("p");
var Img = createTablerElement("img");
var Ul = createTablerElement("ul");
var Li = createTablerElement("li");
var Ol = createTablerElement("ol");
var H1$1 = createTablerElement("h1");
var H2$1 = createTablerElement("h2");
var H3$1 = createTablerElement("h3");
var H4$1 = createTablerElement("h4");
var H5$1 = createTablerElement("h5");
var H6$1 = createTablerElement("h6");
var Form$1 = createTablerElement("form");
var Input = createTablerElement("input");
var Textarea = createTablerElement("textarea");
var Select = createTablerElement("select");
var Option = createTablerElement("option");
var Fieldset = createTablerElement("fieldset");
var Label$1 = createTablerElement("label");
var Iframe = createTablerElement("iframe"); // const Svg = createTablerElement<SVGElement>("svg");

var Small = createTablerElement("small");
var Table$1 = createTablerElement("table");
var Thead = createTablerElement("thead");
var Tbody = createTablerElement("tbody");
var Tfoot = createTablerElement("tfoot");
var Col = createTablerElement("col");
var Tr = createTablerElement("tr");
var Td = createTablerElement("td");
var Th = createTablerElement("th");
var El = {
  Div: Div,
  Span: Span,
  Header: Header$1,
  Section: Section,
  Nav: Nav$1,
  Footer: Footer,
  A: A,
  Button: Button$1,
  P: P,
  Img: Img,
  H1: H1$1,
  H2: H2$1,
  H3: H3$1,
  H4: H4$1,
  H5: H5$1,
  H6: H6$1,
  Ul: Ul,
  Li: Li,
  Ol: Ol,
  Form: Form$1,
  Input: Input,
  Textarea: Textarea,
  Select: Select,
  Option: Option,
  Fieldset: Fieldset,
  Label: Label$1,
  Iframe: Iframe,
  // Svg,
  Small: Small,
  Table: Table$1,
  Thead: Thead,
  Tbody: Tbody,
  Tfoot: Tfoot,
  Col: Col,
  Tr: Tr,
  Td: Td,
  Th: Th
};

/**
 * Renders a group of Icons
 */
function AvatarList(_ref) {
  var className = _ref.className,
      children = _ref.children,
      stacked = _ref.stacked,
      rest = _objectWithoutProperties(_ref, ["className", "children", "stacked"]);

  var classes = classnames({
    "avatar-list": true,
    "avatar-list-stacked": stacked
  }, className);
  return /*#__PURE__*/createElement(El.Div, _extends({
    className: classes
  }, rest), children);
}

/**
 * Appended something to the inside of the badge
 */
function BadgeAddOn(_ref) {
  var children = _ref.children,
      className = _ref.className,
      icon = _ref.icon,
      color = _ref.color,
      as = _ref.as,
      RootComponent = _ref.RootComponent,
      rest = _objectWithoutProperties(_ref, ["children", "className", "icon", "color", "as", "RootComponent"]);

  var classes = classnames("badge-addon", _defineProperty({}, "badge-".concat(color), color), className);
  var childrenForAll = /*#__PURE__*/createElement(Fragment, null, icon && /*#__PURE__*/createElement(Icon, {
    name: icon
  }), children);
  var Component = RootComponent || as || "span";
  return /*#__PURE__*/createElement(Component, _extends({
    className: classes
  }, rest), childrenForAll);
}

var colors = {
  white: "#ffffff",
  blue: "#467fcf",
  "blue-darkest": "#0e1929",
  "blue-darker": "#1c3353",
  "blue-dark": "#3866a6",
  "blue-light": "#7ea5dd",
  "blue-lighter": "#c8d9f1",
  "blue-lightest": "#edf2fa",
  azure: "#45aaf2",
  "azure-darkest": "#0e2230",
  "azure-darker": "#1c4461",
  "azure-dark": "#3788c2",
  "azure-light": "#7dc4f6",
  "azure-lighter": "#c7e6fb",
  "azure-lightest": "#ecf7fe",
  indigo: "#6574cd",
  "indigo-darkest": "#141729",
  "indigo-darker": "#282e52",
  "indigo-dark": "#515da4",
  "indigo-light": "#939edc",
  "indigo-lighter": "#d1d5f0",
  "indigo-lightest": "#f0f1fa",
  purple: "#a55eea",
  "purple-darkest": "#21132f",
  "purple-darker": "#42265e",
  "purple-dark": "#844bbb",
  "purple-light": "#c08ef0",
  "purple-lighter": "#e4cff9",
  "purple-lightest": "#f6effd",
  pink: "#f66d9b",
  "pink-darkest": "#31161f",
  "pink-darker": "#622c3e",
  "pink-dark": "#c5577c",
  "pink-light": "#f999b9",
  "pink-lighter": "#fcd3e1",
  "pink-lightest": "#fef0f5",
  red: "#e74c3c",
  "red-darkest": "#2e0f0c",
  "red-darker": "#5c1e18",
  "red-dark": "#b93d30",
  "red-light": "#ee8277",
  "red-lighter": "#f8c9c5",
  "red-lightest": "#fdedec",
  orange: "#fd9644",
  "orange-darkest": "#331e0e",
  "orange-darker": "#653c1b",
  "orange-dark": "#ca7836",
  "orange-light": "#feb67c",
  "orange-lighter": "#fee0c7",
  "orange-lightest": "#fff5ec",
  yellow: "#f1c40f",
  "yellow-darkest": "#302703",
  "yellow-darker": "#604e06",
  "yellow-dark": "#c19d0c",
  "yellow-light": "#f5d657",
  "yellow-lighter": "#fbedb7",
  "yellow-lightest": "#fef9e7",
  lime: "#7bd235",
  "lime-darkest": "#192a0b",
  "lime-darker": "#315415",
  "lime-dark": "#62a82a",
  "lime-light": "#a3e072",
  "lime-lighter": "#d7f2c2",
  "lime-lightest": "#f2fbeb",
  green: "#5eba00",
  "green-darkest": "#132500",
  "green-darker": "#264a00",
  "green-dark": "#4b9500",
  "green-light": "#8ecf4d",
  "green-lighter": "#cfeab3",
  "green-lightest": "#eff8e6",
  teal: "#2bcbba",
  "teal-darkest": "#092925",
  "teal-darker": "#11514a",
  "teal-dark": "#22a295",
  "teal-light": "#6bdbcf",
  "teal-lighter": "#bfefea",
  "teal-lightest": "#eafaf8",
  cyan: "#17a2b8",
  "cyan-darkest": "#052025",
  "cyan-darker": "#09414a",
  "cyan-dark": "#128293",
  "cyan-light": "#5dbecd",
  "cyan-lighter": "#b9e3ea",
  "cyan-lightest": "#e8f6f8",
  gray: "#868e96",
  "gray-darkest": "#1b1c1e",
  "gray-darker": "#36393c",
  "gray-light": "#aab0b6",
  "gray-lighter": "#dbdde0",
  "gray-lightest": "#f3f4f5",
  "gray-dark": "#343a40",
  "gray-dark-darkest": "#0a0c0d",
  "gray-dark-darker": "#15171a",
  "gray-dark-dark": "#2a2e33",
  "gray-dark-light": "#717579",
  "gray-dark-lighter": "#c2c4c6",
  "gray-dark-lightest": "#ebebec"
};
var softColors = ["blue-lt", "azure-lt", "indigo-lt", "purple-lt", "pink-lt", "red-lt", "orange-lt", "yellow-lt", "lime-lt", "green-lt", "teal-lt", "cyan-lt", "gray-lt", "dark-lt"];

var Badge = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _cn;

  var children = _ref.children,
      className = _ref.className,
      rounded = _ref.rounded,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "primary" : _ref$color,
      avatar = _ref.avatar,
      remove = _ref.remove,
      addOn = _ref.addOn,
      addOnIcon = _ref.addOnIcon,
      addOnColor = _ref.addOnColor,
      onRemoveClick = _ref.onRemoveClick,
      onAddOnClick = _ref.onAddOnClick,
      RootComponent = _ref.RootComponent;
      _ref.link;
      var as = _ref.as,
      _ref$textColor = _ref.textColor,
      textColor = _ref$textColor === void 0 ? "white" : _ref$textColor,
      pill = _ref.pill,
      rest = _objectWithoutProperties(_ref, ["children", "className", "rounded", "color", "avatar", "remove", "addOn", "addOnIcon", "addOnColor", "onRemoveClick", "onAddOnClick", "RootComponent", "link", "as", "textColor", "pill"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isDeleted = _useState2[0],
      setIsDeleted = _useState2[1];

  var handleOnRemoveClick = function handleOnRemoveClick() {
    setIsDeleted(true);
  };

  var classes = classnames((_cn = {
    badge: true,
    expanded: true,
    "badge-pill": rounded || pill
  }, _defineProperty(_cn, "bg-".concat(color), color), _defineProperty(_cn, "text-".concat(textColor), softColors.includes(color) ? false : textColor), _cn), className);

  if (isDeleted) {
    return null;
  }

  var childrenForAll = /*#__PURE__*/React.createElement(React.Fragment, null, avatar && /*#__PURE__*/React.createElement("span", {
    className: "Badge-avatar avatar",
    style: {
      backgroundImage: "url(".concat(avatar, ")")
    }
  }), children, (addOn || addOnIcon) && /*#__PURE__*/React.createElement(BadgeAddOn, {
    icon: addOnIcon,
    color: addOnColor,
    onClick: onAddOnClick
  }, addOn), remove && onRemoveClick ? /*#__PURE__*/React.createElement(BadgeAddOn, {
    onClick: onRemoveClick,
    link: true,
    icon: "x"
  }) : remove && /*#__PURE__*/React.createElement(BadgeAddOn, {
    onClick: handleOnRemoveClick,
    link: true,
    icon: "x"
  }));
  var Component = RootComponent || as || "span";
  return /*#__PURE__*/React.createElement(Component, _extends({
    ref: ref,
    className: classes
  }, rest), childrenForAll);
});

/**
 * Adds a space between its child Badges
 */
var BadgeList = function BadgeList(_ref) {
  var children = _ref.children,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, ["children", "className"]);

  var classes = classnames("Badges", className);
  return /*#__PURE__*/React.createElement(El.Div, _extends({
    className: classes
  }, rest), children);
};

var CompoundBadge = Badge;
CompoundBadge.AddOn = BadgeAddOn;
CompoundBadge.List = BadgeList;

/**
 * Renders a single circular avatar
 */
function Avatar(_ref) {
  var _cn;

  var className = _ref.className,
      children = _ref.children,
      imageURL = _ref.imageURL,
      style = _ref.style,
      size = _ref.size,
      status = _ref.status,
      placeholder = _ref.placeholder,
      icon = _ref.icon,
      color = _ref.color,
      radius = _ref.radius,
      rest = _objectWithoutProperties(_ref, ["className", "children", "imageURL", "style", "size", "status", "placeholder", "icon", "color", "radius"]);

  var classes = classnames((_cn = {
    avatar: true
  }, _defineProperty(_cn, "avatar-".concat(size), size), _defineProperty(_cn, "bg-".concat(color), color), _defineProperty(_cn, "rounded-".concat(radius), radius), _cn), className);

  var _icon = icon || placeholder ? "user" : null;

  return /*#__PURE__*/createElement(El.Span, _extends({
    className: classes,
    style: imageURL ? Object.assign({
      backgroundImage: "url(".concat(imageURL, ")")
    }, style) : style
  }, rest), _icon && typeof icon === "string" ? /*#__PURE__*/createElement(Icon, {
    name: _icon
  }) : icon, status && /*#__PURE__*/createElement(CompoundBadge, {
    color: status
  }), children);
}
Avatar.List = AvatarList;

var Text = createTablerElement("p", {
  className: "text"
});

var TextSmall = function TextSmall(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/createElement(Text, _extends({
    as: "small"
  }, rest), children);
};

var CompoundText = Text;
CompoundText.Small = TextSmall;

/**
 * An individual Notification made up of an Avatar alongside some text and the time
 */
function Notification(_ref) {
  var avatarURL = _ref.avatarURL,
      message = _ref.message,
      time = _ref.time;
  return /*#__PURE__*/createElement(Fragment, null, avatarURL && /*#__PURE__*/createElement(Avatar, {
    className: "mr-3 align-self-center",
    imageURL: avatarURL
  }), /*#__PURE__*/createElement("div", null, message, time && /*#__PURE__*/createElement(CompoundText, {
    color: "gray",
    as: "small"
  }, time)));
}

var ManagerReferenceNodeContext = createContext();
var ManagerReferenceNodeSetterContext = createContext();
function Manager(_ref) {
  var children = _ref.children;

  var _React$useState = useState(null),
      referenceNode = _React$useState[0],
      setReferenceNode = _React$useState[1];

  useEffect(function () {
    return function () {
      setReferenceNode(null);
    };
  }, [setReferenceNode]);
  return /*#__PURE__*/createElement(ManagerReferenceNodeContext.Provider, {
    value: referenceNode
  }, /*#__PURE__*/createElement(ManagerReferenceNodeSetterContext.Provider, {
    value: setReferenceNode
  }, children));
}

/**
 * Takes an argument and if it's an array, returns the first item in the array,
 * otherwise returns the argument. Used for Preact compatibility.
 */
var unwrapArray = function unwrapArray(arg) {
  return Array.isArray(arg) ? arg[0] : arg;
};
/**
 * Takes a maybe-undefined function and arbitrary args and invokes the function
 * only if it is defined.
 */

var safeInvoke = function safeInvoke(fn) {
  if (typeof fn === 'function') {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return fn.apply(void 0, args);
  }
};
/**
 * Sets a ref using either a ref callback or a ref object
 */

var setRef = function setRef(ref, node) {
  // if its a function call it
  if (typeof ref === 'function') {
    return safeInvoke(ref, node);
  } // otherwise we should treat it as a ref object
  else if (ref != null) {
      ref.current = node;
    }
};
/**
 * Simple ponyfill for Object.fromEntries
 */

var fromEntries = function fromEntries(entries) {
  return entries.reduce(function (acc, _ref) {
    var key = _ref[0],
        value = _ref[1];
    acc[key] = value;
    return acc;
  }, {});
};
/**
 * Small wrapper around `useLayoutEffect` to get rid of the warning on SSR envs
 */

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && window.document && window.document.createElement ? useLayoutEffect : useEffect;

var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}

function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function effect$2(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


var applyStyles$1 = {
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: effect$2,
  requires: ['computeStyles']
};

function getBasePlacement(placement) {
  return placement.split('-')[0];
}

function getBoundingClientRect(element) {
  var rect = element.getBoundingClientRect();
  return {
    width: rect.width,
    height: rect.height,
    top: rect.top,
    right: rect.right,
    bottom: rect.bottom,
    left: rect.left,
    x: rect.left,
    y: rect.top
  };
}

// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}

function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}

function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback

  );
}

function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = navigator.userAgent.toLowerCase().includes('firefox');
  var currentNode = getParentNode(element);

  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].includes(css.willChange) || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}

function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}

var max = Math.max;
var min = Math.min;
var round = Math.round;

function within(min$1, value, max$1) {
  return max(min$1, min(value, max$1));
}

function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}

function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function effect$1(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (process.env.NODE_ENV !== "production") {
    if (!isHTMLElement(arrowElement)) {
      console.error(['Popper: "arrow" element must be an HTMLElement (not an SVGElement).', 'To use an SVG arrow, wrap it in an HTMLElement that will be used as', 'the arrow.'].join(' '));
    }
  }

  if (!contains(state.elements.popper, arrowElement)) {
    if (process.env.NODE_ENV !== "production") {
      console.error(['Popper: "arrow" modifier\'s `element` must be a child of the popper', 'element.'].join(' '));
    }

    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


var arrow$1 = {
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: effect$1,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
};

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref) {
  var x = _ref.x,
      y = _ref.y;
  var win = window;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(round(x * dpr) / dpr) || 0,
    y: round(round(y * dpr) / dpr) || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets;

  var _ref3 = roundOffsets === true ? roundOffsetsByDPR(offsets) : typeof roundOffsets === 'function' ? roundOffsets(offsets) : offsets,
      _ref3$x = _ref3.x,
      x = _ref3$x === void 0 ? 0 : _ref3$x,
      _ref3$y = _ref3.y,
      y = _ref3$y === void 0 ? 0 : _ref3$y;

  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);

      if (getComputedStyle(offsetParent).position !== 'static') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === top) {
      sideY = bottom; // $FlowFixMe[prop-missing]

      y -= offsetParent[heightProp] - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === left) {
      sideX = right; // $FlowFixMe[prop-missing]

      x -= offsetParent[widthProp] - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) < 2 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref4) {
  var state = _ref4.state,
      options = _ref4.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;

  if (process.env.NODE_ENV !== "production") {
    var transitionProperty = getComputedStyle(state.elements.popper).transitionProperty || '';

    if (adaptive && ['transform', 'top', 'right', 'bottom', 'left'].some(function (property) {
      return transitionProperty.indexOf(property) >= 0;
    })) {
      console.warn(['Popper: Detected CSS transitions on at least one of the following', 'CSS properties: "transform", "top", "right", "bottom", "left".', '\n\n', 'Disable the "computeStyles" modifier\'s `adaptive` option to allow', 'for smooth transitions, or remove these properties from the CSS', 'transition declaration on the popper element if only transitioning', 'opacity or background-color for example.', '\n\n', 'We recommend using the popper element as a wrapper around an inner', 'element that can have any CSS property transitioned for animations.'].join(' '));
    }
  }

  var commonStyles = {
    placement: getBasePlacement(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var computeStyles$1 = {
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
};

var passive = {
  passive: true
};

function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


var eventListeners = {
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
};

var hash$1 = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash$1[matched];
  });
}

var hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash[matched];
  });
}

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}

function getViewportRect(element) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0; // NB: This isn't supported on iOS <= 12. If the keyboard is open, the popper
  // can be obscured underneath it.
  // Also, `html.clientHeight` adds the bottom bar height in Safari iOS, even
  // if it isn't open, so if this isn't available, the popper will be detected
  // to overflow the bottom of the screen too early.

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height; // Uses Layout Viewport (like Chrome; Safari does not currently)
    // In Chrome, it returns a value very close to 0 (+/-) but contains rounding
    // errors due to floating point numbers, so we need to check precision.
    // Safari returns a number <= 0, usually < -1 when pinch-zoomed
    // Feature detection fails in mobile emulation mode in Chrome.
    // Math.abs(win.innerWidth / visualViewport.scale - visualViewport.width) <
    // 0.001
    // Fallback here: "Not Safari" userAgent

    if (!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}

// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle(body || html).direction === 'rtl') {
    x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent(getParentNode(node));
}

/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}

function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}

function getInnerBoundingClientRect(element) {
  var rect = getBoundingClientRect(element);
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element)) : isHTMLElement(clippingParent) ? getInnerBoundingClientRect(clippingParent) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

  if (!isElement(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}

function getVariation(placement) {
  return placement.split('-')[1];
}

function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;
    }
  }

  return offsets;
}

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var referenceElement = state.elements.reference;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary);
  var referenceClientRect = getBoundingClientRect(referenceElement);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}

function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;

    if (process.env.NODE_ENV !== "production") {
      console.error(['Popper: The `allowedAutoPlacements` option did not allow any', 'placements. Ensure the `placement` option matches the variation', 'of the allowed placements.', 'For example, "auto" cannot be used to allow "bottom-start".', 'Use "auto-start" instead.'].join(' '));
    }
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement(placement);

    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


var flip$1 = {
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
};

function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


var hide$1 = {
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
};

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var offset$1 = {
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
};

function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var popperOffsets$1 = {
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
};

function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis || checkAltAxis) {
    var mainSide = mainAxis === 'y' ? top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min$1 = popperOffsets[mainAxis] + overflow[mainSide];
    var max$1 = popperOffsets[mainAxis] - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - tetherOffsetValue : minLen - arrowLen - arrowPaddingMin - tetherOffsetValue;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + tetherOffsetValue : maxLen + arrowLen + arrowPaddingMax + tetherOffsetValue;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = state.modifiersData.offset ? state.modifiersData.offset[state.placement][mainAxis] : 0;
    var tetherMin = popperOffsets[mainAxis] + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = popperOffsets[mainAxis] + maxOffset - offsetModifierValue;

    if (checkMainAxis) {
      var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset, tether ? max(max$1, tetherMax) : max$1);
      popperOffsets[mainAxis] = preventedOffset;
      data[mainAxis] = preventedOffset - offset;
    }

    if (checkAltAxis) {
      var _mainSide = mainAxis === 'x' ? top : left;

      var _altSide = mainAxis === 'x' ? bottom : right;

      var _offset = popperOffsets[altAxis];

      var _min = _offset + overflow[_mainSide];

      var _max = _offset - overflow[_altSide];

      var _preventedOffset = within(tether ? min(_min, tetherMin) : _min, _offset, tether ? max(_max, tetherMax) : _max);

      popperOffsets[altAxis] = _preventedOffset;
      data[altAxis] = _preventedOffset - _offset;
    }
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var preventOverflow$1 = {
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
};

function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}

// Composite means it takes into account transforms as well as layout.

function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement);
  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}

function format(str) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return [].concat(args).reduce(function (p, c) {
    return p.replace(/%s/, c);
  }, str);
}

var INVALID_MODIFIER_ERROR = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s';
var MISSING_DEPENDENCY_ERROR = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available';
var VALID_PROPERTIES = ['name', 'enabled', 'phase', 'fn', 'effect', 'requires', 'options'];
function validateModifiers(modifiers) {
  modifiers.forEach(function (modifier) {
    Object.keys(modifier).forEach(function (key) {
      switch (key) {
        case 'name':
          if (typeof modifier.name !== 'string') {
            console.error(format(INVALID_MODIFIER_ERROR, String(modifier.name), '"name"', '"string"', "\"" + String(modifier.name) + "\""));
          }

          break;

        case 'enabled':
          if (typeof modifier.enabled !== 'boolean') {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"enabled"', '"boolean"', "\"" + String(modifier.enabled) + "\""));
          }

        case 'phase':
          if (modifierPhases.indexOf(modifier.phase) < 0) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"phase"', "either " + modifierPhases.join(', '), "\"" + String(modifier.phase) + "\""));
          }

          break;

        case 'fn':
          if (typeof modifier.fn !== 'function') {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"fn"', '"function"', "\"" + String(modifier.fn) + "\""));
          }

          break;

        case 'effect':
          if (typeof modifier.effect !== 'function') {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"effect"', '"function"', "\"" + String(modifier.fn) + "\""));
          }

          break;

        case 'requires':
          if (!Array.isArray(modifier.requires)) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requires"', '"array"', "\"" + String(modifier.requires) + "\""));
          }

          break;

        case 'requiresIfExists':
          if (!Array.isArray(modifier.requiresIfExists)) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requiresIfExists"', '"array"', "\"" + String(modifier.requiresIfExists) + "\""));
          }

          break;

        case 'options':
        case 'data':
          break;

        default:
          console.error("PopperJS: an invalid property has been provided to the \"" + modifier.name + "\" modifier, valid properties are " + VALID_PROPERTIES.map(function (s) {
            return "\"" + s + "\"";
          }).join(', ') + "; but \"" + key + "\" was provided.");
      }

      modifier.requires && modifier.requires.forEach(function (requirement) {
        if (modifiers.find(function (mod) {
          return mod.name === requirement;
        }) == null) {
          console.error(format(MISSING_DEPENDENCY_ERROR, String(modifier.name), requirement, requirement));
        }
      });
    });
  });
}

function uniqueBy(arr, fn) {
  var identifiers = new Set();
  return arr.filter(function (item) {
    var identifier = fn(item);

    if (!identifiers.has(identifier)) {
      identifiers.add(identifier);
      return true;
    }
  });
}

function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}

var INVALID_ELEMENT_ERROR = 'Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.';
var INFINITE_LOOP_ERROR = 'Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.';
var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(options) {
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        }); // Validate the provided modifiers so that the consumer will get warned
        // if one of the modifiers is invalid for any reason

        if (process.env.NODE_ENV !== "production") {
          var modifiers = uniqueBy([].concat(orderedModifiers, state.options.modifiers), function (_ref) {
            var name = _ref.name;
            return name;
          });
          validateModifiers(modifiers);

          if (getBasePlacement(state.options.placement) === auto) {
            var flipModifier = state.orderedModifiers.find(function (_ref2) {
              var name = _ref2.name;
              return name === 'flip';
            });

            if (!flipModifier) {
              console.error(['Popper: "auto" placements require the "flip" modifier be', 'present and enabled to work.'].join(' '));
            }
          }

          var _getComputedStyle = getComputedStyle(popper),
              marginTop = _getComputedStyle.marginTop,
              marginRight = _getComputedStyle.marginRight,
              marginBottom = _getComputedStyle.marginBottom,
              marginLeft = _getComputedStyle.marginLeft; // We no longer take into account `margins` on the popper, and it can
          // cause bugs with positioning, so we'll warn the consumer


          if ([marginTop, marginRight, marginBottom, marginLeft].some(function (margin) {
            return parseFloat(margin);
          })) {
            console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', 'between the popper and its reference element or boundary.', 'To replicate margin, use the `offset` modifier, as well as', 'the `padding` option in the `preventOverflow` and `flip`', 'modifiers.'].join(' '));
          }
        }

        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          if (process.env.NODE_ENV !== "production") {
            console.error(INVALID_ELEMENT_ERROR);
          }

          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        var __debug_loops__ = 0;

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (process.env.NODE_ENV !== "production") {
            __debug_loops__ += 1;

            if (__debug_loops__ > 100) {
              console.error(INFINITE_LOOP_ERROR);
              break;
            }
          }

          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      if (process.env.NODE_ENV !== "production") {
        console.error(INVALID_ELEMENT_ERROR);
      }

      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref3) {
        var name = _ref3.name,
            _ref3$options = _ref3.options,
            options = _ref3$options === void 0 ? {} : _ref3$options,
            effect = _ref3.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}

/*:: export type * from './types'; */

/*;; export * from './types'; */

var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
var createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */
var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.
    var it;
    if (hasMap && (a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!equal(i.value[1], b.get(i.value[0]))) return false;
      return true;
    }

    if (hasSet && (a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      return true;
    }
    // END: Modifications

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    // END: fast-deep-equal

    // START: react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element) return false;

    // custom handling for React/Preact
    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements

        continue;
      }

      // all other properties should be traversed as usual
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    // END: react-fast-compare

    // START: fast-deep-equal
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

var reactFastCompare = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (((error.message || '').match(/stack|recursion/i))) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};

var EMPTY_MODIFIERS$1 = [];
var usePopper = function usePopper(referenceElement, popperElement, options) {
  if (options === void 0) {
    options = {};
  }

  var prevOptions = useRef(null);
  var optionsWithDefaults = {
    onFirstUpdate: options.onFirstUpdate,
    placement: options.placement || 'bottom',
    strategy: options.strategy || 'absolute',
    modifiers: options.modifiers || EMPTY_MODIFIERS$1
  };

  var _React$useState = useState({
    styles: {
      popper: {
        position: optionsWithDefaults.strategy,
        left: '0',
        top: '0'
      }
    },
    attributes: {}
  }),
      state = _React$useState[0],
      setState = _React$useState[1];

  var updateStateModifier = useMemo(function () {
    return {
      name: 'updateState',
      enabled: true,
      phase: 'write',
      fn: function fn(_ref) {
        var state = _ref.state;
        var elements = Object.keys(state.elements);
        setState({
          styles: fromEntries(elements.map(function (element) {
            return [element, state.styles[element] || {}];
          })),
          attributes: fromEntries(elements.map(function (element) {
            return [element, state.attributes[element]];
          }))
        });
      },
      requires: ['computeStyles']
    };
  }, []);
  var popperOptions = useMemo(function () {
    var newOptions = {
      onFirstUpdate: optionsWithDefaults.onFirstUpdate,
      placement: optionsWithDefaults.placement,
      strategy: optionsWithDefaults.strategy,
      modifiers: [].concat(optionsWithDefaults.modifiers, [updateStateModifier, {
        name: 'applyStyles',
        enabled: false
      }])
    };

    if (reactFastCompare(prevOptions.current, newOptions)) {
      return prevOptions.current || newOptions;
    } else {
      prevOptions.current = newOptions;
      return newOptions;
    }
  }, [optionsWithDefaults.onFirstUpdate, optionsWithDefaults.placement, optionsWithDefaults.strategy, optionsWithDefaults.modifiers, updateStateModifier]);
  var popperInstanceRef = useRef();
  useIsomorphicLayoutEffect(function () {
    if (popperInstanceRef.current) {
      popperInstanceRef.current.setOptions(popperOptions);
    }
  }, [popperOptions]);
  useIsomorphicLayoutEffect(function () {
    if (referenceElement == null || popperElement == null) {
      return;
    }

    var createPopper$1 = options.createPopper || createPopper;
    var popperInstance = createPopper$1(referenceElement, popperElement, popperOptions);
    popperInstanceRef.current = popperInstance;
    return function () {
      popperInstance.destroy();
      popperInstanceRef.current = null;
    };
  }, [referenceElement, popperElement, options.createPopper]);
  return {
    state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
    styles: state.styles,
    attributes: state.attributes,
    update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
    forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
  };
};

var NOOP = function NOOP() {
  return void 0;
};

var NOOP_PROMISE = function NOOP_PROMISE() {
  return Promise.resolve(null);
};

var EMPTY_MODIFIERS = [];
function Popper(_ref) {
  var _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'bottom' : _ref$placement,
      _ref$strategy = _ref.strategy,
      strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy,
      _ref$modifiers = _ref.modifiers,
      modifiers = _ref$modifiers === void 0 ? EMPTY_MODIFIERS : _ref$modifiers,
      referenceElement = _ref.referenceElement,
      onFirstUpdate = _ref.onFirstUpdate,
      innerRef = _ref.innerRef,
      children = _ref.children;
  var referenceNode = useContext(ManagerReferenceNodeContext);

  var _React$useState = useState(null),
      popperElement = _React$useState[0],
      setPopperElement = _React$useState[1];

  var _React$useState2 = useState(null),
      arrowElement = _React$useState2[0],
      setArrowElement = _React$useState2[1];

  useEffect(function () {
    setRef(innerRef, popperElement);
  }, [innerRef, popperElement]);
  var options = useMemo(function () {
    return {
      placement: placement,
      strategy: strategy,
      onFirstUpdate: onFirstUpdate,
      modifiers: [].concat(modifiers, [{
        name: 'arrow',
        enabled: arrowElement != null,
        options: {
          element: arrowElement
        }
      }])
    };
  }, [placement, strategy, onFirstUpdate, modifiers, arrowElement]);

  var _usePopper = usePopper(referenceElement || referenceNode, popperElement, options),
      state = _usePopper.state,
      styles = _usePopper.styles,
      forceUpdate = _usePopper.forceUpdate,
      update = _usePopper.update;

  var childrenProps = useMemo(function () {
    return {
      ref: setPopperElement,
      style: styles.popper,
      placement: state ? state.placement : placement,
      hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
      isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
      arrowProps: {
        style: styles.arrow,
        ref: setArrowElement
      },
      forceUpdate: forceUpdate || NOOP,
      update: update || NOOP_PROMISE
    };
  }, [setPopperElement, setArrowElement, placement, state, styles, update, forceUpdate]);
  return unwrapArray(children)(childrenProps);
}

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = process.env.NODE_ENV !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

var warning_1 = warning;

function Reference(_ref) {
  var children = _ref.children,
      innerRef = _ref.innerRef;
  var setReferenceNode = useContext(ManagerReferenceNodeSetterContext);
  var refHandler = useCallback(function (node) {
    setRef(innerRef, node);
    safeInvoke(setReferenceNode, node);
  }, [innerRef, setReferenceNode]); // ran on unmount

  useEffect(function () {
    return function () {
      return setRef(innerRef, null);
    };
  });
  useEffect(function () {
    warning_1(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
  }, [setReferenceNode]);
  return unwrapArray(children)({
    ref: refHandler
  });
}

var DropdownContext = /*#__PURE__*/React.createContext([false, function () {
  return null;
}]);

/**
 * Provides the trigger element for a Dropdown
 */
function DropdownTrigger(_ref) {
  var className = _ref.className,
      _ref$toggle = _ref.toggle,
      toggle = _ref$toggle === void 0 ? true : _ref$toggle,
      value = _ref.value,
      children = _ref.children,
      icon = _ref.icon,
      isNavLink = _ref.isNavLink,
      isOption = _ref.isOption,
      as = _ref.as,
      rest = _objectWithoutProperties(_ref, ["className", "toggle", "value", "children", "icon", "isNavLink", "isOption", "as"]);

  var _React$useContext = useContext(DropdownContext),
      _React$useContext2 = _slicedToArray(_React$useContext, 2),
      isOpen = _React$useContext2[0],
      setIsOpen = _React$useContext2[1];

  var Component = as || El.Button;
  var classes = classnames({
    "dropdown-toggle": toggle,
    "nav-link": isNavLink,
    "btn-option": isOption
  }, className);
  var childrenFragment = /*#__PURE__*/createElement(Fragment, null, icon && /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(Icon, {
    name: icon
  }), " "), value, children);
  return /*#__PURE__*/createElement(Reference, null, function (_ref2) {
    var ref = _ref2.ref;
    return /*#__PURE__*/createElement(Component, _extends({
      className: classes,
      onClick: function onClick() {
        setIsOpen(!isOpen);
      },
      ref: ref
    }, rest), childrenFragment);
  });
}

/**
 * The wrapper element for a Dropdowns Items
 */
function DropdownMenu(_ref) {
  var _cn;

  var className = _ref.className,
      children = _ref.children,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? "bottom" : _ref$position,
      arrow = _ref.arrow,
      _ref$arrowPosition = _ref.arrowPosition,
      arrowPosition = _ref$arrowPosition === void 0 ? "left" : _ref$arrowPosition,
      _style = _ref.style,
      show = _ref.show,
      rest = _objectWithoutProperties(_ref, ["className", "children", "position", "arrow", "arrowPosition", "style", "show"]);

  var _React$useContext = React.useContext(DropdownContext),
      _React$useContext2 = _slicedToArray(_React$useContext, 1),
      isOpen = _React$useContext2[0];

  var _isOpen = show || isOpen;

  var classes = classnames((_cn = {
    "dropdown-menu": true
  }, _defineProperty(_cn, "dropdown-menu-".concat(arrowPosition), arrowPosition), _defineProperty(_cn, "dropdown-menu-arrow", arrow), _defineProperty(_cn, "show", _isOpen), _cn), className);
  return /*#__PURE__*/React.createElement(Popper, {
    placement: position
  }, function (_ref2) {
    var ref = _ref2.ref,
        style = _ref2.style,
        placement = _ref2.placement;
    return _isOpen && /*#__PURE__*/React.createElement(El.Div, _extends({
      className: classes,
      "data-placement": placement,
      style: _objectSpread2(_objectSpread2({}, _style), style),
      ref: ref
    }, rest), children);
  });
}

/**
 * An individual item that should be contained within a Dropdown.Menu
 */
function DropdownItem(_ref) {
  var className = _ref.className,
      icon = _ref.icon,
      value = _ref.value,
      children = _ref.children,
      badge = _ref.badge,
      badgeType = _ref.badgeType,
      as = _ref.as,
      RootComponent = _ref.RootComponent,
      rest = _objectWithoutProperties(_ref, ["className", "icon", "value", "children", "badge", "badgeType", "as", "RootComponent"]);

  var classes = classnames({
    "dropdown-item": true
  }, className);
  var Component = RootComponent || as || El.A;
  return /*#__PURE__*/createElement(Component, _extends({
    className: classes
  }, rest), badge && /*#__PURE__*/createElement("span", {
    className: "float-right"
  }, /*#__PURE__*/createElement(CompoundBadge, {
    color: badgeType
  }, badge)), icon && /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(Icon, {
    name: icon,
    className: "dropdown-icon"
  }), " "), value, children);
}

/**
 * Used to seperate items within a Dropdown with a horizontal line
 */
function DropdownItemDivider(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/React.createElement(El.Div, _extends({
    className: "dropdown-divider"
  }, rest), children);
}

var DropdownProvider = function DropdownProvider(_ref) {
  var children = _ref.children;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var value = [isOpen, setIsOpen];
  return /*#__PURE__*/React.createElement(DropdownContext.Provider, {
    value: value
  }, children);
};

var withDropdownProvider = function withDropdownProvider(Component) {
  return /*#__PURE__*/forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(DropdownProvider, null, /*#__PURE__*/React.createElement(Component, _extends({
      ref: ref
    }, props)));
  });
};

var Dropdown = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var className = _ref.className,
      children = _ref.children,
      desktopOnly = _ref.desktopOnly,
      isOption = _ref.isOption,
      items = _ref.items,
      trigger = _ref.trigger,
      icon = _ref.icon,
      triggerContent = _ref.triggerContent,
      triggerAs = _ref.triggerAs,
      isNavLink = _ref.isNavLink,
      triggerClassName = _ref.triggerClassName,
      color = _ref.color,
      toggle = _ref.toggle,
      itemsObject = _ref.itemsObject,
      itemsRootComponent = _ref.itemsRootComponent,
      position = _ref.position,
      arrow = _ref.arrow,
      arrowPosition = _ref.arrowPosition,
      dropdownMenuClassName = _ref.dropdownMenuClassName;
      _ref.style;
      var triggerProps = _ref.triggerProps,
      rest = _objectWithoutProperties(_ref, ["className", "children", "desktopOnly", "isOption", "items", "trigger", "icon", "triggerContent", "triggerAs", "isNavLink", "triggerClassName", "color", "toggle", "itemsObject", "itemsRootComponent", "position", "arrow", "arrowPosition", "dropdownMenuClassName", "style", "triggerProps"]);

  var _useContext = useContext(DropdownContext),
      _useContext2 = _slicedToArray(_useContext, 2),
      isOpen = _useContext2[0],
      setIsOpen = _useContext2[1];

  var _handleItemClick = function _handleItemClick(e, callback) {
    setIsOpen(false);

    if (callback) {
      callback(e);
    }
  };

  var classes = classnames({
    dropdown: true,
    "d-none": desktopOnly,
    "d-md-flex": desktopOnly,
    "card-options-dropdown": isOption,
    show: isOpen
  }, className);

  var _trigger = trigger || function () {
    if (icon || triggerContent || toggle) {
      return /*#__PURE__*/React.createElement(DropdownTrigger, _extends({
        isNavLink: isNavLink,
        icon: icon,
        className: triggerClassName,
        isOption: isOption,
        color: color,
        toggle: toggle,
        as: triggerAs
      }, triggerProps), triggerContent);
    }

    return null;
  }();

  var _items = items || function () {
    if (itemsObject) {
      return itemsObject.map(function (_ref2, i) {
        var as = _ref2.as,
            _onClick = _ref2.onClick,
            isDivider = _ref2.isDivider,
            dividerProps = _ref2.dividerProps,
            item = _objectWithoutProperties(_ref2, ["as", "onClick", "isDivider", "dividerProps"]);

        return isDivider ? /*#__PURE__*/React.createElement(DropdownItemDivider, _extends({
          key: i
        }, dividerProps)) : /*#__PURE__*/React.createElement(DropdownItem, _extends({
          key: i,
          as: as || itemsRootComponent || "a",
          onClick: function onClick(e) {
            return _handleItemClick(e, _onClick);
          }
        }, item));
      });
    }

    return null;
  }();

  var menu = function () {
    if (_items) {
      return /*#__PURE__*/React.createElement(DropdownMenu, {
        position: position,
        arrow: arrow,
        arrowPosition: arrowPosition,
        className: dropdownMenuClassName,
        show: isOpen
      }, _items);
    }

    return null;
  }(); // const _ref = useClickOutside(() => setIsOpen(false), ref);


  return /*#__PURE__*/React.createElement(Manager, null, /*#__PURE__*/React.createElement(El.Div, _extends({
    className: classes,
    ref: ref
  }, rest), _trigger, menu || children));
});
var Dropdown$1 = withDropdownProvider(Dropdown);

var CompoundDropdown = Dropdown$1;
CompoundDropdown.displayName = "Dropdown";
CompoundDropdown.Trigger = DropdownTrigger;
CompoundDropdown.Menu = DropdownMenu;
CompoundDropdown.Item = DropdownItem;
CompoundDropdown.ItemDivider = DropdownItemDivider;

var NavLinkTitle = createTablerElement("span", {
  className: "nav-link-title",
  displayName: "NavLinkTitle"
});

var NavLinkIcon = createTablerElement("span", {
  className: "nav-link-icon",
  displayName: "NavLinkIcon",
  defaultProps: {
    d: {
      md: "none",
      lg: "inline-block"
    }
  }
});

var NavLink = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      className = _ref.className,
      RootComponent = _ref.RootComponent,
      as = _ref.as,
      icon = _ref.icon,
      active = _ref.active,
      disabled = _ref.disabled;
      _ref.hasSubNav;
      var rootRef = _ref.rootRef,
      title = _ref.title,
      collapsed = _ref.collapsed,
      isToggle = _ref.isToggle,
      props = _objectWithoutProperties(_ref, ["children", "className", "RootComponent", "as", "icon", "active", "disabled", "hasSubNav", "rootRef", "title", "collapsed", "isToggle"]);

  var classes = classnames({
    "nav-link": true,
    active: active,
    disabled: disabled,
    collapsed: collapsed,
    collapse: isToggle && collapsed,
    show: isToggle && collapsed
  }, className);
  var Component = RootComponent || as || El.A;
  return /*#__PURE__*/React.createElement(Component, _extends({
    className: classes,
    ref: rootRef || ref,
    "data-toggle": isToggle ? "collapse" : undefined,
    "aria-expanded": !collapsed
  }, props), icon && /*#__PURE__*/React.createElement(NavLinkIcon, null, icon), title && /*#__PURE__*/React.createElement(NavLinkTitle, null, title), children);
});

function NavSubNav(_ref) {
  var as = _ref.as,
      className = _ref.className,
      children = _ref.children,
      _ref$collapsed = _ref.collapsed,
      collapsed = _ref$collapsed === void 0 ? true : _ref$collapsed,
      _ref$show = _ref.show,
      show = _ref$show === void 0 ? false : _ref$show,
      rest = _objectWithoutProperties(_ref, ["as", "className", "children", "collapsed", "show"]);

  var classes = classnames({
    "navbar-subnav": true,
    collapse: true,
    collapsed: collapsed,
    show: show
  }, className);
  var Component = as || El.Div;
  return /*#__PURE__*/React.createElement(Component, _extends({
    className: classes
  }, rest), /*#__PURE__*/React.createElement("ul", {
    className: "nav"
  }, children));
}

var NavSubNavContext = /*#__PURE__*/React.createContext(false);

var NavItem = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      LinkComponent = _ref.LinkComponent,
      value = _ref.value,
      className = _ref.className,
      href = _ref.href,
      to = _ref.to,
      type = _ref.type,
      icon = _ref.icon,
      forcedHasSubNav = _ref.hasSubNav,
      active = _ref.active,
      subItems = _ref.subItems,
      subItemsObjects = _ref.subItemsObjects;
      _ref.useExact;
      _ref.position;
      var onClick = _ref.onClick,
      as = _ref.as,
      linkAs = _ref.linkAs,
      linkProps = _ref.linkProps,
      _ref$link = _ref.link,
      link = _ref$link === void 0 ? true : _ref$link,
      subNav = _ref.subNav,
      props = _objectWithoutProperties(_ref, ["children", "LinkComponent", "value", "className", "href", "to", "type", "icon", "hasSubNav", "active", "subItems", "subItemsObjects", "useExact", "position", "onClick", "as", "linkAs", "linkProps", "link", "subNav"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1]; // context is used so that we only apply on click outside handler to the top level nav item


  var topLevelSubNavContext = useContext(NavSubNavContext);
  var hasSubNav = forcedHasSubNav || !!subItems || !!subItemsObjects;

  var _isTopLevelSubNav = (subNav || hasSubNav) && topLevelSubNavContext === false;

  var Component = type || as || El.Li;

  var _linkAs = LinkComponent || linkAs;

  var _linkProps = _objectSpread2(_objectSpread2({}, linkProps), {}, {
    href: href,
    to: to,
    icon: icon,
    active: active
  });

  var _handleOnClick = function _handleOnClick() {
    if (subNav || hasSubNav) {
      setIsOpen(!isOpen);
    }

    if (onClick) onClick();
  };

  var navLink = link ? /*#__PURE__*/React.createElement(NavLink, _extends({
    as: _linkAs,
    collapsed: (subNav || hasSubNav) && isOpen === false,
    onClick: _handleOnClick,
    isToggle: subNav || hasSubNav
  }, _linkProps), value || children) : value || !hasSubNav && children;
  var wrapperClasses = classnames({
    "nav-item": true,
    show: isOpen
  }, className); // const _ref = useClickOutside(() => {
  //   if (_isTopLevelSubNav) {
  //     setIsOpen(false);
  //   }
  // }, ref);

  var _navItem = /*#__PURE__*/React.createElement(Component, _extends({
    className: wrapperClasses,
    ref: ref
  }, props), /*#__PURE__*/React.createElement(React.Fragment, null, navLink, subNav && isOpen && /*#__PURE__*/React.createElement(NavSubNav, {
    show: isOpen
  }, subNav), hasSubNav && isOpen && /*#__PURE__*/React.createElement(NavSubNav, {
    show: isOpen
  }, subItems || subItemsObjects && subItemsObjects.map(function (a, i) {
    return /*#__PURE__*/React.createElement(NavItem, _extends({
      key: i
    }, a));
  }) || children)));

  if (_isTopLevelSubNav) {
    return /*#__PURE__*/React.createElement(NavSubNavContext.Provider, {
      value: true
    }, _navItem);
  }

  return _navItem;
});

var Container = createTablerElement("div", {
  className: "container",
  classNames: function classNames(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? "xl" : _ref$size;
    return _defineProperty({}, "container-".concat(size), size);
  },
  modifyProps: function modifyProps(_ref3) {
    _ref3.size;
        var props = _objectWithoutProperties(_ref3, ["size"]);

    return props;
  }
});

var NavbarBrand = createTablerElement("h2", {
  displayName: "NavbarBrand",
  className: "navbar-brand",
  provideClassNames: {
    Image: "navbar-brand-image"
  }
});

var provideClassNames$1 = {
  Collapse: "navbar-collapse"
};
var Navbar = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      className = _ref.className,
      isDark = _ref.isDark,
      isSide = _ref.isSide,
      _ref$side = _ref.side,
      side = _ref$side === void 0 ? "left" : _ref$side,
      _ref$expand = _ref.expand,
      expand = _ref$expand === void 0 ? "md" : _ref$expand,
      brand = _ref.brand,
      as = _ref.as,
      rest = _objectWithoutProperties(_ref, ["children", "className", "isDark", "isSide", "side", "expand", "brand", "as"]);

  var classes = classnames("navbar", "navbar-".concat(isDark ? "dark" : "light"), _defineProperty({
    "navbar-side": isSide,
    "navbar-right": side === "right"
  }, "navbar-expand-".concat(expand), expand), className);
  var Component = as || El.Header;
  return /*#__PURE__*/createElement(ClassNamesProvider, {
    value: provideClassNames$1
  }, /*#__PURE__*/createElement(Component, _extends({
    ref: ref,
    className: classes
  }, rest), /*#__PURE__*/createElement(Container, {
    size: "xl"
  }, brand && /*#__PURE__*/createElement(NavbarBrand, null, brand), children)));
});

/**
 * A header
 * By default renders a div not a <hX> tag and has no additional spacing classes applied
 */
function Header(_ref) {
  var as = _ref.as,
      RootComponent = _ref.RootComponent,
      className = _ref.className,
      children = _ref.children,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 1 : _ref$size,
      props = _objectWithoutProperties(_ref, ["as", "RootComponent", "className", "children", "size"]);

  var classes = classnames("h".concat(size), className);
  var Component = RootComponent || as || El.Div;
  return /*#__PURE__*/React.createElement(Component, _extends({
    className: classes
  }, props), children);
}

/**
 * A Header component rendered as a h6 HTML element with a margin below
 */
function H6(_ref) {
  var children = _ref.children,
      as = _ref.as,
      _ref$mt = _ref.mt,
      mt = _ref$mt === void 0 ? 0 : _ref$mt,
      _ref$mb = _ref.mb,
      mb = _ref$mb === void 0 ? 4 : _ref$mb,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 6 : _ref$size,
      props = _objectWithoutProperties(_ref, ["children", "as", "mt", "mb", "size"]);

  return /*#__PURE__*/React.createElement(Header, _extends({
    as: as || "h6",
    size: size,
    mt: mt,
    mb: mb
  }, props), children);
}

function NavbarHeading(_ref) {
  var children = _ref.children,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, ["children", "className"]);

  var classes = classnames("navbar-heading", {}, className);
  return /*#__PURE__*/createElement(H6, _extends({
    className: classes
  }, rest), children);
}

var NavbarNav = createTablerElement("ul", {
  displayName: "NavbarNav",
  className: "navbar-nav flex-row",
  provideClassNames: {
    Dropdown: "nav-item",
    DropdownToggle: "nav-link",
    Link: "nav-link",
    Collapse: "navbar-collapse"
  }
});

var NavbarTogglerContext = /*#__PURE__*/createContext(["open", function () {}]);

var useToggle = function useToggle() {
  var _useState = useState(function () {
    return "open";
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var handleToggle = useCallback(function () {
    setState(function (s) {
      return s === "open" ? "collapsed" : "open";
    });
  }, []);
  return [state, handleToggle];
};

var useNavbarToggler = function useNavbarToggler() {
  var fallbackState = useToggle();
  var context = useContext(NavbarTogglerContext);
  return context || fallbackState;
};
var NavbarTogglerProvider = function NavbarTogglerProvider(_ref) {
  var children = _ref.children;
  var state = useToggle();
  return /*#__PURE__*/React.createElement(NavbarTogglerContext.Provider, {
    value: state
  }, children);
};

var NavbarToggler = function NavbarToggler(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["children"]);

  var _useNavbarToggler = useNavbarToggler(),
      _useNavbarToggler2 = _slicedToArray(_useNavbarToggler, 2),
      state = _useNavbarToggler2[0],
      toggleState = _useNavbarToggler2[1];

  return /*#__PURE__*/React.createElement(El.Button, _extends({
    onClick: toggleState,
    classNames: ["navbar-toggler", state === "collapsed" && "collapsed"]
  }, rest), children);
};

var NavbarTogglerIcon = createTablerElement("span", {
  className: "navbar-toggler-icon",
  displayName: "NavbarTogglerIcon"
});

var CompoundNavbar = Navbar;
CompoundNavbar.displayName = "Navbar";
CompoundNavbar.Nav = NavbarNav;
CompoundNavbar.Brand = NavbarBrand;
CompoundNavbar.Heading = NavbarHeading;
CompoundNavbar.Toggler = NavbarToggler;
CompoundNavbar.TogglerIcon = NavbarTogglerIcon; // export * from "./NavItem";

var Nav = function Nav(_ref) {
  var as = _ref.as,
      className = _ref.className,
      children = _ref.children,
      items = _ref.items,
      itemsObjects = _ref.itemsObjects,
      isMenu = _ref.isMenu,
      vertical = _ref.vertical,
      variant = _ref.variant,
      fill = _ref.fill,
      collapse = _ref.collapse,
      show = _ref.show,
      rest = _objectWithoutProperties(_ref, ["as", "className", "children", "items", "itemsObjects", "isMenu", "vertical", "variant", "fill", "collapse", "show"]);

  var classes = classnames("nav", {
    "navbar-menu": isMenu
  }, vertical && "nav-vertical", variant && "nav-".concat(variant), variant === "tabs-alt" && "nav-tabs-alt", collapse && "collapse", show && "show", fill && "nav-fill", className);

  var _items = items || itemsObjects && itemsObjects.map(function (_ref2, i) {
    _ref2.active;
        var restItemProps = _objectWithoutProperties(_ref2, ["active"]);

    return /*#__PURE__*/React.createElement(NavItem, _extends({
      key: i,
      hasSubNav: (restItemProps.subItems || restItemProps.subItemsObjects) === true
    }, restItemProps));
  });

  var _children = _items ? /*#__PURE__*/React.createElement(NavbarNav, null, _items) : children;

  var Component = as || El.Ul;
  return /*#__PURE__*/React.createElement(Component, _extends({
    className: classes
  }, rest), _children);
};

function NavSubItem(_ref) {
  var children = _ref.children,
      as = _ref.as,
      LinkComponent = _ref.LinkComponent,
      value = _ref.value,
      props = _objectWithoutProperties(_ref, ["children", "as", "LinkComponent", "value"]);

  var _as = LinkComponent || as;

  var _children = value || children;

  return /*#__PURE__*/createElement(CompoundDropdown.Item, _extends({
    RootComponent: _as
  }, props), _children);
}

function NavSubmenu(_ref) {
  var as = _ref.as,
      className = _ref.className,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["as", "className", "children"]);

  var classes = classnames({
    nav: true,
    "nav-submenu": true
  }, className);
  var Component = as || El.Div;
  return /*#__PURE__*/createElement(Component, _extends({
    className: classes
  }, rest), children);
}

function NavSubmenuItem(_ref) {
  var className = _ref.className,
      as = _ref.as,
      RootComponent = _ref.RootComponent,
      icon = _ref.icon,
      children = _ref.children,
      _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      rest = _objectWithoutProperties(_ref, ["className", "as", "RootComponent", "icon", "children", "active"]);

  var classes = classnames({
    "nav-item": true,
    active: active
  }, className);
  var Component = RootComponent || as || El.A;
  return /*#__PURE__*/createElement(Component, _extends({
    className: classes
  }, rest), icon && /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(Icon, {
    name: icon
  })), children);
}

var NavLinkToggle = createTablerElement("span", {
  className: "nav-link-toggle",
  displayName: "NavLinkToggle"
});

var CompoundNav = Nav;
CompoundNav.displayName = "Nav";
CompoundNav.Item = NavItem;
CompoundNav.SubItem = NavSubItem;
CompoundNav.Link = NavLink;
CompoundNav.LinkTitle = NavLinkTitle;
CompoundNav.LinkToggle = NavLinkToggle;
CompoundNav.LinkIcon = NavLinkIcon;
CompoundNav.Submenu = NavSubmenu;
CompoundNav.SubmenuItem = NavSubmenuItem;
CompoundNav.SubNav = NavSubNav; // export * from "./NavItem";

/**
 * An Icon triggered Dropdown containing Notifications
 */
function NotificationTray(props) {
  var children = props.children,
      unread = props.unread,
      notificationsObjects = props.notificationsObjects,
      markAllAsRead = props.markAllAsRead;
  var notifications = children && Children.toArray(children);
  return /*#__PURE__*/createElement(CompoundDropdown, {
    triggerAs: CompoundNav.Link,
    triggerContent: unread && /*#__PURE__*/createElement("span", {
      className: "nav-unread"
    }),
    toggle: false,
    icon: "bell",
    isNavLink: true,
    position: "bottom-end",
    arrow: true,
    arrowPosition: "right",
    flex: true,
    items: /*#__PURE__*/createElement(Fragment, null, notifications && notifications.map(function (n, i) {
      return /*#__PURE__*/createElement(CompoundDropdown.Item, {
        className: "d-flex",
        key: i
      }, n);
    }) || notificationsObjects && notificationsObjects.map(function (n, i) {
      return /*#__PURE__*/createElement(CompoundDropdown.Item, {
        className: "d-flex ".concat(n.unread ? "bg-light" : ""),
        key: i
      }, /*#__PURE__*/createElement(Notification, {
        unread: n.unread,
        avatarURL: n.avatarURL,
        message: n.message,
        time: n.time
      }));
    }), markAllAsRead && unread && /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(CompoundDropdown.ItemDivider, null), /*#__PURE__*/createElement(CompoundDropdown.Item, {
      className: "text-center text-muted-dark",
      onClick: function onClick() {
        return markAllAsRead();
      }
    }, "Mark all as read")))
  });
}

var CompoundNotification = Notification;
CompoundNotification.Tray = NotificationTray;

var defaultOptions = {
  profile: {
    icon: "user",
    value: "Profile",
    to: "/profile"
  },
  settings: {
    icon: "settings",
    value: "Settings",
    to: "/settings"
  },
  mail: {
    icon: "mail",
    value: "Inbox",
    to: "/mail"
  },
  message: {
    icon: "send",
    value: "Message",
    to: "/message"
  },
  help: {
    icon: "help-circle",
    value: "Need help?",
    to: "/help"
  },
  logout: {
    icon: "log-out",
    value: "Sign out",
    to: "/logout"
  },
  divider: {
    isDivider: true
  }
};

var itemsFromDefaultOptions = function itemsFromDefaultOptions(options) {
  return options.map(function (opt) {
    return typeof opt === "string" ? defaultOptions[opt] : opt;
  });
};
/**
 * A component for fast creation of an account centric dropdown
 */


function AccountDropdown(_ref) {
  var avatarURL = _ref.avatarURL,
      name = _ref.name,
      description = _ref.description,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      optionsRootComponent = _ref.optionsRootComponent,
      rest = _objectWithoutProperties(_ref, ["avatarURL", "name", "description", "options", "optionsRootComponent"]);

  var itemsObjects = itemsFromDefaultOptions(options);
  return /*#__PURE__*/React.createElement(CompoundDropdown, _extends({
    as: CompoundNav.Item,
    link: false,
    triggerClassName: "d-flex align-items-center py-0 px-lg-0 px-2 text-color ml-2",
    triggerAs: CompoundNav.Link,
    triggerContent: /*#__PURE__*/React.createElement(React.Fragment, null, avatarURL && /*#__PURE__*/React.createElement(Avatar, {
      imageURL: avatarURL
    }), /*#__PURE__*/React.createElement("span", {
      className: "ml-2 d-none d-lg-block leading-none"
    }, /*#__PURE__*/React.createElement("span", null, name), /*#__PURE__*/React.createElement("span", {
      className: "text-muted d-block mt-1 text-h6"
    }, description))),
    position: "bottom-end",
    arrow: true,
    arrowPosition: "right",
    toggle: false,
    itemsObject: itemsObjects,
    itemsRootComponent: optionsRootComponent
  }, rest));
}

var getButtonVariantColorClassName = function getButtonVariantColorClassName(color, variant) {
  if (variant === "outline") {
    return "btn-outline-".concat(color);
  }

  if (variant === "ghost") {
    return "btn-ghost-".concat(color);
  }

  if (color) {
    return "btn-".concat(color);
  }

  return false;
};

var Button = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _cn;

  var size = _ref.size,
      link = _ref.link,
      block = _ref.block,
      className = _ref.className,
      children = _ref.children,
      color = _ref.color;
      _ref.square;
      _ref.pill;
      var icon = _ref.icon,
      loading = _ref.loading,
      isDropdownToggle = _ref.isDropdownToggle,
      isOption = _ref.isOption,
      RootComponent = _ref.RootComponent,
      as = _ref.as,
      active = _ref.active,
      variant = _ref.variant,
      radius = _ref.radius,
      rootRef = _ref.rootRef,
      rest = _objectWithoutProperties(_ref, ["size", "link", "block", "className", "children", "color", "square", "pill", "icon", "loading", "isDropdownToggle", "isOption", "RootComponent", "as", "active", "variant", "radius", "rootRef"]);

  var classes = classnames((_cn = {
    btn: variant !== "none"
  }, _defineProperty(_cn, "btn-".concat(radius), radius), _defineProperty(_cn, "btn-".concat(size), !!size), _defineProperty(_cn, "btn-block", block), _defineProperty(_cn, "btn-link", link), _defineProperty(_cn, "active", active), _defineProperty(_cn, "disabled", rest.disabled), _defineProperty(_cn, "btn-icon", icon && !children), _defineProperty(_cn, "btn-loading", loading), _defineProperty(_cn, "dropdown-toggle", isDropdownToggle), _defineProperty(_cn, "btn-option", isOption), _cn), getButtonVariantColorClassName(color, variant), className);
  var Component = RootComponent || as || El.Button;

  var _icon = typeof icon === "string" ? /*#__PURE__*/React.createElement(Icon, {
    name: icon,
    className: children ? "mr-2" : ""
  }) : icon;

  return /*#__PURE__*/React.createElement(Component, _extends({
    className: classes,
    ref: rootRef || ref
  }, rest), _icon, children);
});

function ButtonList(_ref) {
  var className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "children"]);

  var classes = classnames({
    "btn-list": true
  }, className);
  return /*#__PURE__*/React.createElement(El.Div, _extends({
    className: classes
  }, props), children);
}

var ButtonDropdown = function ButtonDropdown(_ref) {
  var children = _ref.children,
      value = _ref.value,
      dropdownProps = _ref.dropdownProps,
      buttonProps = _objectWithoutProperties(_ref, ["children", "value", "dropdownProps"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var _handleButtonOnClick = function _handleButtonOnClick(e) {
    e.preventDefault();
    setIsOpen(function (s) {
      return !s;
    });
  };

  return /*#__PURE__*/React.createElement(Manager, null, /*#__PURE__*/React.createElement(Reference, null, function (_ref2) {
    var ref = _ref2.ref;
    return /*#__PURE__*/React.createElement(Button, _extends({
      onClick: _handleButtonOnClick,
      rootRef: ref,
      isDropdownToggle: true
    }, buttonProps), value);
  }), /*#__PURE__*/React.createElement(DropdownMenu, _extends({
    show: isOpen
  }, dropdownProps), children));
};

var CompoundButton = Button;
CompoundButton.List = ButtonList;
CompoundButton.Dropdown = ButtonDropdown;

var provideClassNames = {
  Link: "alert-link"
};
var Alert = function Alert(_ref) {
  var _cn;

  var className = _ref.className,
      style = _ref.style,
      children = _ref.children,
      type = _ref.type,
      icon = _ref.icon,
      hasExtraSpace = _ref.hasExtraSpace,
      isDismissible = _ref.isDismissible,
      avatar = _ref.avatar,
      onDismissClick = _ref.onDismissClick,
      important = _ref.important,
      message = _ref.message,
      title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["className", "style", "children", "type", "icon", "hasExtraSpace", "isDismissible", "avatar", "onDismissClick", "important", "message", "title"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isDismissed = _useState2[0],
      setIsDismissed = _useState2[1];

  var _handleOnDismissClick = function _handleOnDismissClick() {
    if (onDismissClick) onDismissClick();
    setIsDismissed(true);
  };

  var classes = classnames("alert", (_cn = {}, _defineProperty(_cn, "alert-".concat(type), type), _defineProperty(_cn, "my-4", hasExtraSpace), _defineProperty(_cn, "alert-dismissible", isDismissible), _defineProperty(_cn, "alert-important", important), _cn), className);

  if (isDismissed) {
    return null;
  }

  return /*#__PURE__*/React.createElement(ClassNamesProvider, {
    value: provideClassNames
  }, /*#__PURE__*/React.createElement(El.Div, _extends({
    className: classes,
    style: style,
    role: "alert",
    d: "flex"
  }, rest), icon && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
    name: icon,
    className: "mr-2",
    isAriaHidden: true
  })), avatar && /*#__PURE__*/React.createElement(Avatar, {
    imageURL: avatar
  }), /*#__PURE__*/React.createElement("div", null, title && /*#__PURE__*/React.createElement("h4", {
    className: "alert-title"
  }, title), message && /*#__PURE__*/React.createElement("div", {
    className: "text"
  }, message), children), isDismissible && /*#__PURE__*/React.createElement(CompoundButton, {
    className: "btn close",
    onClick: _handleOnDismissClick
  })));
};

/**
 * Renders an anchor that stands out more within Alerts
 */
function AlertLink(_ref) {
  var children = _ref.children,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, ["children", "className"]);

  var classes = classnames("alert-link", className);
  return /*#__PURE__*/createElement(El.A, _extends({
    className: classes
  }, rest), children);
}

var CompoundAlert = Alert;
CompoundAlert.Link = AlertLink;

var CardHeader = createTablerElement("div", {
  displayName: "CardHeader",
  className: "card-header",
  provideClassNames: {
    "nav-pills": "card-header-pills",
    "nav-tabs": "card-header-tabs"
  }
});

var CardTitle = createTablerElement("div", {
  displayName: "CardTitle",
  className: "card-title"
});

var CardBody = createTablerElement("div", {
  displayName: "CardBody",
  className: "card-body"
});

function CardOptions(_ref) {
  var className = _ref.className,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["className", "children"]);

  var classes = classnames("card-options", className);
  return /*#__PURE__*/createElement(El.Div, _extends({
    className: classes
  }, rest), children);
}

function CardOptionsItem(_ref) {
  var className = _ref.className;
      _ref.children;
      var icon = _ref.icon,
      type = _ref.type,
      rest = _objectWithoutProperties(_ref, ["className", "children", "icon", "type"]);

  var classes = classnames({
    "card-options-collapse": type === "collapse",
    "card-options-remove": type === "close",
    "card-options-fullscreen": type === "fullscreen"
  }, className);

  var dataToggle = function () {
    switch (type) {
      case "collapse":
        return "card-collapse";

      case "close":
        return "card-remove";

      case "fullscreen":
        return "card-remove";

      default:
        return "";
    }
  }();

  var iconName = function () {
    if (icon) {
      return icon;
    }

    switch (type) {
      case "collapse":
        return "chevron-up";

      case "close":
        return "x";

      case "fullscreen":
        return "maximize";

      default:
        return "";
    }
  }();

  return /*#__PURE__*/createElement(El.A, _extends({
    className: classes,
    "data-toggle": dataToggle
  }, rest), /*#__PURE__*/createElement(Icon, {
    name: iconName
  }));
}

function CardStatus(_ref) {
  var _cn;

  var className = _ref.className,
      children = _ref.children,
      color = _ref.color;
      _ref.side;
      var _ref$position = _ref.position,
      position = _ref$position === void 0 ? "start" : _ref$position,
      rest = _objectWithoutProperties(_ref, ["className", "children", "color", "side", "position"]);

  var classes = classnames((_cn = {
    "card-status": true
  }, _defineProperty(_cn, "bg-".concat(color), true), _defineProperty(_cn, "card-status-".concat(position), position), _cn), className);
  return /*#__PURE__*/createElement(El.Div, _extends({
    className: classes
  }, rest), children);
}

var CardFooter = createTablerElement("div", {
  displayName: "CardFooter",
  className: "card-footer"
});

var CardSubTitle = createTablerElement("div", {
  displayName: "CardSubTitle",
  className: "card-subtitle"
});

/**
 * A Header component rendered as a h1 HTML element with a margin below
 */
function H1(_ref) {
  var children = _ref.children,
      as = _ref.as,
      _ref$mt = _ref.mt,
      mt = _ref$mt === void 0 ? 0 : _ref$mt,
      _ref$mb = _ref.mb,
      mb = _ref$mb === void 0 ? 4 : _ref$mb,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 1 : _ref$size,
      props = _objectWithoutProperties(_ref, ["children", "as", "mt", "mb", "size"]);

  return /*#__PURE__*/React.createElement(Header, _extends({
    as: as || "h1",
    size: size,
    mt: mt,
    mb: mb
  }, props), children);
}

/**
 * A Header component rendered as a h2 HTML element with a margin below
 */
function H2(_ref) {
  var children = _ref.children,
      as = _ref.as,
      _ref$mt = _ref.mt,
      mt = _ref$mt === void 0 ? 0 : _ref$mt,
      _ref$mb = _ref.mb,
      mb = _ref$mb === void 0 ? 4 : _ref$mb,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 2 : _ref$size,
      props = _objectWithoutProperties(_ref, ["children", "as", "mt", "mb", "size"]);

  return /*#__PURE__*/React.createElement(Header, _extends({
    as: as || "h2",
    size: size,
    mt: mt,
    mb: mb
  }, props), children);
}

/**
 * A Header component rendered as a h3 HTML element with a margin below
 */
function H3(_ref) {
  var children = _ref.children,
      as = _ref.as,
      _ref$mt = _ref.mt,
      mt = _ref$mt === void 0 ? 0 : _ref$mt,
      _ref$mb = _ref.mb,
      mb = _ref$mb === void 0 ? 4 : _ref$mb,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 3 : _ref$size,
      props = _objectWithoutProperties(_ref, ["children", "as", "mt", "mb", "size"]);

  return /*#__PURE__*/React.createElement(Header, _extends({
    as: as || "h3",
    size: size,
    mt: mt,
    mb: mb
  }, props), children);
}

/**
 * A Header component rendered as a h4 HTML element with a margin below
 */
function H4(_ref) {
  var children = _ref.children,
      as = _ref.as,
      _ref$mt = _ref.mt,
      mt = _ref$mt === void 0 ? 0 : _ref$mt,
      _ref$mb = _ref.mb,
      mb = _ref$mb === void 0 ? 4 : _ref$mb,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 4 : _ref$size,
      props = _objectWithoutProperties(_ref, ["children", "as", "mt", "mb", "size"]);

  return /*#__PURE__*/React.createElement(Header, _extends({
    as: as || "h4",
    size: size,
    mt: mt,
    mb: mb
  }, props), children);
}

/**
 * A Header component rendered as a h5 HTML element with a margin below
 */
function H5(_ref) {
  var children = _ref.children,
      as = _ref.as,
      _ref$mt = _ref.mt,
      mt = _ref$mt === void 0 ? 0 : _ref$mt,
      _ref$mb = _ref.mb,
      mb = _ref$mb === void 0 ? 4 : _ref$mb,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 5 : _ref$size,
      props = _objectWithoutProperties(_ref, ["children", "as", "mt", "mb", "size"]);

  return /*#__PURE__*/React.createElement(Header, _extends({
    as: as || "h5",
    size: size,
    mt: mt,
    mb: mb
  }, props), children);
}

var CompoundHeader = Header;
CompoundHeader.H1 = H1;
CompoundHeader.H2 = H2;
CompoundHeader.H3 = H3;
CompoundHeader.H4 = H4;
CompoundHeader.H5 = H5;
CompoundHeader.H6 = H6;

var SubHeader = createTablerElement("div", {
  displayName: "SubHeader",
  className: "subheader"
});

var GridRow = createTablerElement("div", {
  className: "row",
  classNames: function classNames(_ref) {
    var cards = _ref.cards,
        deck = _ref.deck,
        zero = _ref.zero;
    return {
      "row-cards": cards,
      "row-deck": deck,
      "row-0": zero
    };
  },
  modifyProps: function modifyProps(_ref2) {
    _ref2.cards;
        _ref2.deck;
        var props = _objectWithoutProperties(_ref2, ["cards", "deck"]);

    return props;
  }
});

var GridCol = createTablerElement("div", {
  classNames: function classNames(_ref) {
    var _ref2;

    var col = _ref.col,
        sm = _ref.sm,
        md = _ref.md,
        lg = _ref.lg,
        xl = _ref.xl,
        xxl = _ref.xxl,
        offsetSm = _ref.offsetSm,
        offsetMd = _ref.offsetMd,
        offsetLg = _ref.offsetLg,
        offsetXl = _ref.offsetXl,
        offsetXxl = _ref.offsetXxl;
    return _ref2 = {
      col: !col && !sm && !md && !lg && !xl && !xxl
    }, _defineProperty(_ref2, "col-".concat(col), col), _defineProperty(_ref2, "col-sm-".concat(sm), sm), _defineProperty(_ref2, "col-md-".concat(md), md), _defineProperty(_ref2, "col-lg-".concat(lg), lg), _defineProperty(_ref2, "col-xl-".concat(xl), xl), _defineProperty(_ref2, "col-xxl-".concat(xxl), xxl), _defineProperty(_ref2, "offset-sm-".concat(sm), offsetSm), _defineProperty(_ref2, "offset-md-".concat(md), offsetMd), _defineProperty(_ref2, "offset-lg-".concat(lg), offsetLg), _defineProperty(_ref2, "offset-xl-".concat(xl), offsetXl), _defineProperty(_ref2, "offset-xxl-".concat(xxl), offsetXxl), _ref2;
  },
  modifyProps: function modifyProps(_ref3) {
    _ref3.col;
        _ref3.sm;
        _ref3.md;
        _ref3.lg;
        _ref3.xl;
        _ref3.xxl;
        _ref3.offsetSm;
        _ref3.offsetMd;
        _ref3.offsetLg;
        _ref3.offsetXl;
        _ref3.offsetXxl;
        var props = _objectWithoutProperties(_ref3, ["col", "sm", "md", "lg", "xl", "xxl", "offsetSm", "offsetMd", "offsetLg", "offsetXl", "offsetXxl"]);

    return _objectSpread2({}, props);
  }
});

var Image = createTablerElement(El.Img, {
  displayName: "Image",
  classNames: function classNames(_ref) {
    var ratio = _ref.ratio,
        responsive = _ref.responsive,
        fluid = _ref.fluid,
        thumbnail = _ref.thumbnail;
    return [responsive || ratio && "img-responsive", ratio && "img-responsive-".concat(ratio), thumbnail && "img-thumbnail", fluid && "img-fluid"];
  },
  modifyProps: function modifyProps(_ref2) {
    var as = _ref2.as,
        style = _ref2.style,
        backgroundImage = _ref2.backgroundImage,
        backgroundImageUrl = _ref2.backgroundImageUrl;
        _ref2.ratio;
        _ref2.responsive;
        _ref2.fluid;
        _ref2.thumbnail;
        var props = _objectWithoutProperties(_ref2, ["as", "style", "backgroundImage", "backgroundImageUrl", "ratio", "responsive", "fluid", "thumbnail"]);

    var _style = backgroundImage || backgroundImageUrl ? _objectSpread2(_objectSpread2({}, style), {}, {
      backgroundImage: backgroundImageUrl ? "url(".concat(backgroundImageUrl, ")") : backgroundImage
    }) : style;

    var _as = as || (!props.src ? El.Div : undefined);

    return _objectSpread2({
      style: _style,
      as: _as
    }, props);
  }
});

var Card = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _cn;

  var className = _ref.className,
      children = _ref.children,
      as = _ref.as,
      RootComponent = _ref.RootComponent,
      title = _ref.title,
      subTitle = _ref.subTitle,
      preTitle = _ref.preTitle,
      preTitleActions = _ref.preTitleActions,
      body = _ref.body,
      options = _ref.options,
      isCollapsible = _ref.isCollapsible,
      isClosable = _ref.isClosable,
      isFullscreenable = _ref.isFullscreenable,
      aside = _ref.aside,
      statusColor = _ref.statusColor,
      statusPosition = _ref.statusPosition;
      _ref.alertColor;
      var header = _ref.header,
      footer = _ref.footer,
      isClosed = _ref.isClosed,
      isCollapsed = _ref.isCollapsed,
      imageTop = _ref.imageTop,
      imageBottom = _ref.imageBottom,
      imageLeft = _ref.imageLeft,
      imageRight = _ref.imageRight,
      size = _ref.size,
      active = _ref.active,
      borderless = _ref.borderless,
      stacked = _ref.stacked,
      rest = _objectWithoutProperties(_ref, ["className", "children", "as", "RootComponent", "title", "subTitle", "preTitle", "preTitleActions", "body", "options", "isCollapsible", "isClosable", "isFullscreenable", "aside", "statusColor", "statusPosition", "alertColor", "header", "footer", "isClosed", "isCollapsed", "imageTop", "imageBottom", "imageLeft", "imageRight", "size", "active", "borderless", "stacked"]);

  var _useState = useState(isClosed || false),
      _useState2 = _slicedToArray(_useState, 2),
      _isClosed = _useState2[0],
      setIsClosed = _useState2[1];

  var _useState3 = useState(isCollapsed || false),
      _useState4 = _slicedToArray(_useState3, 2),
      _isCollapsed = _useState4[0],
      setIsCollapsed = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isFullscreen = _useState6[0],
      setIsFullscreen = _useState6[1];

  var handleCloseOnClick = function handleCloseOnClick() {
    setIsClosed(function (s) {
      return !s;
    });
  };

  var handleCollapseOnClick = function handleCollapseOnClick() {
    setIsCollapsed(function (s) {
      return !s;
    });
  };

  var handleFullscreenOnClick = function handleFullscreenOnClick() {
    setIsFullscreen(function (s) {
      return !s;
    });
  };

  if (_isClosed) {
    return null;
  }

  var classes = classnames((_cn = {
    card: true,
    aside: aside,
    "card-collapsed": _isCollapsed,
    "card-fullscreen": isFullscreen
  }, _defineProperty(_cn, "card-".concat(size), size), _defineProperty(_cn, "card-".concat(active), active), _defineProperty(_cn, "border-0", borderless), _defineProperty(_cn, "card-stacked", stacked), _cn), className);
  var Component = RootComponent || as || El.Div;
  var card_options = (options || isCollapsible || isClosable) && /*#__PURE__*/React.createElement(CardOptions, null, options, isCollapsible && /*#__PURE__*/React.createElement(CardOptionsItem, {
    onClick: handleCollapseOnClick,
    type: "collapse"
  }), isFullscreenable && /*#__PURE__*/React.createElement(CardOptionsItem, {
    type: "fullscreen",
    onClick: handleFullscreenOnClick
  }), isClosable && /*#__PURE__*/React.createElement(CardOptionsItem, {
    type: "close",
    onClick: handleCloseOnClick
  }));

  var _titles = /*#__PURE__*/React.createElement(El.Div, null, preTitle && /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center"
  }, /*#__PURE__*/React.createElement(SubHeader, null, preTitle), preTitleActions && /*#__PURE__*/React.createElement("div", {
    className: "ms-auto lh-1"
  }, preTitleActions)), title && preTitle ? /*#__PURE__*/React.createElement(Header, {
    size: 1,
    mb: 3
  }, title) : title && /*#__PURE__*/React.createElement(CardTitle, null, title), subTitle && /*#__PURE__*/React.createElement(CardSubTitle, null, subTitle));

  var _header = (header || !body && title) && /*#__PURE__*/React.createElement(CardHeader, null, _titles, card_options, header);

  var _contents = /*#__PURE__*/React.createElement(React.Fragment, null, _header, imageTop && /*#__PURE__*/React.createElement(Image, {
    className: "card-img-top",
    src: imageTop
  }), body && /*#__PURE__*/React.createElement(CardBody, null, !_header && _titles, body), !body && !_header && _titles, children, imageBottom && /*#__PURE__*/React.createElement(Image, {
    className: "card-img-bottom",
    src: imageBottom
  }), footer && /*#__PURE__*/React.createElement(CardFooter, null, footer));

  return /*#__PURE__*/React.createElement(Component, _extends({
    className: classes,
    ref: ref
  }, rest), statusColor && /*#__PURE__*/React.createElement(CardStatus, {
    color: statusColor,
    position: statusPosition
  }), imageLeft || imageRight ? /*#__PURE__*/React.createElement(CardSideImages, {
    imageLeft: imageLeft,
    imageRight: imageRight
  }, _contents) : _contents);
});

var CardSideImages = function CardSideImages(_ref2) {
  var imageLeft = _ref2.imageLeft,
      imageRight = _ref2.imageRight,
      children = _ref2.children;
  return /*#__PURE__*/React.createElement(GridRow, {
    zero: true
  }, imageLeft && /*#__PURE__*/React.createElement(GridCol, {
    col: 3
  }, /*#__PURE__*/React.createElement(Image, {
    w: 100,
    h: 100,
    objectFit: "cover",
    src: imageLeft
  })), /*#__PURE__*/React.createElement(GridCol, null, children), imageRight && /*#__PURE__*/React.createElement(GridCol, {
    as: "span",
    col: 3
  }, /*#__PURE__*/React.createElement(Image, {
    w: 100,
    h: 100,
    objectFit: "cover",
    src: imageRight
  })));
}; // static Header = CardHeader;

/**
 * @deprecated use <Alert />
 */
function CardAlert(_ref) {
  var className = _ref.className,
      children = _ref.children,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["className", "children", "color"]);

  var classes = classnames("card-alert alert alert-".concat(color, " mb-0"), className);
  return /*#__PURE__*/createElement(El.Div, _extends({
    className: classes
  }, rest), children);
}

function CardMap(_ref) {
  var className = _ref.className,
      children = _ref.children,
      placeholder = _ref.placeholder,
      rest = _objectWithoutProperties(_ref, ["className", "children", "placeholder"]);

  var classes = classnames("card-map", {
    "card-map-placeholder": placeholder
  }, className);
  return /*#__PURE__*/createElement(El.Div, _extends({
    className: classes,
    style: placeholder ? {
      backgroundImage: "url(".concat(placeholder, ")")
    } : {}
  }, rest), children);
}

var CardGroup = createTablerElement("div", {
  displayName: "CardGroup",
  className: "card-group"
});

var CompoundCard = Card;
CompoundCard.Alert = CardAlert;
CompoundCard.Body = CardBody;
CompoundCard.Footer = CardFooter;
CompoundCard.Header = CardHeader;
CompoundCard.Map = CardMap;
CompoundCard.Options = CardOptions;
CompoundCard.OptionsItem = CardOptionsItem;
CompoundCard.Status = CardStatus;
CompoundCard.Title = CardTitle;
CompoundCard.Group = CardGroup;

function BlogCard(_ref) {
  var title = _ref.title,
      description = _ref.description,
      imgAlt = _ref.imgAlt,
      aside = _ref.aside,
      authorName = _ref.authorName,
      date = _ref.date,
      _ref$imgSrc = _ref.imgSrc,
      imgSrc = _ref$imgSrc === void 0 ? "" : _ref$imgSrc,
      _ref$avatarImgSrc = _ref.avatarImgSrc,
      avatarImgSrc = _ref$avatarImgSrc === void 0 ? "" : _ref$avatarImgSrc,
      iconName = _ref.iconName,
      iconHref = _ref.iconHref,
      postHref = _ref.postHref,
      profileHref = _ref.profileHref;
  return !aside ? /*#__PURE__*/createElement(CompoundCard, null, /*#__PURE__*/createElement("a", {
    href: postHref
  }, /*#__PURE__*/createElement("img", {
    className: "card-img-top",
    src: imgSrc,
    alt: imgAlt
  })), /*#__PURE__*/createElement(CompoundCard.Body, {
    className: "d-flex flex-column"
  }, /*#__PURE__*/createElement("h4", null, /*#__PURE__*/createElement("a", {
    href: postHref
  }, title)), /*#__PURE__*/createElement("div", {
    className: "text-muted"
  }, description), /*#__PURE__*/createElement("div", {
    className: "d-flex align-items-center pt-5 mt-auto"
  }, /*#__PURE__*/createElement("div", {
    className: "avatar avatar-md mr-3",
    style: {
      backgroundImage: "url(".concat(avatarImgSrc)
    }
  }), /*#__PURE__*/createElement("div", null, /*#__PURE__*/createElement("a", {
    href: profileHref,
    className: "text-default"
  }, authorName), /*#__PURE__*/createElement("small", {
    className: "d-block text-muted"
  }, date)), /*#__PURE__*/createElement("div", {
    className: "ml-auto text-muted"
  }, /*#__PURE__*/createElement("a", {
    href: iconHref,
    className: "icon d-none d-md-inline-block ml-3"
  }, /*#__PURE__*/createElement(Icon, {
    prefix: "fe",
    name: iconName || "heart"
  })))))) : /*#__PURE__*/createElement(CompoundCard, {
    className: "card-aside"
  }, /*#__PURE__*/createElement("a", {
    href: postHref,
    className: "card-aside-column",
    style: {
      backgroundImage: "url(".concat(imgSrc, ")")
    }
  }, ""), /*#__PURE__*/createElement(CompoundCard.Body, {
    className: "d-flex flex-column"
  }, /*#__PURE__*/createElement("h4", null, /*#__PURE__*/createElement("a", {
    href: postHref
  }, title)), /*#__PURE__*/createElement("div", {
    className: "text-muted"
  }, description), /*#__PURE__*/createElement("div", {
    className: "d-flex align-items-center pt-5 mt-auto"
  }, /*#__PURE__*/createElement("div", {
    className: "avatar avatar-md mr-3",
    style: {
      backgroundImage: "url(".concat(avatarImgSrc)
    }
  }), /*#__PURE__*/createElement("div", null, /*#__PURE__*/createElement("a", {
    href: profileHref,
    className: "text-default"
  }, authorName), /*#__PURE__*/createElement("small", {
    className: "d-block text-muted"
  }, date)), /*#__PURE__*/createElement("div", {
    className: "ml-auto text-red"
  }, /*#__PURE__*/createElement("a", {
    href: iconHref,
    className: "icon d-none d-md-inline-block ml-3"
  }, /*#__PURE__*/createElement(Icon, {
    prefix: "fe",
    name: iconName || "heart"
  }))))));
}

/**
 * Breadcrumbs
 */
function Breadcrumb(_ref) {
  var children = _ref.children,
      className = _ref.className,
      separator = _ref.separator,
      variant = _ref.variant,
      rest = _objectWithoutProperties(_ref, ["children", "className", "separator", "variant"]);

  var classes = classnames("breadcrumb", _defineProperty({}, "breadcrumb-".concat(separator), separator), _defineProperty({}, "breadcrumb-".concat(variant), variant), className);
  return /*#__PURE__*/React.createElement(El.Ol, _extends({
    className: classes
  }, rest), children);
}

/**
 * Breadcrumb Item
 */
function BreadcrumbItem(_ref) {
  var children = _ref.children,
      className = _ref.className,
      active = _ref.active,
      rest = _objectWithoutProperties(_ref, ["children", "className", "active"]);

  var classes = classnames("breadcrumb-item", {
    active: active
  }, className);
  return /*#__PURE__*/React.createElement(El.Li, _extends({
    className: classes
  }, rest), children);
}

var CompoundBreadcrumb = Breadcrumb;
CompoundBreadcrumb.Item = BreadcrumbItem;

function ListItem(_ref) {
  var className = _ref.className,
      children = _ref.children,
      inline = _ref.inline,
      rest = _objectWithoutProperties(_ref, ["className", "children", "inline"]);

  var classes = classnames({
    "list-inline-item": inline
  }, className);
  return /*#__PURE__*/createElement(El.Li, _extends({
    className: classes
  }, rest), children);
}

function ListGroup(_ref) {
  var className = _ref.className,
      children = _ref.children,
      transparent = _ref.transparent,
      isCardBody = _ref.isCardBody,
      rest = _objectWithoutProperties(_ref, ["className", "children", "transparent", "isCardBody"]);

  var classes = classnames("list-group", "mb-0", {
    "list-group-transparent": transparent,
    "card-list-group": isCardBody
  }, className);
  return /*#__PURE__*/createElement(El.Div, _extends({
    className: classes
  }, rest), children);
}

function ListGroupItem(_ref) {
  var className = _ref.className,
      children = _ref.children,
      RootComponent = _ref.RootComponent,
      as = _ref.as,
      active = _ref.active,
      action = _ref.action,
      icon = _ref.icon,
      rest = _objectWithoutProperties(_ref, ["className", "children", "RootComponent", "as", "active", "action", "icon"]);

  var classes = classnames("list-group-item", {
    "list-group-item-action": action
  }, {
    active: active
  }, className);
  var Component = RootComponent || as || El.A;
  return /*#__PURE__*/createElement(Component, _extends({
    className: classes
  }, rest), icon && /*#__PURE__*/createElement("span", {
    className: "mr-3 icon"
  }, /*#__PURE__*/createElement(Icon, {
    prefix: "fe",
    name: icon
  }), " "), children);
}

function List(_ref) {
  var className = _ref.className,
      children = _ref.children,
      unstyled = _ref.unstyled,
      seperated = _ref.seperated,
      inline = _ref.inline,
      rest = _objectWithoutProperties(_ref, ["className", "children", "unstyled", "seperated", "inline"]);

  var classes = classnames({
    list: !unstyled,
    "list-unstyled": unstyled,
    "list-seperated": seperated,
    "list-inline": inline
  }, className);
  return /*#__PURE__*/createElement(El.Ul, _extends({
    className: classes
  }, rest), children);
}

List.Item = ListItem;
List.Group = ListGroup;
List.GroupItem = ListGroupItem;

function Media(_ref) {
  var className = _ref.className,
      children = _ref.children,
      rounded = _ref.rounded,
      aspectRatio = _ref.aspectRatio,
      rest = _objectWithoutProperties(_ref, ["className", "children", "rounded", "aspectRatio"]);

  var classes = classnames("media", _defineProperty({
    rounded: rounded
  }, "media-".concat(aspectRatio), aspectRatio), className);
  return /*#__PURE__*/React.createElement(El.Div, _extends({
    className: classes
  }, rest), children);
}

function MediaBody(_ref) {
  var className = _ref.className,
      children = _ref.children;
  var classes = classnames("media-body", className);
  return /*#__PURE__*/createElement("div", {
    className: classes
  }, children);
}

function MediaHeading(_ref) {
  var className = _ref.className,
      children = _ref.children;
  var classes = classnames("media-heading", className);
  return /*#__PURE__*/createElement("div", {
    className: classes
  }, children);
}

function MediaList(_ref) {
  var className = _ref.className,
      children = _ref.children;
  var classes = classnames("media-list", className);
  return /*#__PURE__*/createElement("ul", {
    className: classes
  }, children);
}

function MediaObject(_ref) {
  var className = _ref.className,
      children = _ref.children,
      avatar = _ref.avatar,
      objectURL = _ref.objectURL,
      size = _ref.size,
      rounded = _ref.rounded,
      alt = _ref.alt;
  var classes = classnames("media-object", className);
  var imageClasses = classnames({
    "d-flex": true,
    rounded: rounded
  });
  var mediaImage = avatar ? /*#__PURE__*/createElement(Avatar, {
    size: size,
    imageURL: objectURL
  }) : objectURL ? /*#__PURE__*/createElement("img", {
    className: imageClasses,
    src: objectURL,
    alt: alt
  }) : null;
  return /*#__PURE__*/createElement("div", {
    className: classes
  }, mediaImage, children);
}

function listItemFromObjectFactory() {
  var asButtons = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var iconPrefix = arguments.length > 1 ? arguments[1] : undefined;
  return function (item, index) {
    var itemContent = asButtons ? /*#__PURE__*/createElement(CompoundButton, {
      to: item.to,
      social: item.name,
      color: item.color,
      size: "sm"
    }, item.label) : /*#__PURE__*/createElement("a", {
      href: item.to,
      "data-original-title": item.tooltip
    }, /*#__PURE__*/createElement(Icon, {
      prefix: iconPrefix,
      name: item.name
    }));
    return /*#__PURE__*/createElement(List.Item, {
      key: index,
      inline: true
    }, itemContent);
  };
}

function SocialNetworksList(props) {
  var children = props.children,
      className = props.className,
      asButtons = props.asButtons,
      _props$prefix = props.prefix,
      prefix = _props$prefix === void 0 ? "fe" : _props$prefix,
      items = props.items,
      itemsObjects = props.itemsObjects;
  var classes = classnames("social-links", className);
  var getObjectListItem = listItemFromObjectFactory(asButtons, prefix);
  var contents = itemsObjects && itemsObjects.map(getObjectListItem) || items && items.map(function (item, index) {
    return /*#__PURE__*/createElement(List.Item, {
      key: index,
      inline: true
    }, item);
  }) || children;
  return /*#__PURE__*/createElement(List, {
    inline: true,
    className: classes
  }, contents);
}

var Tooltip = function Tooltip(_ref) {
  var className = _ref.className,
      children = _ref.children,
      placement = _ref.placement,
      content = _ref.content,
      _ref$arrow = _ref.arrow,
      arrow = _ref$arrow === void 0 ? true : _ref$arrow;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isShown = _useState2[0],
      setIsShown = _useState2[1];

  var _handleTriggerOnMouseEnter = function _handleTriggerOnMouseEnter(e) {
    e.preventDefault();
    setIsShown(true);
  };

  var _handleTriggerOnMouseLeave = function _handleTriggerOnMouseLeave(e) {
    e.preventDefault();
    setIsShown(false);
  };

  var classes = classnames("tooltip", placement && "bs-tooltip-" + placement, "show", className);
  var arrowClasses = classnames("arrow", placement === "top" || placement === "bottom" ? "tbr-arrow-vertical" : "tbr-arrow-horizontal");
  return /*#__PURE__*/React.createElement(Manager, null, /*#__PURE__*/React.createElement(Reference, null, function (_ref2) {
    var ref = _ref2.ref;
    var referenceProps = {
      ref: ref,
      onMouseEnter: _handleTriggerOnMouseEnter,
      onMouseLeave: _handleTriggerOnMouseLeave
    };
    return typeof children !== "undefined" && /*#__PURE__*/React.cloneElement(children, referenceProps);
  }), isShown && /*#__PURE__*/React.createElement(Popper, {
    placement: placement
  }, function (_ref3) {
    var ref = _ref3.ref,
        _ref3$style = _ref3.style;
        _ref3$style.opacity;
        var style = _objectWithoutProperties(_ref3$style, ["opacity"]),
        placement = _ref3.placement;

    return /*#__PURE__*/React.createElement("div", {
      className: classes,
      "data-placement": placement,
      style: style,
      ref: ref
    }, arrow && /*#__PURE__*/React.createElement("div", {
      className: arrowClasses
    }), /*#__PURE__*/React.createElement("div", {
      className: "tooltip-inner"
    }, content));
  }));
};

function MediaBodySocial(_ref) {
  _ref.className;
      var children = _ref.children,
      name = _ref.name,
      workTitle = _ref.workTitle,
      _ref$facebook = _ref.facebook,
      facebook = _ref$facebook === void 0 ? "" : _ref$facebook,
      _ref$twitter = _ref.twitter,
      twitter = _ref$twitter === void 0 ? "" : _ref$twitter,
      _ref$phone = _ref.phone,
      phone = _ref$phone === void 0 ? "" : _ref$phone,
      _ref$skype = _ref.skype,
      skype = _ref$skype === void 0 ? "" : _ref$skype;
  var fbIcon;
  var twitterIcon;
  var phoneIcon;
  var skypeIcon;

  if (facebook) {
    fbIcon = /*#__PURE__*/createElement(List.Item, {
      inline: true
    }, /*#__PURE__*/createElement(Tooltip, {
      content: "Facebook",
      placement: "top"
    }, /*#__PURE__*/createElement("a", {
      href: "/Profile"
    }, /*#__PURE__*/createElement(Icon, {
      prefix: "fa",
      name: "facebook"
    }))));
  }

  if (twitter) {
    twitterIcon = /*#__PURE__*/createElement(List.Item, {
      inline: true
    }, /*#__PURE__*/createElement(Tooltip, {
      content: "Twitter",
      placement: "top"
    }, /*#__PURE__*/createElement("a", {
      href: "/Profile"
    }, /*#__PURE__*/createElement(Icon, {
      prefix: "fa",
      name: "twitter"
    }))));
  }

  if (phone) {
    phoneIcon = /*#__PURE__*/createElement(List.Item, {
      inline: true
    }, /*#__PURE__*/createElement(Tooltip, {
      content: "+1 234-567-8901",
      placement: "top"
    }, /*#__PURE__*/createElement("a", {
      href: "/Profile"
    }, /*#__PURE__*/createElement(Icon, {
      prefix: "fa",
      name: "phone"
    }))));
  }

  if (skype) {
    skypeIcon = /*#__PURE__*/createElement(List.Item, {
      inline: true
    }, /*#__PURE__*/createElement(Tooltip, {
      content: "@skypename",
      placement: "top"
    }, /*#__PURE__*/createElement("a", {
      href: "/Profile"
    }, /*#__PURE__*/createElement(Icon, {
      prefix: "fa",
      name: "skype"
    }))));
  }

  return /*#__PURE__*/createElement(MediaBody, null, /*#__PURE__*/createElement("h4", {
    className: "m-0"
  }, name), /*#__PURE__*/createElement("p", {
    className: "text-muted mb-0"
  }, workTitle), /*#__PURE__*/createElement(SocialNetworksList, {
    className: "mb-0 mt-2"
  }, fbIcon, twitterIcon, phoneIcon, skypeIcon), children);
}

function MediaListItem(_ref) {
  var className = _ref.className,
      children = _ref.children;
  var classes = classnames("media mt-4", className);
  return /*#__PURE__*/createElement("li", {
    className: classes
  }, children);
}

function MediaContent(_ref) {
  var className = _ref.className,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["className", "children"]);

  var classes = classnames("media-content", className);
  return /*#__PURE__*/React.createElement(El.Div, _extends({
    className: classes
  }, rest), children);
}

var CompoundMedia = Media;
CompoundMedia.Body = MediaBody;
CompoundMedia.BodySocial = MediaBodySocial;
CompoundMedia.Heading = MediaHeading;
CompoundMedia.List = MediaList;
CompoundMedia.ListItem = MediaListItem;
CompoundMedia.Object = MediaObject;
CompoundMedia.Content = MediaContent;

function CommentList(_ref) {
  var className = _ref.className,
      children = _ref.children;
  var classes = classnames("card-list-group", className);
  return /*#__PURE__*/createElement(List.Group, {
    className: classes
  }, children);
}

function CommentReply(_ref) {
  var className = _ref.className;
      _ref.children;
      var avatarURL = _ref.avatarURL,
      name = _ref.name;
      _ref.date;
      var text = _ref.text;
  return /*#__PURE__*/createElement(CompoundMedia.ListItem, {
    className: className
  }, /*#__PURE__*/createElement(CompoundMedia.Object, {
    avatar: true,
    objectURL: avatarURL,
    className: "mr-4"
  }), /*#__PURE__*/createElement(CompoundMedia.Body, null, /*#__PURE__*/createElement("strong", null, name, ": "), text));
}

function Comment(_ref) {
  var className = _ref.className,
      avatarURL = _ref.avatarURL,
      name = _ref.name,
      date = _ref.date,
      text = _ref.text,
      replies = _ref.replies;
  var classes = classnames("py-5", className);
  return /*#__PURE__*/createElement(List.GroupItem, {
    className: classes
  }, /*#__PURE__*/createElement(CompoundMedia, null, /*#__PURE__*/createElement(CompoundMedia.Object, {
    avatar: true,
    objectURL: avatarURL,
    size: "md",
    className: "mr-4"
  }), /*#__PURE__*/createElement(CompoundMedia.Body, null, /*#__PURE__*/createElement(CompoundMedia.Heading, null, /*#__PURE__*/createElement("small", {
    className: "float-right text-muted"
  }, date), /*#__PURE__*/createElement("h5", null, name)), /*#__PURE__*/createElement(CompoundText, null, text), replies && /*#__PURE__*/createElement(CompoundMedia.List, null, replies))));
}

Comment.List = CommentList;
Comment.Reply = CommentReply;

function Form(_ref) {
  var children = _ref.children,
      as = _ref.as,
      rest = _objectWithoutProperties(_ref, ["children", "as"]);

  var Component = as || El.Form;
  return /*#__PURE__*/React.createElement(Component, rest, children);
}

function FormLabel(_ref) {
  var className = _ref.className,
      aside = _ref.aside,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["className", "aside", "children"]);

  var classes = classnames("form-label", className);
  return /*#__PURE__*/React.createElement(El.Label, _extends({
    className: classes
  }, rest), aside && /*#__PURE__*/React.createElement("span", {
    className: "form-label-small"
  }, aside), children);
}

function FormGroup(_ref) {
  var className = _ref.className,
      children = _ref.children,
      label = _ref.label,
      isRequired = _ref.isRequired,
      rest = _objectWithoutProperties(_ref, ["className", "children", "label", "isRequired"]);

  var classes = classnames("form-group", className);
  return /*#__PURE__*/React.createElement(El.Div, _extends({
    className: classes
  }, rest), !label ? null : typeof label === "string" ? /*#__PURE__*/React.createElement(FormLabel, null, label, isRequired && /*#__PURE__*/React.createElement("span", {
    className: "form-required"
  }, "*")) : label, children);
}

/**
 * A an input field
 */
var FormInput = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var as = _ref.as,
      className = _ref.className,
      icon = _ref.icon,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? "prepend" : _ref$position,
      valid = _ref.valid,
      tick = _ref.tick,
      invalid = _ref.invalid,
      cross = _ref.cross,
      error = _ref.error,
      label = _ref.label,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "text" : _ref$type,
      feedback = _ref.feedback,
      light = _ref.light,
      rest = _objectWithoutProperties(_ref, ["as", "className", "icon", "position", "valid", "tick", "invalid", "cross", "error", "label", "type", "feedback", "light"]);

  var classes = classnames({
    "form-control": type !== "checkbox" && type !== "radio",
    "form-control-light": light,
    "custom-control-input": type === "checkbox" || type === "radio",
    "is-valid": valid,
    "state-valid": tick,
    "is-invalid": invalid || !!error,
    "state-invalid": cross || !!error
  }, className);

  var _feedback = error || feedback;

  var allInputProps = _objectSpread2({
    className: classes,
    type: type
  }, rest);

  var Component = as || El.Input;

  var _children = !icon ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Component, _extends({
    ref: ref
  }, allInputProps)), _feedback && /*#__PURE__*/React.createElement("span", {
    className: "invalid-feedback"
  }, _feedback)) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "input-icon"
  }, position === "prepend" && /*#__PURE__*/React.createElement("span", {
    className: "input-icon-addon"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: icon
  })), /*#__PURE__*/React.createElement(Component, _extends({
    ref: ref
  }, allInputProps)), position === "append" && /*#__PURE__*/React.createElement("span", {
    className: "input-icon-addon"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: icon
  }))), _feedback && /*#__PURE__*/React.createElement("span", {
    className: "invalid-feedback"
  }, _feedback));

  return label ? /*#__PURE__*/React.createElement(FormGroup, {
    label: label
  }, _children) : _children;
});

function FormStaticText(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/React.createElement(El.Div, _extends({
    classNames: "form-control-plaintext"
  }, rest), children);
}

function FormTextarea(_ref) {
  var className = _ref.className,
      valid = _ref.valid,
      tick = _ref.tick,
      invalid = _ref.invalid,
      cross = _ref.cross,
      error = _ref.error,
      children = _ref.children,
      label = _ref.label,
      feedback = _ref.feedback,
      rest = _objectWithoutProperties(_ref, ["className", "valid", "tick", "invalid", "cross", "error", "children", "label", "feedback"]);

  var classes = classnames("form-control", {
    "is-valid": valid,
    "state-valid": tick,
    "is-invalid": invalid || !!error,
    "state-invalid": cross || !!error
  }, className);

  var _feedback = error || feedback;

  if (children) {
    rest.value = children;
  }

  var contents = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(El.Textarea, _extends({
    className: classes
  }, rest)), _feedback && /*#__PURE__*/React.createElement("span", {
    className: "invalid-feedback"
  }, _feedback));
  return label ? /*#__PURE__*/React.createElement(FormGroup, {
    label: label
  }, contents) : contents;
}

function Grid(props) {
  return props.children;
}

Grid.Row = GridRow;
Grid.Col = GridCol;

function FormImageCheck(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/createElement(Grid.Row, _extends({
    g: "sm"
  }, rest), children);
}

function FormImageCheckItem(_ref) {
  var className = _ref.className,
      col = _ref.col,
      imageURL = _ref.imageURL,
      imgProps = _ref.imgProps,
      rest = _objectWithoutProperties(_ref, ["className", "col", "imageURL", "imgProps"]);

  return /*#__PURE__*/React.createElement(Grid.Col, _extends({
    className: className,
    col: 6,
    sm: 4
  }, col), /*#__PURE__*/React.createElement("label", {
    className: "imagecheck mb-4"
  }, /*#__PURE__*/React.createElement("input", _extends({
    name: "imagecheck",
    type: "checkbox",
    className: "imagecheck-input"
  }, rest)), /*#__PURE__*/React.createElement("figure", {
    className: "imagecheck-figure"
  }, /*#__PURE__*/React.createElement("img", _extends({
    src: imageURL,
    alt: "Select",
    className: "imagecheck-image"
  }, imgProps)))));
}

function FormColorCheck(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/createElement(Grid.Row, _extends({
    g: "sm"
  }, rest), children);
}

function FormColorCheckItem(_ref) {
  var className = _ref.className,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["className", "color"]);

  var classes = classnames(className);
  return /*#__PURE__*/React.createElement(Grid.Col, {
    col: "auto",
    className: classes
  }, /*#__PURE__*/React.createElement("label", {
    className: "colorinput"
  }, /*#__PURE__*/React.createElement("input", _extends({
    type: "checkbox",
    value: color,
    className: "colorinput-input"
  }, rest)), /*#__PURE__*/React.createElement("span", {
    className: "colorinput-color bg-".concat(color)
  })));
}

function FormInputGroupAppend(_ref) {
  var className = _ref.className,
      children = _ref.children;
  var classes = classnames("input-group-append", className);
  return /*#__PURE__*/React.createElement(El.Span, {
    className: classes
  }, children);
}

function FormInputGroupPrepend(_ref) {
  var className = _ref.className,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["className", "children"]);

  var classes = classnames("input-group-prepend", className);
  return /*#__PURE__*/React.createElement(El.Span, _extends({
    className: classes
  }, rest), children);
}

function FormInputGroup(_ref) {
  var className = _ref.className,
      append = _ref.append,
      prepend = _ref.prepend,
      RootComponent = _ref.RootComponent,
      as = _ref.as,
      inputProps = _ref.inputProps,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["className", "append", "prepend", "RootComponent", "as", "inputProps", "children"]);

  var classes = classnames({
    "input-group": true
  }, className);
  var Component = RootComponent || as || El.Div;

  var _children = inputProps ? /*#__PURE__*/React.createElement(FormInput, inputProps) : children;

  if (prepend === true) {
    return /*#__PURE__*/React.createElement(FormInputGroupPrepend, null, children);
  }

  if (append === true) {
    return /*#__PURE__*/React.createElement(FormInputGroupAppend, null, children);
  }

  return /*#__PURE__*/React.createElement(Component, _extends({
    className: classes
  }, rest), prepend && /*#__PURE__*/React.createElement(FormInputGroupPrepend, null, prepend), _children, append && /*#__PURE__*/React.createElement(FormInputGroupAppend, null, append));
}

function FormHelp(_ref) {
  var className = _ref.className,
      children = _ref.children;
      _ref.position;
      _ref.message;
      var rest = _objectWithoutProperties(_ref, ["className", "children", "position", "message"]);

  var classes = classnames("form-help", className);
  return /*#__PURE__*/React.createElement(El.Span, _extends({
    className: classes // dataContent={message}
    // dataToggle="popover"
    // dataPlacement={position}

  }, rest), children || "?");
}

function FormSelect(_ref) {
  var className = _ref.className,
      children = _ref.children,
      valid = _ref.valid,
      tick = _ref.tick,
      invalid = _ref.invalid,
      cross = _ref.cross,
      error = _ref.error,
      label = _ref.label,
      feedback = _ref.feedback,
      rest = _objectWithoutProperties(_ref, ["className", "children", "valid", "tick", "invalid", "cross", "error", "label", "feedback"]);

  var classes = classnames({
    "form-control": true,
    "custom-select": true,
    "is-valid": valid,
    "state-valid": tick,
    "is-invalid": invalid || !!error,
    "state-invalid": cross || !!error
  }, className);

  var _feedback = error || feedback;

  var _children = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(El.Select, _extends({
    className: classes
  }, rest), children), _feedback && /*#__PURE__*/React.createElement("span", {
    className: "invalid-feedback"
  }, _feedback));

  return label ? /*#__PURE__*/React.createElement(FormGroup, {
    label: label
  }, _children) : _children;
}

function FormFooter(_ref) {
  var className = _ref.className,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["className", "children"]);

  var classes = classnames("form-footer", className);
  return /*#__PURE__*/React.createElement(El.Div, _extends({
    className: classes
  }, rest), children);
}

var FormRatio = function FormRatio(_ref) {
  var className = _ref.className,
      onChange = _ref.onChange,
      defaultValue = _ref.defaultValue,
      value = _ref.value,
      rest = _objectWithoutProperties(_ref, ["className", "onChange", "defaultValue", "value"]);

  var _useState = useState(!onChange ? defaultValue : "0"),
      _useState2 = _slicedToArray(_useState, 2),
      internalValue = _useState2[0],
      setInternalValue = _useState2[1];

  var handleOnChange = function handleOnChange(e) {
    if (onChange) {
      onChange(e);
    } else {
      var _value2 = e.target.value;
      setInternalValue(_value2);
    }
  };

  var classes = classnames(className);

  var _value = onChange ? value : internalValue;

  return /*#__PURE__*/React.createElement(Grid.Row, {
    className: classes,
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Grid.Col, null, /*#__PURE__*/React.createElement(El.Input, _extends({
    type: "range",
    className: "form-control custom-range",
    onChange: handleOnChange,
    value: _value,
    step: 1
  }, rest))), /*#__PURE__*/React.createElement(Grid.Col, {
    col: "auto"
  }, /*#__PURE__*/React.createElement(El.Input, {
    type: "number",
    className: "form-control w-8",
    value: _value,
    onFocus: rest.onFocus,
    onBlur: rest.onBlur,
    readOnly: true
  })));
};

function FormFieldSet(_ref) {
  var className = _ref.className,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["className", "children"]);

  var classes = classnames("form-fieldset", className);
  return /*#__PURE__*/React.createElement(El.Fieldset, _extends({
    className: classes
  }, rest), children);
}

function FormRadio(_ref) {
  var className = _ref.className,
      label = _ref.label,
      isInline = _ref.isInline,
      rest = _objectWithoutProperties(_ref, ["className", "label", "isInline"]);

  var classes = classnames("custom-control custom-radio", {
    "custom-control-inline": isInline
  }, className);
  var inputComponent = /*#__PURE__*/React.createElement(FormInput, _extends({
    type: "radio",
    className: classes
  }, rest));
  return label ? /*#__PURE__*/React.createElement("label", {
    className: classes
  }, inputComponent, /*#__PURE__*/React.createElement("span", {
    className: "custom-control-label"
  }, label)) : inputComponent;
}

function FormCheckbox(_ref) {
  var className = _ref.className,
      label = _ref.label,
      isInline = _ref.isInline,
      rest = _objectWithoutProperties(_ref, ["className", "label", "isInline"]);

  var classes = classnames("custom-control custom-checkbox", {
    "custom-control-inline": isInline
  }, className);
  var inputComponent = /*#__PURE__*/React.createElement(FormInput, _extends({
    type: "checkbox",
    className: classes
  }, rest));
  return label ? /*#__PURE__*/React.createElement("label", {
    className: classes
  }, inputComponent, /*#__PURE__*/React.createElement("span", {
    className: "custom-control-label"
  }, label)) : inputComponent;
}

function FormSelectGroup(_ref) {
  var children = _ref.children,
      pills = _ref.pills,
      canSelectMultiple = _ref.canSelectMultiple,
      rest = _objectWithoutProperties(_ref, ["children", "pills", "canSelectMultiple"]);

  var classNames = {
    selectgroup: true,
    "w-100": true,
    "selectgroup-pills": pills
  };
  return /*#__PURE__*/React.createElement(El.Div, _extends({
    classNames: classNames
  }, rest), canSelectMultiple && children ? React.Children.map(children, function (itm) {
    return /*#__PURE__*/React.isValidElement(itm) ? /*#__PURE__*/React.cloneElement(itm, {
      type: "checkbox"
    }) : itm;
  }) : children);
}

function FormSelectGroupItem(_ref) {
  var className = _ref.className,
      label = _ref.label,
      icon = _ref.icon,
      type = _ref.type,
      rest = _objectWithoutProperties(_ref, ["className", "label", "icon", "type"]);

  var classes = classnames({
    "selectgroup-item": true
  }, className);
  var btnClasses = classnames("selectgroup-button", {
    "selectgroup-button-icon": icon
  });
  var outputLabel = icon ? /*#__PURE__*/React.createElement(Icon, {
    name: icon
  }) : label;
  return /*#__PURE__*/React.createElement("label", {
    className: classes
  }, type === "checkbox" ? /*#__PURE__*/React.createElement(El.Input, _extends({
    type: "checkbox",
    className: "selectgroup-input"
  }, rest)) : /*#__PURE__*/React.createElement(El.Input, _extends({
    type: "radio",
    className: "selectgroup-input"
  }, rest)), /*#__PURE__*/React.createElement("span", {
    className: btnClasses
  }, outputLabel));
}

var FormFileInput = function FormFileInput(_ref) {
  var onChange = _ref.onChange,
      className = _ref.className,
      _ref$label = _ref.label,
      labelFromProps = _ref$label === void 0 ? "Choose file" : _ref$label,
      rest = _objectWithoutProperties(_ref, ["onChange", "className", "label"]);

  var _useState = useState(""),
      _useState2 = _slicedToArray(_useState, 2),
      fileName = _useState2[0],
      setFileName = _useState2[1];

  var _handleOnChange = function _handleOnChange(event) {
    if (event.target.files) {
      setFileName(event.target.files[0].name);
    }

    if (onChange) {
      onChange(event);
    }
  };

  var classes = classnames("custom-file", className);
  var label = fileName || labelFromProps;
  return /*#__PURE__*/React.createElement("div", {
    className: classes
  }, /*#__PURE__*/React.createElement("input", _extends({
    type: "file",
    className: "custom-file-input",
    onChange: _handleOnChange
  }, rest)), /*#__PURE__*/React.createElement("label", {
    className: "custom-file-label",
    style: {
      whiteSpace: "nowrap",
      display: "block",
      overflow: "hidden"
    }
  }, label));
};

function FormToggleStack(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/React.createElement(El.Div, _extends({
    classNames: "custom-switches-stacked"
  }, rest), children);
}

function FormToggle(_ref) {
  var className = _ref.className,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "checkbox" : _ref$type,
      label = _ref.label,
      rest = _objectWithoutProperties(_ref, ["className", "type", "label"]);

  var classes = classnames("custom-switch", className);
  return /*#__PURE__*/React.createElement("label", {
    className: classes
  }, /*#__PURE__*/React.createElement("input", _extends({
    className: "custom-switch-input",
    type: type
  }, rest)), /*#__PURE__*/React.createElement("span", {
    className: "custom-switch-indicator"
  }), /*#__PURE__*/React.createElement("span", {
    className: "custom-switch-description"
  }, label));
}

function FormInputGroupText(_ref) {
  var className = _ref.className,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["className", "children"]);

  var classes = classnames("input-group-text", className);
  return /*#__PURE__*/React.createElement(El.Span, _extends({
    className: classes
  }, rest), children);
}

var reactTextMask = createCommonjsModule(function (module, exports) {
!function(e,t){module.exports=t(React);}(commonjsGlobal,function(e){return function(e){function t(n){if(r[n])return r[n].exports;var o=r[n]={exports:{},id:n,loaded:!1};return e[n].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var r={};return t.m=e,t.c=r,t.p="",t(0)}([function(e,t,r){function n(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var r={};for(var n in e)t.indexOf(n)>=0||Object.prototype.hasOwnProperty.call(e,n)&&(r[n]=e[n]);return r}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return !t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t);}Object.defineProperty(t,"__esModule",{value:!0}),t.conformToMask=void 0;var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n]);}return e},l=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n);}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),f=r(3);Object.defineProperty(t,"conformToMask",{enumerable:!0,get:function(){return n(f).default}});var c=r(11),p=n(c),d=r(9),h=n(d),v=r(5),y=n(v),m=r(2),b=function(e){function t(){var e;i(this,t);for(var r=arguments.length,n=Array(r),o=0;o<r;o++)n[o]=arguments[o];var u=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(n)));return u.setRef=u.setRef.bind(u),u.onBlur=u.onBlur.bind(u),u.onChange=u.onChange.bind(u),u}return u(t,e),l(t,[{key:"setRef",value:function(e){this.inputElement=e;}},{key:"initTextMask",value:function(){var e=this.props,t=this.props.value;this.textMaskInputElement=(0, y.default)(s({inputElement:this.inputElement},e)),this.textMaskInputElement.update(t);}},{key:"componentDidMount",value:function(){this.initTextMask();}},{key:"componentDidUpdate",value:function(e){var t=this.props,r=t.value,n=t.pipe,o=t.mask,i=t.guide,a=t.placeholderChar,u=t.showMask,s={guide:i,placeholderChar:a,showMask:u},l="function"==typeof n&&"function"==typeof e.pipe?n.toString()!==e.pipe.toString():(0, m.isNil)(n)&&!(0, m.isNil)(e.pipe)||!(0, m.isNil)(n)&&(0, m.isNil)(e.pipe),f=o.toString()!==e.mask.toString(),c=Object.keys(s).some(function(t){return s[t]!==e[t]})||f||l,p=r!==this.inputElement.value;(p||c)&&this.initTextMask();}},{key:"render",value:function e(){var t=this.props,e=t.render,r=o(t,["render"]);return delete r.mask,delete r.guide,delete r.pipe,delete r.placeholderChar,delete r.keepCharPositions,delete r.value,delete r.onBlur,delete r.onChange,delete r.showMask,e(this.setRef,s({onBlur:this.onBlur,onChange:this.onChange,defaultValue:this.props.value},r))}},{key:"onChange",value:function(e){this.textMaskInputElement.update(),"function"==typeof this.props.onChange&&this.props.onChange(e);}},{key:"onBlur",value:function(e){"function"==typeof this.props.onBlur&&this.props.onBlur(e);}}]),t}(p.default.PureComponent);t.default=b,b.propTypes={mask:h.default.oneOfType([h.default.array,h.default.func,h.default.bool,h.default.shape({mask:h.default.oneOfType([h.default.array,h.default.func]),pipe:h.default.func})]).isRequired,guide:h.default.bool,value:h.default.oneOfType([h.default.string,h.default.number]),pipe:h.default.func,placeholderChar:h.default.string,keepCharPositions:h.default.bool,showMask:h.default.bool},b.defaultProps={render:function(e,t){return p.default.createElement("input",s({ref:e},t))}};},function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.placeholderChar="_",t.strFunction="function";},function(e,t,r){function n(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:f,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:l.placeholderChar;if(!o(e))throw new Error("Text-mask:convertMaskToPlaceholder; The mask property must be an array.");if(e.indexOf(t)!==-1)throw new Error("Placeholder character must not be used as part of the mask. Please specify a character that is not present in your mask as your placeholder character.\n\n"+("The placeholder character that was received is: "+JSON.stringify(t)+"\n\n")+("The mask that was received is: "+JSON.stringify(e)));return e.map(function(e){return e instanceof RegExp?t:e}).join("")}function o(e){return Array.isArray&&Array.isArray(e)||e instanceof Array}function i(e){return "string"==typeof e||e instanceof String}function a(e){return "number"==typeof e&&void 0===e.length&&!isNaN(e)}function u(e){return "undefined"==typeof e||null===e}function s(e){for(var t=[],r=void 0;r=e.indexOf(c),r!==-1;)t.push(r),e.splice(r,1);return {maskWithoutCaretTraps:e,indexes:t}}Object.defineProperty(t,"__esModule",{value:!0}),t.convertMaskToPlaceholder=n,t.isArray=o,t.isString=i,t.isNumber=a,t.isNil=u,t.processCaretTraps=s;var l=r(1),f=[],c="[]";},function(e,t,r){function n(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:s,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:u,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};if(!(0, i.isArray)(t)){if(("undefined"==typeof t?"undefined":o(t))!==a.strFunction)throw new Error("Text-mask:conformToMask; The mask property must be an array.");t=t(e,r),t=(0, i.processCaretTraps)(t).maskWithoutCaretTraps;}var n=r.guide,l=void 0===n||n,f=r.previousConformedValue,c=void 0===f?s:f,p=r.placeholderChar,d=void 0===p?a.placeholderChar:p,h=r.placeholder,v=void 0===h?(0, i.convertMaskToPlaceholder)(t,d):h,y=r.currentCaretPosition,m=r.keepCharPositions,b=l===!1&&void 0!==c,g=e.length,k=c.length,C=v.length,O=t.length,T=g-k,P=T>0,x=y+(P?-T:0),w=x+Math.abs(T);if(m===!0&&!P){for(var S=s,_=x;_<w;_++)v[_]===d&&(S+=d);e=e.slice(0,x)+S+e.slice(x,g);}for(var M=e.split(s).map(function(e,t){return {char:e,isNew:t>=x&&t<w}}),j=g-1;j>=0;j--){var E=M[j].char;if(E!==d){var R=j>=x&&k===O;E===v[R?j-T:j]&&M.splice(j,1);}}var V=s,N=!1;e:for(var A=0;A<C;A++){var B=v[A];if(B===d){if(M.length>0)for(;M.length>0;){var I=M.shift(),F=I.char,q=I.isNew;if(F===d&&b!==!0){V+=d;continue e}if(t[A].test(F)){if(m===!0&&q!==!1&&c!==s&&l!==!1&&P){for(var D=M.length,L=null,W=0;W<D;W++){var J=M[W];if(J.char!==d&&J.isNew===!1)break;if(J.char===d){L=W;break}}null!==L?(V+=F,M.splice(L,1)):A--;}else V+=F;continue e}N=!0;}b===!1&&(V+=v.substr(A,C));break}V+=B;}if(b&&P===!1){for(var U=null,H=0;H<V.length;H++)v[H]===d&&(U=H);V=null!==U?V.substr(0,U+1):s;}return {conformedValue:V,meta:{someCharsRejected:N}}}Object.defineProperty(t,"__esModule",{value:!0});var o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.default=n;var i=r(2),a=r(1),u=[],s="";},function(e,t){function r(e){var t=e.previousConformedValue,r=void 0===t?o:t,i=e.previousPlaceholder,a=void 0===i?o:i,u=e.currentCaretPosition,s=void 0===u?0:u,l=e.conformedValue,f=e.rawValue,c=e.placeholderChar,p=e.placeholder,d=e.indexesOfPipedChars,h=void 0===d?n:d,v=e.caretTrapIndexes,y=void 0===v?n:v;if(0===s||!f.length)return 0;var m=f.length,b=r.length,g=p.length,k=l.length,C=m-b,O=C>0,T=0===b,P=C>1&&!O&&!T;if(P)return s;var x=O&&(r===l||l===p),w=0,S=void 0,_=void 0;if(x)w=s-C;else {var M=l.toLowerCase(),j=f.toLowerCase(),E=j.substr(0,s).split(o),R=E.filter(function(e){return M.indexOf(e)!==-1});_=R[R.length-1];var V=a.substr(0,R.length).split(o).filter(function(e){return e!==c}).length,N=p.substr(0,R.length).split(o).filter(function(e){return e!==c}).length,A=N!==V,B=void 0!==a[R.length-1]&&void 0!==p[R.length-2]&&a[R.length-1]!==c&&a[R.length-1]!==p[R.length-1]&&a[R.length-1]===p[R.length-2];!O&&(A||B)&&V>0&&p.indexOf(_)>-1&&void 0!==f[s]&&(S=!0,_=f[s]);for(var I=h.map(function(e){return M[e]}),F=I.filter(function(e){return e===_}).length,q=R.filter(function(e){return e===_}).length,D=p.substr(0,p.indexOf(c)).split(o).filter(function(e,t){return e===_&&f[t]!==e}).length,L=D+q+F+(S?1:0),W=0,J=0;J<k;J++){var U=M[J];if(w=J+1,U===_&&W++,W>=L)break}}if(O){for(var H=w,Y=w;Y<=g;Y++)if(p[Y]===c&&(H=Y),p[Y]===c||y.indexOf(Y)!==-1||Y===g)return H}else if(S){for(var z=w-1;z>=0;z--)if(l[z]===_||y.indexOf(z)!==-1||0===z)return z}else for(var G=w;G>=0;G--)if(p[G-1]===c||y.indexOf(G)!==-1||0===G)return G}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r;var n=[],o="";},function(e,t,r){function n(e){return e&&e.__esModule?e:{default:e}}function o(e){var t={previousConformedValue:void 0,previousPlaceholder:void 0};return {state:t,update:function(r){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:e,o=n.inputElement,l=n.mask,c=n.guide,y=n.pipe,b=n.placeholderChar,g=void 0===b?h.placeholderChar:b,k=n.keepCharPositions,C=void 0!==k&&k,O=n.showMask,T=void 0!==O&&O;if("undefined"==typeof r&&(r=o.value),r!==t.previousConformedValue){("undefined"==typeof l?"undefined":s(l))===m&&void 0!==l.pipe&&void 0!==l.mask&&(y=l.pipe,l=l.mask);var P=void 0,x=void 0;if(l instanceof Array&&(P=(0, d.convertMaskToPlaceholder)(l,g)),l!==!1){var w=a(r),S=o.selectionEnd,_=t.previousConformedValue,M=t.previousPlaceholder,j=void 0;if(("undefined"==typeof l?"undefined":s(l))===h.strFunction){if(x=l(w,{currentCaretPosition:S,previousConformedValue:_,placeholderChar:g}),x===!1)return;var E=(0, d.processCaretTraps)(x),R=E.maskWithoutCaretTraps,V=E.indexes;x=R,j=V,P=(0, d.convertMaskToPlaceholder)(x,g);}else x=l;var N={previousConformedValue:_,guide:c,placeholderChar:g,pipe:y,placeholder:P,currentCaretPosition:S,keepCharPositions:C},A=(0, p.default)(w,x,N),B=A.conformedValue,I=("undefined"==typeof y?"undefined":s(y))===h.strFunction,F={};I&&(F=y(B,u({rawValue:w},N)),F===!1?F={value:_,rejected:!0}:(0, d.isString)(F)&&(F={value:F}));var q=I?F.value:B,D=(0, f.default)({previousConformedValue:_,previousPlaceholder:M,conformedValue:q,placeholder:P,rawValue:w,currentCaretPosition:S,placeholderChar:g,indexesOfPipedChars:F.indexesOfPipedChars,caretTrapIndexes:j}),L=q===P&&0===D,W=T?P:v,J=L?W:q;t.previousConformedValue=J,t.previousPlaceholder=P,o.value!==J&&(o.value=J,i(o,D));}}}}}function i(e,t){document.activeElement===e&&(b?g(function(){return e.setSelectionRange(t,t,y)},0):e.setSelectionRange(t,t,y));}function a(e){if((0, d.isString)(e))return e;if((0, d.isNumber)(e))return String(e);if(void 0===e||null===e)return v;throw new Error("The 'value' provided to Text Mask needs to be a string or a number. The value received was:\n\n "+JSON.stringify(e))}Object.defineProperty(t,"__esModule",{value:!0});var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n]);}return e},s="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.default=o;var l=r(4),f=n(l),c=r(3),p=n(c),d=r(2),h=r(1),v="",y="none",m="object",b="undefined"!=typeof navigator&&/Android/i.test(navigator.userAgent),g="undefined"!=typeof requestAnimationFrame?requestAnimationFrame:setTimeout;},function(e,t){function r(e){return function(){return e}}var n=function(){};n.thatReturns=r,n.thatReturnsFalse=r(!1),n.thatReturnsTrue=r(!0),n.thatReturnsNull=r(null),n.thatReturnsThis=function(){return this},n.thatReturnsArgument=function(e){return e},e.exports=n;},function(e,t,r){function n(e,t,r,n,i,a,u,s){if(!e){var l;if(void 0===t)l=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {var f=[r,n,i,a,u,s],c=0;l=new Error(t.replace(/%s/g,function(){return f[c++]})),l.name="Invariant Violation";}throw l.framesToPop=1,l}}e.exports=n;},function(e,t,r){var n=r(6),o=r(7),i=r(10);e.exports=function(){function e(e,t,r,n,a,u){u!==i&&o(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");}function t(){return e}e.isRequired=e;var r={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t};return r.checkPropTypes=n,r.PropTypes=r,r};},function(e,t,r){e.exports=r(8)();},function(e,t){var r="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";e.exports=r;},function(t,r){t.exports=e;}])});
});

var MaskedInput = /*@__PURE__*/getDefaultExportFromCjs(reactTextMask);

function parseValue(property, value) {
  var _classes;

  if (typeof value === "undefined") {
    return undefined;
  }

  if (typeof value === "number" || typeof value === "string") {
    return "".concat(property, "-").concat(value);
  }

  var xs = value.xs,
      sm = value.sm,
      md = value.md,
      lg = value.lg,
      xl = value.xl;
  var classes = (_classes = {}, _defineProperty(_classes, "".concat(property, "-").concat(xs), xs), _defineProperty(_classes, "".concat(property, "-sm-").concat(sm), sm), _defineProperty(_classes, "".concat(property, "-md-").concat(md), md), _defineProperty(_classes, "".concat(property, "-lg-").concat(lg), lg), _defineProperty(_classes, "".concat(property, "-xl-").concat(xl), xl), _classes);
  return classes;
}

var utilityBrekapointPropsKeys = ["d", "m", "mt", "mb", "ml", "mr", "mx", "my", "p", "pt", "pb", "pl", "pr", "px", "py"];
var utilityPropsKeys = ["d", "m", "mt", "mb", "ml", "mr", "mx", "my", "p", "pt", "pb", "pl", "pr", "px", "py"];
var getUtilityPropsClasses = function getUtilityPropsClasses(props) {
  var utilityBreakpointPropsClasses = utilityBrekapointPropsKeys.reduce(function (acc, cur) {
    if (typeof props[cur] !== "undefined") {
      acc.push(parseValue(cur, props[cur]));
    }

    return acc;
  }, []);
  utilityPropsKeys.reduce(function (acc, cur) {
    if (props[cur]) {
      acc.push(parseValue(cur, props[cur]));
    }

    return acc;
  }, []);
  return utilityBreakpointPropsClasses;
};

/**
 * A masked input field using react-text-mask
 */
function FormMaskedInput(_ref) {
  var valid = _ref.valid,
      tick = _ref.tick,
      invalid = _ref.invalid,
      cross = _ref.cross,
      feedback = _ref.feedback,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, ["valid", "tick", "invalid", "cross", "feedback", "className"]);

  var utilityClasses = getUtilityPropsClasses(rest);
  var classes = classnames(utilityClasses, {
    "form-control": true,
    "is-valid": valid,
    "state-valid": tick,
    "is-invalid": invalid,
    "state-invalid": cross
  }, className);
  return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(MaskedInput, _extends({
    className: classes
  }, rest)), feedback && (invalid || cross) && /*#__PURE__*/createElement("span", {
    className: "invalid-feedback"
  }, feedback));
}

/**
 * A simple date picker using 3 FormSelect's.
 */
var FormDatePicker = function FormDatePicker(_ref) {
  var onChange = _ref.onChange,
      monthLabels = _ref.monthLabels,
      minYear = _ref.minYear,
      maxYear = _ref.maxYear,
      format = _ref.format,
      className = _ref.className,
      dayProps = _ref.dayProps,
      monthProps = _ref.monthProps,
      yearProps = _ref.yearProps,
      value = _ref.value,
      defaultDate = _ref.defaultDate,
      rest = _objectWithoutProperties(_ref, ["onChange", "monthLabels", "minYear", "maxYear", "format", "className", "dayProps", "monthProps", "yearProps", "value", "defaultDate"]);

  var _useState = useState(_typeof(value) !== undefined ? value : defaultDate || new Date(Date.now())),
      _useState2 = _slicedToArray(_useState, 2),
      currentDate = _useState2[0],
      setCurrentDate = _useState2[1];

  useEffect(function () {
    if (value && currentDate !== value) {
      setCurrentDate(value);
    }
  }, []); // Handle date changes

  var _handleOnChange = function _handleOnChange(type, value) {
    var newDate = new Date(currentDate || Date.now()); // Change month

    if (type === "mm") {
      newDate.setMonth(value);
    } // Change day


    if (type === "dd") {
      newDate.setDate(value);
    }

    if (type === "yyyy") {
      newDate.setFullYear(value);
    }

    setCurrentDate(newDate);

    if (onChange) {
      onChange(newDate);
    }
  }; // Creates an array with numeric values from start to end


  var _range = function _range(start, end) {
    return Array.from({
      length: end + 1 - start
    }, function (_, k) {
      return k + start;
    });
  }; // Renders the months select


  var _renderMonths = function _renderMonths() {
    var onChangeMonths = function onChangeMonths(e) {
      return _handleOnChange("mm", Number(e.target.value));
    };

    return /*#__PURE__*/React.createElement(FormSelect, _extends({
      key: "month",
      value: currentDate ? currentDate.getUTCMonth() : "",
      onChange: onChangeMonths
    }, monthProps), /*#__PURE__*/React.createElement("option", {
      value: ""
    }), monthLabels.map(function (name, index) {
      return /*#__PURE__*/React.createElement("option", {
        key: index,
        value: index
      }, name);
    }));
  }; // Renders the days select


  var _renderDays = function _renderDays() {
    var currentMonthDays = currentDate && new Date(currentDate.getUTCFullYear(), currentDate.getUTCMonth() + 1, 0).getDate();
    var daysRange = currentMonthDays ? _range(1, currentMonthDays) : [];
    var currentDay = currentDate && currentDate.getUTCDate();

    var onChangeDays = function onChangeDays(e) {
      return _handleOnChange("dd", Number(e.target.value));
    };

    return /*#__PURE__*/React.createElement(FormSelect, _extends({
      key: "dd",
      value: currentDay || "",
      onChange: onChangeDays
    }, dayProps), /*#__PURE__*/React.createElement("option", {
      value: ""
    }), daysRange.map(function (day) {
      return /*#__PURE__*/React.createElement("option", {
        key: day,
        value: day
      }, day);
    }));
  }; // renderes the years select


  var _renderYears = function _renderYears() {
    var yearsRange = _range(minYear, maxYear).reverse();

    var currentYear = currentDate && currentDate.getUTCFullYear();

    var onChangeYears = function onChangeYears(e) {
      return _handleOnChange("yyyy", Number(e.target.value));
    };

    return /*#__PURE__*/React.createElement(FormSelect, _extends({
      key: "yy",
      onChange: onChangeYears,
      value: currentYear || ""
    }, yearProps), /*#__PURE__*/React.createElement("option", {
      value: ""
    }), yearsRange.map(function (year) {
      return /*#__PURE__*/React.createElement("option", {
        key: year,
        value: year
      }, year);
    }));
  };

  var formatSplit = format.split("/");
  var dateComponents = {
    mm: _renderMonths(),
    dd: _renderDays(),
    yyyy: _renderYears()
  };
  return /*#__PURE__*/React.createElement(El.Div, _extends({
    className: className
  }, rest), /*#__PURE__*/React.createElement(FormInputGroup, null, formatSplit.map(function (type) {
    return dateComponents[type];
  })));
};

FormDatePicker.defaultProps = {
  monthLabels: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  minYear: 1897,
  maxYear: new Date().getFullYear(),
  format: "mm/dd/yyyy",
  defaultDate: new Date()
};

var CompoundForm = Form;
CompoundForm.Group = FormGroup;
CompoundForm.Label = FormLabel;
CompoundForm.Input = FormInput;
CompoundForm.StaticText = FormStaticText;
CompoundForm.Textarea = FormTextarea;
CompoundForm.ImageCheck = FormImageCheck;
CompoundForm.ImageCheckItem = FormImageCheckItem;
CompoundForm.ColorCheck = FormColorCheck;
CompoundForm.ColorCheckItem = FormColorCheckItem;
CompoundForm.InputGroup = FormInputGroup;
CompoundForm.Help = FormHelp;
CompoundForm.Select = FormSelect;
CompoundForm.Footer = FormFooter;
CompoundForm.Ratio = FormRatio;
CompoundForm.FieldSet = FormFieldSet;
CompoundForm.SelectGroup = FormSelectGroup;
CompoundForm.SelectGroupItem = FormSelectGroupItem;
CompoundForm.Radio = FormRadio;
CompoundForm.Checkbox = FormCheckbox;
CompoundForm.FileInput = FormFileInput;
CompoundForm.SwitchStack = FormToggleStack;
CompoundForm.Switch = FormToggle;
CompoundForm.InputGroupAppend = FormInputGroupAppend;
CompoundForm.InputGroupPrepend = FormInputGroupPrepend;
CompoundForm.InputGroupText = FormInputGroupText;
CompoundForm.MaskedInput = FormMaskedInput;
CompoundForm.DatePicker = FormDatePicker;

/**
 * A form containing a single input field with an appended Button
 */
function FormWithSingleInputAndButton(_ref) {
  var formProps = _ref.formProps,
      inputProps = _ref.inputProps,
      buttonProps = _ref.buttonProps;
  var button = /*#__PURE__*/createElement(CompoundButton, buttonProps);
  return /*#__PURE__*/createElement(CompoundForm, formProps, /*#__PURE__*/createElement(CompoundForm.InputGroup, {
    inputProps: inputProps,
    append: button
  }));
}

function CommentsCard(_ref) {
  var className = _ref.className,
      children = _ref.children;
  var classes = classnames(className);
  return /*#__PURE__*/createElement(CompoundCard, {
    className: classes
  }, /*#__PURE__*/createElement(CompoundCard.Header, null, /*#__PURE__*/createElement(FormWithSingleInputAndButton, {
    inputProps: {
      placeholder: "Message"
    },
    buttonProps: {
      icon: "camera",
      color: "secondary"
    }
  }), /*#__PURE__*/createElement(Comment, null, children)));
}

/**
 * Renders a Card designed for displaying details of a person or business
 */
function ContactCard(_ref) {
  var children = _ref.children,
      className = _ref.className,
      cardTitle = _ref.cardTitle,
      map = _ref.map,
      mapPlaceholder = _ref.mapPlaceholder,
      rounded = _ref.rounded,
      avatar = _ref.avatar,
      objectURL = _ref.objectURL,
      alt = _ref.alt,
      name = _ref.name,
      address = _ref.address,
      details = _ref.details,
      description = _ref.description;
  var cardClassName = classnames(className);
  return /*#__PURE__*/createElement(CompoundCard, {
    className: cardClassName,
    title: cardTitle
  }, (mapPlaceholder || map) && /*#__PURE__*/createElement(CompoundCard.Map, {
    placeholder: mapPlaceholder
  }, map), /*#__PURE__*/createElement(CompoundCard.Body, null, /*#__PURE__*/createElement(CompoundMedia, {
    className: "mb-5"
  }, /*#__PURE__*/createElement(CompoundMedia.Object, {
    size: "md",
    className: "mr-4",
    avatar: avatar,
    rounded: rounded,
    objectURL: objectURL,
    alt: alt
  }), /*#__PURE__*/createElement(CompoundMedia.Body, null, name && /*#__PURE__*/createElement(CompoundHeader.H5, null, name), address && /*#__PURE__*/createElement("address", {
    className: "text-muted small"
  }, address.line1, address.line2 && /*#__PURE__*/createElement("br", null), address.line2))), details && /*#__PURE__*/createElement(Grid.Row, null, details.map(function (d, i) {
    return /*#__PURE__*/createElement(Grid.Col, {
      col: 6,
      key: i
    }, /*#__PURE__*/createElement(CompoundHeader.H6, null, d.title), /*#__PURE__*/createElement("p", null, d.content));
  })), description && /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(CompoundHeader.H6, null, typeof description === "string" ? "Description" : description.title), /*#__PURE__*/createElement("p", null, typeof description === "string" ? description : description.content)), children));
}

function Loader(_ref) {
  var className = _ref.className,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["className", "children"]);

  var classes = classnames({
    loader: true
  }, className);
  return /*#__PURE__*/createElement(El.Div, _extends({
    className: classes
  }, rest), children);
}

function DimmerContent(_ref) {
  var className = _ref.className,
      children = _ref.children;
  var classes = classnames({
    "dimmer-content": true
  }, className);
  return /*#__PURE__*/createElement("div", {
    className: classes
  }, children);
}

function Dimmer(_ref) {
  var className = _ref.className,
      children = _ref.children,
      active = _ref.active,
      loader = _ref.loader;
  var classes = classnames({
    dimmer: true,
    active: active
  }, className);
  return /*#__PURE__*/createElement("div", {
    className: classes
  }, /*#__PURE__*/createElement(Fragment, null, loader && /*#__PURE__*/createElement(Loader, null), /*#__PURE__*/createElement(DimmerContent, null, children)));
}

Dimmer.Content = DimmerContent;

// GalleryCardDetails Component

function GalleryCardDetails(_ref) {
  _ref.className;
      var children = _ref.children,
      avatarURL = _ref.avatarURL,
      fullName = _ref.fullName,
      dateString = _ref.dateString;
  //classes
  var avatarClasses = classnames("mr-3");
  var dateStringClasses = classnames("d-block text-muted"); //conditions

  var hasOtherDetails = fullName !== null || dateString !== null; //components

  var avatar = /*#__PURE__*/createElement(Avatar, {
    imageURL: avatarURL,
    size: "md",
    className: avatarClasses
  }); // TODO: The following could be a seperate component

  var otherDetails = /*#__PURE__*/createElement("div", null, /*#__PURE__*/createElement("div", null, fullName), /*#__PURE__*/createElement("small", {
    className: dateStringClasses
  }, " ", dateString), " ");
  return /*#__PURE__*/createElement(Fragment, null, avatarURL && avatar, hasOtherDetails && otherDetails, children);
}

function GalleryCardFooter(_ref) {
  var children = _ref.children;
  var classes = classnames("d-flex", "align-items-center", "px-2");
  return /*#__PURE__*/createElement("div", {
    className: classes
  }, children);
}

function GalleryCardIconGroup(_ref) {
  var children = _ref.children,
      className = _ref.className;
  var classes = classnames("ml-auto", "text-muted", className);
  return /*#__PURE__*/createElement("div", {
    className: classes
  }, children);
}

function GalleryCardIconItem(_ref) {
  var className = _ref.className,
      label = _ref.label,
      name = _ref.name,
      href = _ref.href,
      right = _ref.right,
      to = _ref.to,
      RootComponent = _ref.RootComponent;
  var positionRightClasses = "d-none d-md-inline-block ml-3";
  var componentClasses = !right ? classnames("icon", className) : classnames("icon", positionRightClasses, className);
  var iconClasses = classnames("mr-1");
  var childrenForAll = /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(Icon, {
    name: name,
    className: iconClasses
  }), label);
  var extraProps = {
    href: undefined
  };

  if (href) {
    extraProps.href = href;
  }

  return RootComponent ? /*#__PURE__*/createElement(RootComponent, {
    className: componentClasses,
    to: to
  }, childrenForAll) : /*#__PURE__*/createElement("a", _extends({
    className: componentClasses
  }, extraProps), childrenForAll);
}

function GalleryCardImage(_ref) {
  var src = _ref.src,
      alt = _ref.alt,
      href = _ref.href,
      _ref$rounded = _ref.rounded,
      rounded = _ref$rounded === void 0 ? true : _ref$rounded,
      className = _ref.className,
      to = _ref.to,
      RootComponent = _ref.RootComponent;
  var componentClasses = classnames("mb-3");
  var imageClasses = classnames({
    rounded: rounded
  }, className);
  var componentOptionalProps = {
    href: undefined
  };

  if (href) {
    componentOptionalProps.href = href;
  }

  var image = /*#__PURE__*/createElement("img", {
    src: src,
    alt: alt,
    className: imageClasses
  });
  return RootComponent ? /*#__PURE__*/createElement(RootComponent, {
    className: componentClasses,
    to: to
  }, image) : /*#__PURE__*/createElement("a", _extends({
    className: componentClasses
  }, componentOptionalProps), image);
}

function GalleryCard(_ref) {
  var children = _ref.children,
      className = _ref.className;
  var cardClassName = classnames("p-3", className);
  return /*#__PURE__*/createElement(CompoundCard, {
    className: cardClassName
  }, children);
}

GalleryCard.Details = GalleryCardDetails;
GalleryCard.Footer = GalleryCardFooter;
GalleryCard.IconGroup = GalleryCardIconGroup;
GalleryCard.IconItem = GalleryCardIconItem;
GalleryCard.Image = GalleryCardImage;

var PageTitle = createTablerElement(Header, {
  displayName: "PageTitle",
  classNames: function classNames() {
    return ["page-title"];
  }
});

var PageSubTitle = createTablerElement(Header, {
  displayName: "PageSubTitle",
  classNames: function classNames() {
    return ["page-subtitle"];
  }
});

function PageOptions(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/createElement("div", {
    className: "page-options d-flex"
  }, children);
}

function PageHeader(_ref) {
  var children = _ref.children,
      title = _ref.title,
      preTitle = _ref.preTitle,
      subTitle = _ref.subTitle,
      icon = _ref.icon,
      actions = _ref.actions,
      breadcrumb = _ref.breadcrumb,
      options = _ref.options,
      rest = _objectWithoutProperties(_ref, ["children", "title", "preTitle", "subTitle", "icon", "actions", "breadcrumb", "options"]);

  return /*#__PURE__*/createElement(El.Div, _extends({
    className: "page-header"
  }, rest), /*#__PURE__*/createElement(GridRow, {
    alignItems: "center"
  }, icon && /*#__PURE__*/createElement(GridCol, {
    col: "auto"
  }, icon), /*#__PURE__*/createElement(GridCol, null, breadcrumb && /*#__PURE__*/createElement("div", {
    className: "mb-1"
  }, breadcrumb), preTitle && /*#__PURE__*/createElement("div", {
    className: "page-pretitle"
  }, preTitle), title && /*#__PURE__*/createElement(PageTitle, null, title), subTitle && /*#__PURE__*/createElement(PageSubTitle, null, subTitle), options && /*#__PURE__*/createElement(PageOptions, null, options), children), actions && /*#__PURE__*/createElement(GridCol, {
    col: "auto",
    ms: "auto"
  }, actions)));
}

function PageContent(_ref) {
  var className = _ref.className,
      children = _ref.children,
      title = _ref.title,
      subTitle = _ref.subTitle,
      preTitle = _ref.preTitle,
      options = _ref.options,
      footer = _ref.footer,
      actions = _ref.actions,
      contentContainerProps = _ref.contentContainerProps;
  var classes = classnames("page-content", className);
  return /*#__PURE__*/createElement("div", {
    className: classes
  }, /*#__PURE__*/createElement(Container, _extends({
    size: "xl"
  }, contentContainerProps), (title || preTitle || subTitle || actions) && /*#__PURE__*/createElement(PageHeader, {
    title: title,
    subTitle: subTitle,
    preTitle: preTitle,
    actions: actions,
    options: options
  }), children), footer);
}

function Page(_ref) {
  var className = _ref.className,
      navbar = _ref.navbar,
      footer = _ref.footer,
      title = _ref.title,
      preTitle = _ref.preTitle,
      subTitle = _ref.subTitle,
      actions = _ref.actions,
      contentContainerProps = _ref.contentContainerProps,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["className", "navbar", "footer", "title", "preTitle", "subTitle", "actions", "contentContainerProps", "children"]);

  var classes = classnames("page", className);
  return /*#__PURE__*/React.createElement(El.Div, _extends({
    className: classes
  }, rest), navbar, /*#__PURE__*/React.createElement(PageContent, {
    title: title,
    subTitle: subTitle,
    preTitle: preTitle,
    actions: actions,
    contentContainerProps: contentContainerProps
  }, children), footer);
}

function PageMain(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/createElement("div", {
    className: "page-main flex-fill d-flex flex-column max-w-full"
  }, children);
}

// @flow

function PageContentWithSidebar(_ref) {
  var children = _ref.children,
      header = _ref.header,
      sidebar = _ref.sidebar;
  return /*#__PURE__*/createElement(PageContent, null, header, /*#__PURE__*/createElement(Grid.Row, null, /*#__PURE__*/createElement(Grid.Col, {
    lg: 3,
    className: "order-lg-1 mb-4"
  }, sidebar), /*#__PURE__*/createElement(Grid.Col, {
    lg: 9
  }, children)));
}

function PageCard(_ref) {
  var children = _ref.children,
      title = _ref.title,
      header = _ref.header,
      footer = _ref.footer,
      RootComponent = _ref.RootComponent;
  return /*#__PURE__*/createElement("div", {
    className: "my-3 my-md-5"
  }, /*#__PURE__*/createElement(Container, null, /*#__PURE__*/createElement(Grid.Row, null, /*#__PURE__*/createElement(Grid.Col, {
    col: 12
  }, /*#__PURE__*/createElement(CompoundCard, {
    RootComponent: RootComponent
  }, title && /*#__PURE__*/createElement(CompoundCard.Header, null, /*#__PURE__*/createElement(CompoundCard.Title, null, title)), header, /*#__PURE__*/createElement(CompoundCard.Body, null, children), footer)))));
}

// @flow

function PageMapHeader(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/createElement("div", {
    className: "map-header"
  }, children);
}

var CompoundPage = Object.assign(Page, {
  Main: PageMain,
  Content: PageContent,
  Header: PageHeader,
  ContentWithSidebar: PageContentWithSidebar,
  Card: PageCard,
  Title: PageTitle,
  MapHeader: PageMapHeader
});

function PricingCardCategory(_ref) {
  var className = _ref.className,
      children = _ref.children;
  var classes = classnames("card-category", className);
  return /*#__PURE__*/createElement("div", {
    className: classes
  }, children);
}

function PricingCardPrice(_ref) {
  var className = _ref.className,
      children = _ref.children;
  var classes = classnames("display-3 my-4", className);
  return /*#__PURE__*/createElement("div", {
    className: classes
  }, children);
}

function PricingCardAttributeList(_ref) {
  var className = _ref.className,
      children = _ref.children;
  var classes = classnames("list-unstyled", "leading-loose", className);
  return /*#__PURE__*/createElement("ul", {
    className: classes
  }, children);
}

function PricingCardAttributeItem(_ref) {
  var children = _ref.children,
      available = _ref.available,
      hasIcon = _ref.hasIcon;
  var iconClasses = available ? classnames("text-success", "mr-2") : classnames("text-danger", "mr-2");
  return hasIcon ? /*#__PURE__*/createElement("li", null, " ", /*#__PURE__*/createElement(Icon, {
    prefix: "fe",
    name: available ? "check" : "x",
    className: iconClasses,
    isAriaHidden: true
  }), children) : /*#__PURE__*/createElement("li", null, " ", children, " ");
}

// TODO : Add  color prop

function PricingCardButton(_ref) {
  var className = _ref.className,
      children = _ref.children,
      RootComponent = _ref.RootComponent,
      active = _ref.active,
      href = _ref.href,
      to = _ref.to,
      onClick = _ref.onClick;
  var classes = classnames("text-center", "mt-6");
  var Component = RootComponent || "a";
  var componentClasses = classnames("btn", active ? "btn-green" : "btn-secondary", "btn-block", className);
  var otherProps = {
    href: undefined,
    to: undefined,
    role: undefined,
    onClick: undefined
  };

  if (href) {
    otherProps.href = href;
  }

  if (to) {
    otherProps.to = to;
  }

  if (onClick) {
    otherProps.role = "button";
    otherProps.onClick = onClick;
  }

  return /*#__PURE__*/createElement("div", {
    className: classes
  }, /*#__PURE__*/createElement(Component, _extends({
    className: componentClasses
  }, otherProps), children));
}

function PricingCard(_ref) {
  _ref.className;
      var children = _ref.children,
      _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      category = _ref.category;
  var cardBodyClassName = classnames("text-center");
  var cardStatusClassName = classnames("card-status", "bg-green");
  var cardStatus = /*#__PURE__*/createElement("div", {
    className: cardStatusClassName
  });
  var cardCategory = /*#__PURE__*/createElement(PricingCardCategory, null, category); // TODO: Add component logic.

  return /*#__PURE__*/createElement(CompoundCard, null, active && cardStatus, /*#__PURE__*/createElement(CompoundCard.Body, {
    className: cardBodyClassName
  }, category && cardCategory, children));
}

PricingCard.Category = PricingCardCategory;
PricingCard.Price = PricingCardPrice;
PricingCard.AttributeList = PricingCardAttributeList;
PricingCard.AttributeItem = PricingCardAttributeItem;
PricingCard.Button = PricingCardButton;

function ProfileImage(_ref) {
  var avatarURL = _ref.avatarURL;
  return /*#__PURE__*/createElement("img", {
    className: "card-profile-img",
    alt: "Profile",
    src: avatarURL
  });
}

function Profile(_ref) {
  var className = _ref.className,
      children = _ref.children,
      name = _ref.name,
      _ref$avatarURL = _ref.avatarURL,
      avatarURL = _ref$avatarURL === void 0 ? "" : _ref$avatarURL;
      _ref.twitterURL;
      var _ref$backgroundURL = _ref.backgroundURL,
      backgroundURL = _ref$backgroundURL === void 0 ? "" : _ref$backgroundURL,
      bio = _ref.bio;
  var classes = classnames("cardwidth-profile", className);
  return /*#__PURE__*/createElement(CompoundCard, {
    className: classes,
    imageTop: backgroundURL
  }, /*#__PURE__*/createElement(CompoundCard.Body, {
    className: "text-center"
  }, /*#__PURE__*/createElement(ProfileImage, {
    avatarURL: avatarURL
  }), /*#__PURE__*/createElement(CompoundHeader.H3, {
    className: "mb-3"
  }, name), /*#__PURE__*/createElement("p", {
    className: "mb-4"
  }, bio || children), /*#__PURE__*/createElement(SocialNetworksList, {
    itemsObjects: [{
      name: "twitter",
      label: "Follow"
    }],
    prefix: "fa",
    asButtons: true
  })));
}

Profile.Image = ProfileImage;

function ProgressBar(_ref) {
  var className = _ref.className,
      color = _ref.color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 0 : _ref$width,
      style = _ref.style,
      rest = _objectWithoutProperties(_ref, ["className", "color", "width", "style"]);

  var classes = classnames("progress-bar", _defineProperty({}, "bg-".concat(color), !!color), className);
  return /*#__PURE__*/createElement(El.Div, _extends({
    className: classes,
    style: _objectSpread2({
      width: "".concat(width, "%")
    }, style)
  }, rest));
}

function Progress(_ref) {
  var className = _ref.className,
      children = _ref.children,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "" : _ref$size,
      rest = _objectWithoutProperties(_ref, ["className", "children", "size"]);

  var classes = classnames("progress", _defineProperty({}, "progress-".concat(size), !!size), className);
  return /*#__PURE__*/createElement(El.Div, _extends({
    className: classes
  }, rest), children);
}

Progress.Bar = ProgressBar;

function ProgressCard(_ref) {
  var className = _ref.className,
      header = _ref.header,
      content = _ref.content,
      progressColor = _ref.progressColor,
      progressWidth = _ref.progressWidth;
  var classes = classnames(className);
  return /*#__PURE__*/createElement(CompoundCard, {
    className: classes
  }, /*#__PURE__*/createElement(CompoundCard.Body, {
    className: "text-center"
  }, /*#__PURE__*/createElement(CompoundHeader, {
    size: 5
  }, header), /*#__PURE__*/createElement("div", {
    className: "display-4 font-weight-bold mb-4"
  }, content), /*#__PURE__*/createElement(Progress, {
    size: "sm"
  }, /*#__PURE__*/createElement(Progress.Bar, {
    color: progressColor,
    width: progressWidth
  }))));
}

function Ribbon(_ref) {
  var _cn;

  var children = _ref.children,
      className = _ref.className,
      color = _ref.color,
      icon = _ref.icon,
      bookmark = _ref.bookmark,
      position = _ref.position,
      rest = _objectWithoutProperties(_ref, ["children", "className", "color", "icon", "bookmark", "position"]);

  var _className = classnames("ribbon", (_cn = {}, _defineProperty(_cn, "bg-".concat(color), color), _defineProperty(_cn, "ribbon-bookmark", bookmark), _defineProperty(_cn, "ribbon-top", position && position.substr(0, 3) === "top"), _defineProperty(_cn, "ribbon-bottom", position && position.substr(0, 6) === "bottom"), _defineProperty(_cn, "ribbon-left", position && position.substr(-4) === "left"), _defineProperty(_cn, "ribbon-right", position && position.substr(-5) === "right"), _cn), className);

  return /*#__PURE__*/React.createElement(El.Div, _extends({
    className: _className
  }, rest), icon && /*#__PURE__*/React.createElement(Icon, {
    name: icon
  }), children);
}

/**
 * Components for building the base of your website, such as a header, footer and nav bar
 */
function Site(props) {
  return props.children;
}

/**
 * The very top header bar of your website, containing the logo and some optional
 * action components, such as a NotificationTray or an AccountDropdown on the right hand side
 */
var SiteHeader = function SiteHeader(_ref) {
  var children = _ref.children,
      href = _ref.href;
      _ref.align;
      var logoURL = _ref.logoURL,
      alt = _ref.alt,
      notificationsTrayFromProps = _ref.notificationsTray,
      accountDropdownFromProps = _ref.accountDropdown,
      navItems = _ref.navItems,
      onMenuToggleClick = _ref.onMenuToggleClick,
      searchBar = _ref.searchBar;
  return /*#__PURE__*/React.createElement(CompoundNavbar, {
    expand: "md",
    brand: logoURL && /*#__PURE__*/React.createElement(Image, {
      href: href,
      alt: alt,
      src: logoURL
    })
  }, children || /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(NavbarToggler, {
    onClick: onMenuToggleClick
  }, /*#__PURE__*/React.createElement(NavbarTogglerIcon, null)), searchBar && /*#__PURE__*/React.createElement(El.Div, {
    msSm: 0,
    msMd: 5,
    me: "auto",
    dSm: "none",
    dLg: "block"
  }, searchBar), /*#__PURE__*/React.createElement(NavbarNav, null, navItems, notificationsTrayFromProps && /*#__PURE__*/React.createElement(CompoundNav.Item, {
    link: false,
    className: "d-none d-md-flex"
  }, /*#__PURE__*/React.createElement(CompoundNotification.Tray, notificationsTrayFromProps)), accountDropdownFromProps && /*#__PURE__*/React.createElement(AccountDropdown, accountDropdownFromProps))));
};

/**
 * The footer of your website
 */
var SiteFooter = function SiteFooter(_ref) {
  var links = _ref.links,
      note = _ref.note,
      copyright = _ref.copyright,
      nav = _ref.nav;
  return /*#__PURE__*/createElement(Fragment, null, (links || note) && /*#__PURE__*/createElement("div", {
    className: "footer"
  }, /*#__PURE__*/createElement(Container, null, /*#__PURE__*/createElement(Grid.Row, null, /*#__PURE__*/createElement(Grid.Col, {
    lg: 8
  }, /*#__PURE__*/createElement(Grid.Row, null, links && /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(Grid.Col, {
    col: 6,
    md: 3
  }, /*#__PURE__*/createElement(List, {
    unstyled: true,
    className: "mb-0"
  }, /*#__PURE__*/createElement(List.Item, null, links[0]), /*#__PURE__*/createElement(List.Item, null, links[1]))), /*#__PURE__*/createElement(Grid.Col, {
    col: 6,
    md: 3
  }, /*#__PURE__*/createElement(List, {
    unstyled: true,
    className: "mb-0"
  }, /*#__PURE__*/createElement(List.Item, null, links[2]), /*#__PURE__*/createElement(List.Item, null, links[3]))), /*#__PURE__*/createElement(Grid.Col, {
    col: 6,
    md: 3
  }, /*#__PURE__*/createElement(List, {
    unstyled: true,
    className: "mb-0"
  }, /*#__PURE__*/createElement(List.Item, null, links[4]), /*#__PURE__*/createElement(List.Item, null, links[5]))), /*#__PURE__*/createElement(Grid.Col, {
    col: 6,
    md: 3
  }, /*#__PURE__*/createElement(List, {
    unstyled: true,
    className: "mb-0"
  }, /*#__PURE__*/createElement(List.Item, null, links[6]), /*#__PURE__*/createElement(List.Item, null, links[7])))))), /*#__PURE__*/createElement(Grid.Col, {
    lg: 4,
    className: "mt-4 mt-lg-0"
  }, note)))), (nav || copyright) && /*#__PURE__*/createElement("footer", {
    className: "footer"
  }, /*#__PURE__*/createElement(Container, null, /*#__PURE__*/createElement(Grid.Row, {
    className: "align-items-center flex-row-reverse"
  }, /*#__PURE__*/createElement(Grid.Col, {
    col: "auto",
    ms: "auto"
  }, /*#__PURE__*/createElement(Grid.Row, {
    className: "align-items-center"
  }, nav)), /*#__PURE__*/createElement(Grid.Col, {
    col: 12,
    lg: "auto",
    mt: 3,
    mtLg: 0,
    textAlign: "center"
  }, copyright)))));
};

var SiteNav = function SiteNav(_ref) {
  var children = _ref.children,
      items = _ref.items,
      itemsObjects = _ref.itemsObjects;
      _ref.withSearchForm;
      var rightColumnComponent = _ref.rightColumnComponent,
      _ref$collapse = _ref.collapse,
      collapse = _ref$collapse === void 0 ? false : _ref$collapse,
      logoURL = _ref.logoURL,
      rest = _objectWithoutProperties(_ref, ["children", "items", "itemsObjects", "withSearchForm", "rightColumnComponent", "collapse", "logoURL"]);

  var classes = classnames({
    collapse: collapse
  });

  var _children = /*#__PURE__*/createElement(Fragment, null, (items || itemsObjects) && /*#__PURE__*/createElement(CompoundNav, {
    items: items,
    itemsObjects: itemsObjects
  }), children, rightColumnComponent);

  if (rest.isSide) {
    return /*#__PURE__*/createElement(CompoundNavbar, _extends({
      brand: logoURL && /*#__PURE__*/createElement(Image, {
        src: logoURL,
        style: {
          marginRight: "0.5rem",
          height: 40
        }
      }),
      expand: "md",
      className: classes
    }, rest), /*#__PURE__*/createElement(NavbarNav, null, _children));
  }

  return /*#__PURE__*/createElement(CompoundNavbar, _extends({
    brand: logoURL && /*#__PURE__*/createElement(Image, {
      src: logoURL
    }),
    expand: "md",
    className: classes
  }, rest), _children);
};

var SiteLogo = function SiteLogo(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  var _className = classnames("navbar-brand", className);

  return /*#__PURE__*/createElement("a", _extends({
    className: _className,
    href: props.href
  }, props), /*#__PURE__*/createElement("img", {
    src: props.src,
    className: "d-none d-md-block navbar-brand-logo",
    alt: props.alt
  }), props.srcSmall && /*#__PURE__*/createElement("img", {
    src: props.srcSmall,
    className: "d-md-none navbar-brand-logo",
    alt: props.alt
  }));
};

var SiteWrapper = function SiteWrapper(_ref) {
  var header = _ref.header,
      nav = _ref.nav,
      footer = _ref.footer,
      children = _ref.children;
      _ref.navIsSide;
      var rest = _objectWithoutProperties(_ref, ["header", "nav", "footer", "children", "navIsSide"]);

  return /*#__PURE__*/React.createElement(Page, _extends({
    navbar: /*#__PURE__*/React.createElement(NavbarTogglerProvider, null, header, nav),
    footer: footer
  }, rest), children);
};

var CompoundSite = Site;
CompoundSite.Header = SiteHeader;
CompoundSite.Footer = SiteFooter;
CompoundSite.Nav = SiteNav;
CompoundSite.Logo = SiteLogo;
CompoundSite.Wrapper = SiteWrapper;

function Stamp(_ref) {
  var _cn;

  var children = _ref.children,
      className = _ref.className,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "md" : _ref$size,
      icon = _ref.icon,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["children", "className", "size", "icon", "color"]);

  var classes = classnames((_cn = {
    stamp: true
  }, _defineProperty(_cn, "stamp-".concat(size), size), _defineProperty(_cn, "bg-".concat(color), color), _defineProperty(_cn, "text-white", true), _cn), className);
  return /*#__PURE__*/createElement(El.Span, _extends({
    className: classes
  }, rest), icon && /*#__PURE__*/createElement(Icon, {
    name: icon
  }), children);
}

function StampCard(_ref) {
  var children = _ref.children,
      className = _ref.className,
      icon = _ref.icon,
      color = _ref.color,
      header = _ref.header,
      footer = _ref.footer;
  var classes = classnames(className);
  return /*#__PURE__*/createElement(CompoundCard, {
    className: classes
  }, /*#__PURE__*/createElement("div", {
    className: "p-3 d-flex align-items-center"
  }, /*#__PURE__*/createElement(Stamp, {
    color: color,
    icon: icon,
    me: 3
  }), /*#__PURE__*/createElement("div", null, header && /*#__PURE__*/createElement(CompoundHeader, {
    size: 3,
    m: 0
  }, header), children, footer && /*#__PURE__*/createElement(CompoundText.Small, {
    textColor: "muted"
  }, footer))));
}

/**
 * Used for dispaying an individual statistic/number with different potential layouts
 */
function StatsCard(_ref) {
  var children = _ref.children,
      className = _ref.className,
      movement = _ref.movement,
      movementLabel = _ref.movementLabel,
      total = _ref.total,
      label = _ref.label,
      _ref$layout = _ref.layout,
      layout = _ref$layout === void 0 ? 1 : _ref$layout,
      chart = _ref.chart,
      progressWidth = _ref.progressWidth,
      _ref$progressColor = _ref.progressColor,
      progressColor = _ref$progressColor === void 0 ? "primary" : _ref$progressColor,
      actions = _ref.actions;
  var classes = classnames(className);
  var movementString = "".concat(movement > 0 ? "+" : "").concat(movement, "%");
  var movementColor = !movement ? "yellow" : movement > 0 ? "green" : "red";

  if (layout === 3 || layout === 4) {
    return /*#__PURE__*/createElement(CompoundCard, {
      className: classes
    }, /*#__PURE__*/createElement(CompoundCard.Body, null, /*#__PURE__*/createElement(El.Div, {
      d: "flex"
    }, /*#__PURE__*/createElement("div", null, label), actions && /*#__PURE__*/createElement(El.Div, {
      ms: "auto"
    }, actions)), /*#__PURE__*/createElement(El.Div, {
      d: "flex",
      mb: layout === 3 ? 3 : 0,
      className: "align-items-baseline"
    }, /*#__PURE__*/createElement(CompoundHeader, {
      mb: 0,
      me: 2
    }, total), layout === 4 && /*#__PURE__*/createElement(El.Div, {
      me: "auto",
      className: "text-".concat(movementColor)
    }, movementString, " ", /*#__PURE__*/createElement(Icon, {
      name: !movement ? "minus" : movement > 0 ? "trending-up" : "trending-down",
      thin: true
    }))), layout === 3 && /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(El.Div, {
      d: "flex",
      mb: 2
    }, /*#__PURE__*/createElement("div", null, movementLabel), /*#__PURE__*/createElement(El.Div, {
      ms: "auto",
      className: "text-".concat(movementColor)
    }, movementString, " ", /*#__PURE__*/createElement(Icon, {
      name: !movement ? "minus" : movement > 0 ? "trending-up" : "trending-down",
      thin: true
    }))), typeof progressWidth !== "undefined" && /*#__PURE__*/createElement(Progress, {
      size: "sm"
    }, /*#__PURE__*/createElement(Progress.Bar, {
      color: progressColor,
      width: progressWidth
    }))), children), chart && /*#__PURE__*/createElement("div", {
      className: "card-chart"
    }, chart));
  }

  if (layout === 2) {
    return /*#__PURE__*/createElement(CompoundCard, {
      className: classes
    }, /*#__PURE__*/createElement(CompoundCard.Body, null, /*#__PURE__*/createElement("div", {
      className: "card-value float-right text-".concat(movementColor)
    }, movementString), /*#__PURE__*/createElement(CompoundHeader.H3, {
      className: "mb-1"
    }, total), /*#__PURE__*/createElement(CompoundText, {
      textColor: "muted"
    }, label)), chart && /*#__PURE__*/createElement("div", {
      className: "card-chart-bg"
    }, chart));
  }

  return /*#__PURE__*/createElement(CompoundCard, {
    className: classes
  }, /*#__PURE__*/createElement(CompoundCard.Body, {
    className: "p-3 text-center"
  }, /*#__PURE__*/createElement(CompoundText, {
    color: movementColor,
    className: "text-right"
  }, movementString, /*#__PURE__*/createElement(Icon, {
    name: !movement ? "minus" : movement > 0 ? "chevron-up" : "chevron-down"
  })), /*#__PURE__*/createElement(CompoundHeader, {
    className: "m-0"
  }, total), /*#__PURE__*/createElement(CompoundText, {
    color: "gray",
    className: " mb-4"
  }, label)));
}

var Steps = function Steps(_ref) {
  var _cn;

  var children = _ref.children,
      className = _ref.className,
      color = _ref.color,
      counter = _ref.counter,
      rest = _objectWithoutProperties(_ref, ["children", "className", "color", "counter"]);

  var _className = classnames("steps", (_cn = {}, _defineProperty(_cn, "steps-".concat(color), color), _defineProperty(_cn, "steps-counter", counter), _cn), className);

  return /*#__PURE__*/React.createElement(El.Div, _extends({
    p: 5,
    className: _className
  }, rest), children);
};

var Step = function Step(_ref) {
  var children = _ref.children,
      className = _ref.className,
      active = _ref.active,
      tooltip = _ref.tooltip,
      rest = _objectWithoutProperties(_ref, ["children", "className", "active", "tooltip"]);

  var _className = classnames("step-item", {
    active: active
  }, className);

  var component = /*#__PURE__*/React.createElement(El.Span, _extends({
    className: _className
  }, rest), children);

  if (tooltip) {
    return /*#__PURE__*/React.createElement(Tooltip, {
      content: tooltip,
      placement: "top",
      arrow: false
    }, component);
  }

  return component;
};

var CompoundSteps = Steps;
CompoundSteps.Step = Step;

function StoreCard(_ref) {
  _ref.children;
      var title = _ref.title,
      subtitle = _ref.subtitle,
      price = _ref.price,
      imgUrl = _ref.imgUrl,
      imgAlt = _ref.imgAlt;
  return /*#__PURE__*/createElement(CompoundCard, null, /*#__PURE__*/createElement(CompoundCard.Body, null, /*#__PURE__*/createElement("div", {
    className: "mb-4 text-center"
  }, /*#__PURE__*/createElement("img", {
    src: imgUrl,
    alt: imgAlt
  })), /*#__PURE__*/createElement(CompoundCard.Title, null, title), /*#__PURE__*/createElement(CompoundText, {
    className: "card-subtitle"
  }, subtitle), /*#__PURE__*/createElement("div", {
    className: "mt-5 d-flex align-items-center"
  }, /*#__PURE__*/createElement("div", {
    className: "product-price"
  }, /*#__PURE__*/createElement("strong", null, price)), /*#__PURE__*/createElement("div", {
    className: "ml-auto"
  }, /*#__PURE__*/createElement(CompoundButton, {
    color: "primary"
  }, /*#__PURE__*/createElement(Icon, {
    prefix: "fe",
    name: "plus"
  }), "Add to cart")))));
}

var Tab = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Tab, _React$PureComponent);

  var _super = _createSuper(Tab);

  function Tab() {
    _classCallCheck(this, Tab);

    return _super.apply(this, arguments);
  }

  _createClass(Tab, [{
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);

  return Tab;
}(PureComponent);

function TabbedContainer(props) {
  var tabs = Children.toArray(props.children);
  return /*#__PURE__*/createElement(Fragment, null, tabs.filter(function (tab) {
    return tab.props.title === props.selectedTitle;
  }));
}

function TabbedHeader(_ref) {
  var children = _ref.children,
      stateCallback = _ref.stateCallback,
      selectedTitle = _ref.selectedTitle,
      rest = _objectWithoutProperties(_ref, ["children", "stateCallback", "selectedTitle"]);

  var tabs = Children.toArray(children);
  return /*#__PURE__*/createElement(El.Ul, _extends({
    classNames: "nav nav-tabs Tab_header_tabs"
  }, rest), tabs.map(function (_ref2, index) {
    var _ref2$props = _ref2.props,
        title = _ref2$props.title,
        tabRest = _objectWithoutProperties(_ref2$props, ["title"]);

    return /*#__PURE__*/createElement(CompoundNav.Item, _extends({
      key: index,
      value: title,
      onClick: function onClick() {
        return stateCallback(title);
      },
      active: title === selectedTitle
    }, tabRest));
  }));
}

var Tabs = function Tabs(_ref) {
  var children = _ref.children,
      initialTab = _ref.initialTab;

  var _useState = useState(initialTab),
      _useState2 = _slicedToArray(_useState, 2),
      selectedTitle = _useState2[0],
      setSelectedTitle = _useState2[1];

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabbedHeader, {
    selectedTitle: selectedTitle,
    stateCallback: setSelectedTitle
  }, children), /*#__PURE__*/React.createElement("div", {
    className: "margin-bottom-24"
  }), /*#__PURE__*/React.createElement(TabbedContainer, {
    selectedTitle: selectedTitle
  }, children));
};

var TabbedCard = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(TabbedCard, _React$PureComponent);

  var _super = _createSuper(TabbedCard);

  function TabbedCard() {
    var _this;

    _classCallCheck(this, TabbedCard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      selectedTitle: _this.props.initialTab
    });

    return _this;
  }

  _createClass(TabbedCard, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var children = this.props.children;
      var selectedTitle = this.state.selectedTitle;
      return /*#__PURE__*/createElement(CompoundCard, null, /*#__PURE__*/createElement(CompoundCard.Header, null, /*#__PURE__*/createElement(TabbedHeader, {
        selectedTitle: selectedTitle,
        stateCallback: function stateCallback(newTitle) {
          return _this2.setState({
            selectedTitle: newTitle
          });
        }
      }, children)), /*#__PURE__*/createElement(CompoundCard.Body, null, /*#__PURE__*/createElement(TabbedContainer, {
        selectedTitle: selectedTitle
      }, children)));
    }
  }]);

  return TabbedCard;
}(PureComponent);

function TableHeader(_ref) {
  var className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "children"]);

  var classes = classnames(className);
  return /*#__PURE__*/React.createElement(El.Thead, _extends({
    className: classes
  }, props), children);
}

function TableBody(_ref) {
  var className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "children"]);

  var classes = classnames(className);
  return /*#__PURE__*/createElement(El.Tbody, _extends({
    className: classes
  }, props), children);
}

function TableRow(_ref) {
  var className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "children"]);

  var classes = classnames(className);
  return /*#__PURE__*/createElement(El.Tr, _extends({
    className: classes
  }, props), children);
}

function TableCol(_ref) {
  var className = _ref.className,
      children = _ref.children,
      alignContent = _ref.alignContent,
      rest = _objectWithoutProperties(_ref, ["className", "children", "alignContent"]);

  var classes = classnames(_defineProperty({}, "text-".concat(alignContent), alignContent), className);
  return /*#__PURE__*/createElement(El.Td, _extends({
    className: classes
  }, rest), children);
}

function TableColHeader(_ref) {
  var className = _ref.className,
      children = _ref.children,
      alignContent = _ref.alignContent,
      rest = _objectWithoutProperties(_ref, ["className", "children", "alignContent"]);

  var classes = classnames(_defineProperty({}, "text-".concat(alignContent), alignContent), className);
  return /*#__PURE__*/React.createElement(El.Th, _extends({
    className: classes
  }, rest), children);
}

function Table(_ref) {
  var className = _ref.className,
      children = _ref.children,
      cards = _ref.cards,
      striped = _ref.striped,
      responsive = _ref.responsive,
      highlightRowOnHover = _ref.highlightRowOnHover,
      hasOutline = _ref.hasOutline,
      verticalAlign = _ref.verticalAlign,
      headerItems = _ref.headerItems,
      bodyItems = _ref.bodyItems,
      props = _objectWithoutProperties(_ref, ["className", "children", "cards", "striped", "responsive", "highlightRowOnHover", "hasOutline", "verticalAlign", "headerItems", "bodyItems"]);

  var classes = classnames("table", {
    "card-table": cards,
    "table-striped": striped,
    "table-hover": highlightRowOnHover,
    "table-outline": hasOutline,
    "table-vcenter": verticalAlign === "center"
  }, className);
  var header = headerItems && /*#__PURE__*/React.createElement(Table.Header, null, /*#__PURE__*/React.createElement(Table.Row, null, headerItems.map(function (_ref2, i) {
    var content = _ref2.content,
        item = _objectWithoutProperties(_ref2, ["content"]);

    return /*#__PURE__*/React.createElement(Table.ColHeader, _extends({
      key: i
    }, item), content);
  })));
  var body = bodyItems && /*#__PURE__*/React.createElement(Table.Body, null, bodyItems.map(function (row, i) {
    return /*#__PURE__*/React.createElement(Table.Row, row, row.item.map(function (_ref3, i) {
      var content = _ref3.content,
          col = _objectWithoutProperties(_ref3, ["content"]);

      return /*#__PURE__*/React.createElement(Table.Col, _extends({
        key: i
      }, col), content);
    }));
  }));
  var table = /*#__PURE__*/React.createElement(El.Table, _extends({
    className: classes
  }, props), header, body || children);
  return !responsive ? table : /*#__PURE__*/React.createElement("div", {
    className: "table-responsive"
  }, table);
}

Table.defaultProps = {
  cards: false,
  striped: false,
  responsive: false
};
Table.Header = TableHeader;
Table.Body = TableBody;
Table.Row = TableRow;
Table.Col = TableCol;
Table.ColHeader = TableColHeader;

var CompoundTag = Badge;
CompoundTag.AddOn = BadgeAddOn;
CompoundTag.List = BadgeList;

function Timeline(_ref) {
  var className = _ref.className,
      children = _ref.children,
      simple = _ref.simple,
      rest = _objectWithoutProperties(_ref, ["className", "children", "simple"]);

  var classes = classnames("list-timeline", {
    "list-timeline-simple": simple
  }, className);
  return /*#__PURE__*/React.createElement(El.Ul, _extends({
    className: classes
  }, rest), children);
}

function TimelineItemBadge(_ref) {
  var className = _ref.className,
      children = _ref.children,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["className", "children", "color"]);

  var classes = classnames(_defineProperty({
    "list-timeline-badge": true
  }, "bg-".concat(color), color), className);
  return /*#__PURE__*/React.createElement(El.Div, _extends({
    className: classes
  }, rest), children);
}

var TimelineItemTime = function TimelineItemTime(_ref) {
  var className = _ref.className,
      children = _ref.children,
      active = _ref.active,
      rest = _objectWithoutProperties(_ref, ["className", "children", "active"]);

  var classes = classnames({
    "list-timeline-time": true,
    "text-muted-black": active
  }, className);
  return /*#__PURE__*/React.createElement(El.Div, _extends({
    className: classes
  }, rest), children);
};

function TimelineItemTitle(_ref) {
  var children = _ref.children,
      className = _ref.className,
      active = _ref.active,
      rest = _objectWithoutProperties(_ref, ["children", "className", "active"]);

  var _className = classnames("list-timeline-title", {}, className);

  return /*#__PURE__*/React.createElement(El.P, _extends({
    className: _className
  }, rest), active ? /*#__PURE__*/React.createElement("strong", null, children) : children);
}

var TimelineItemDescription = /*#__PURE__*/forwardRef(function TimelineItemDescription(_ref, ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/createElement(El.P, _extends({
    classNames: "text-muted",
    ref: ref
  }, rest), children);
});

function TimelineItem(_ref) {
  var className = _ref.className,
      children = _ref.children,
      titleFromProps = _ref.title,
      description = _ref.description,
      badge = _ref.badge,
      badgeColor = _ref.badgeColor,
      time = _ref.time,
      active = _ref.active,
      rest = _objectWithoutProperties(_ref, ["className", "children", "title", "description", "badge", "badgeColor", "time", "active"]);

  var classes = classnames("timeline-item", {}, className);
  var titleString = titleFromProps || typeof children === "string" && children;
  var title = titleString && /*#__PURE__*/React.createElement(TimelineItemTitle, {
    active: active
  }, titleString);
  var titleAndDescription = title && /*#__PURE__*/React.createElement(React.Fragment, null, title, description && /*#__PURE__*/React.createElement(TimelineItemDescription, null, description));
  return /*#__PURE__*/React.createElement(El.Li, _extends({
    className: classes
  }, rest), (badge || badgeColor) && /*#__PURE__*/React.createElement(TimelineItemBadge, {
    color: badgeColor
  }), active ? /*#__PURE__*/React.createElement("div", null, titleAndDescription) : titleAndDescription, children, time && /*#__PURE__*/React.createElement(TimelineItemTime, {
    active: active
  }, time));
}

function TimelineItemContent(_ref) {
  var children = _ref.children,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, ["children", "className"]);

  var _className = classnames("list-timeline-content", {}, className);

  return /*#__PURE__*/React.createElement(El.Div, _extends({
    className: _className
  }, rest), children);
}

function TimelineItemIcon(_ref) {
  var children = _ref.children,
      className = _ref.className,
      active = _ref.active,
      bg = _ref.bg,
      rest = _objectWithoutProperties(_ref, ["children", "className", "active", "bg"]);

  var _className = classnames("list-timeline-icon", _defineProperty({}, "bg-".concat(bg), bg), className);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    className: _className
  }, rest), active ? /*#__PURE__*/React.createElement("strong", null, children) : children);
}

var CompoundTimeline = Timeline;
CompoundTimeline.Item = TimelineItem;
CompoundTimeline.ItemBadge = TimelineItemBadge;
CompoundTimeline.ItemDescription = TimelineItemDescription;
CompoundTimeline.ItemTime = TimelineItemTime;
CompoundTimeline.ItemTitle = TimelineItemTitle;
CompoundTimeline.ItemContent = TimelineItemContent;
CompoundTimeline.ItemIcon = TimelineItemIcon;

var ToastHeader = function ToastHeader(_ref) {
  var children = _ref.children,
      className = _ref.className,
      avatar = _ref.avatar,
      title = _ref.title,
      timestamp = _ref.timestamp,
      rest = _objectWithoutProperties(_ref, ["children", "className", "avatar", "title", "timestamp"]);

  var _className = classnames("toast-header", className);

  return /*#__PURE__*/React.createElement(El.Div, _extends({
    className: _className
  }, rest), avatar && /*#__PURE__*/React.createElement(Avatar, {
    size: "sm",
    me: 2,
    imageURL: avatar
  }), title && /*#__PURE__*/React.createElement("strong", {
    className: "mr-auto"
  }, title), timestamp && /*#__PURE__*/React.createElement("small", null, "11 mins ago"), /*#__PURE__*/React.createElement(Button, {
    ms: 2,
    className: "close",
    "data-dismiss": "toast",
    "aria-label": "Close"
  }, /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true"
  }, "\xD7")), children);
};

var ToastBody = function ToastBody(_ref) {
  var children = _ref.children,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, ["children", "className"]);

  var _className = classnames("toast-body", className);

  return /*#__PURE__*/React.createElement(El.Div, _extends({
    className: _className
  }, rest), children);
};

var Toast = function Toast(_ref) {
  var children = _ref.children,
      className = _ref.className,
      show = _ref.show,
      header = _ref.header,
      body = _ref.body,
      rest = _objectWithoutProperties(_ref, ["children", "className", "show", "header", "body"]);

  var _className = classnames("toast", {
    show: show
  }, className);

  return /*#__PURE__*/React.createElement(El.Div, _extends({
    className: _className,
    role: "alert",
    "aria-live": "assertive",
    "aria-atomic": "true"
  }, rest), header && /*#__PURE__*/React.createElement(ToastHeader, header), body && /*#__PURE__*/React.createElement(ToastBody, null, body), children);
};

var CompoundToast = Toast;
CompoundToast.Header = ToastHeader;
CompoundToast.Body = ToastBody;

var Label = createTablerElement("label", {
  className: "label",
  displayName: "Label",
  classNames: function classNames(_ref) {
    var required = _ref.required;
    return {
      required: required
    };
  }
});

var RouterContextProvider = /*#__PURE__*/function (_React$Component) {
  _inherits(RouterContextProvider, _React$Component);

  var _super = _createSuper(RouterContextProvider);

  function RouterContextProvider() {
    _classCallCheck(this, RouterContextProvider);

    return _super.apply(this, arguments);
  }

  _createClass(RouterContextProvider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          callback = _this$props.callback,
          location = _this$props.location;
      callback(location);
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return RouterContextProvider;
}(Component);

function StandaloneFormPage(props) {
  return /*#__PURE__*/createElement("div", {
    className: "page"
  }, /*#__PURE__*/createElement("div", {
    className: "page-single"
  }, /*#__PURE__*/createElement("div", {
    className: "container"
  }, /*#__PURE__*/createElement("div", {
    className: "row"
  }, /*#__PURE__*/createElement("div", {
    className: "col col-login mx-auto"
  }, /*#__PURE__*/createElement("div", {
    className: "text-center mb-6"
  }, /*#__PURE__*/createElement("img", {
    src: props.imageURL,
    className: "h-6",
    alt: "logo"
  })), props.children)))));
}

function DefaultErrorPage(props) {
  var _onBackClick = function _onBackClick(event) {
    window.history.back();
    event.preventDefault();
    return true;
  };

  var _props$title = props.title,
      title = _props$title === void 0 ? "Error" : _props$title,
      _props$subtitle = props.subtitle,
      subtitle = _props$subtitle === void 0 ? "Sorry an unkown error occurred" : _props$subtitle,
      details = props.details,
      _props$action = props.action,
      action = _props$action === void 0 ? "Go back" : _props$action;
  return /*#__PURE__*/createElement(CompoundPage, {
    className: "text-center"
  }, /*#__PURE__*/createElement(Container, null, /*#__PURE__*/createElement(CompoundHeader.H1, {
    className: "display-1 text-muted mb-5"
  }, title), /*#__PURE__*/createElement(CompoundHeader.H2, null, subtitle), details && /*#__PURE__*/createElement(CompoundHeader.H4, {
    className: "text-muted font-weight-normal mb-7"
  }, details), /*#__PURE__*/createElement(CompoundButton, {
    onClick: _onBackClick,
    className: "btn-primary"
  }, /*#__PURE__*/createElement(Icon, {
    className: "mr-2",
    name: "arrow-left"
  }), action)));
}

function Error400Page(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? "400" : _ref$title,
      _ref$subtitle = _ref.subtitle,
      subtitle = _ref$subtitle === void 0 ? "Oops... You just found an error page..." : _ref$subtitle,
      _ref$details = _ref.details,
      details = _ref$details === void 0 ? "We are sorry but your request contains bad syntax and cannot be fulfilled..." : _ref$details,
      action = _ref.action;
  return /*#__PURE__*/createElement(DefaultErrorPage, {
    title: title,
    subtitle: subtitle,
    details: details,
    action: action
  });
}

function Error401Page(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? "401" : _ref$title,
      _ref$subtitle = _ref.subtitle,
      subtitle = _ref$subtitle === void 0 ? "Oops... You just found an error page..." : _ref$subtitle,
      _ref$details = _ref.details,
      details = _ref$details === void 0 ? "We are sorry but you are not authorized to access this page..." : _ref$details,
      action = _ref.action;
  return /*#__PURE__*/createElement(DefaultErrorPage, {
    title: title,
    subtitle: subtitle,
    details: details,
    action: action
  });
}

function Error403Page(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? "403" : _ref$title,
      _ref$subtitle = _ref.subtitle,
      subtitle = _ref$subtitle === void 0 ? "Oops... You just found an error page..." : _ref$subtitle,
      _ref$details = _ref.details,
      details = _ref$details === void 0 ? "We are sorry but you do not have permission to access this page..." : _ref$details,
      action = _ref.action;
  return /*#__PURE__*/createElement(DefaultErrorPage, {
    title: title,
    subtitle: subtitle,
    details: details,
    action: action
  });
}

function Error404Page(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? "404" : _ref$title,
      _ref$subtitle = _ref.subtitle,
      subtitle = _ref$subtitle === void 0 ? "Oops... You just found an error page..." : _ref$subtitle,
      _ref$details = _ref.details,
      details = _ref$details === void 0 ? "We are sorry but the page you have requested can not be found..." : _ref$details,
      action = _ref.action;
  return /*#__PURE__*/createElement(DefaultErrorPage, {
    title: title,
    subtitle: subtitle,
    details: details,
    action: action
  });
}

function Error500Page(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? "500" : _ref$title,
      _ref$subtitle = _ref.subtitle,
      subtitle = _ref$subtitle === void 0 ? "Oops... You just found an error page..." : _ref$subtitle,
      _ref$details = _ref.details,
      details = _ref$details === void 0 ? "We are sorry but your request contains bad syntax and cannot be fulfilled..." : _ref$details,
      action = _ref.action;
  return /*#__PURE__*/createElement(DefaultErrorPage, {
    title: title,
    subtitle: subtitle,
    details: details,
    action: action
  });
}

function Error503Page(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? "503" : _ref$title,
      _ref$subtitle = _ref.subtitle,
      subtitle = _ref$subtitle === void 0 ? "Oops... You just found an error page..." : _ref$subtitle,
      _ref$details = _ref.details,
      details = _ref$details === void 0 ? "This page is temporarily unavailable.  Please reload your browser..." : _ref$details,
      action = _ref.action;
  return /*#__PURE__*/createElement(DefaultErrorPage, {
    title: title,
    subtitle: subtitle,
    details: details,
    action: action
  });
}

function FormCard(_ref) {
  var children = _ref.children,
      action = _ref.action,
      method = _ref.method,
      onSubmit = _ref.onSubmit,
      title = _ref.title,
      buttonText = _ref.buttonText;
  return /*#__PURE__*/createElement(CompoundForm, {
    className: "card",
    onSubmit: onSubmit,
    action: action,
    method: method
  }, /*#__PURE__*/createElement(CompoundCard.Body, {
    className: "p-6"
  }, /*#__PURE__*/createElement(CompoundCard.Title, null, title), children, /*#__PURE__*/createElement(CompoundForm.Footer, null, /*#__PURE__*/createElement(CompoundButton, {
    type: "submit",
    color: "primary",
    block: true
  }, buttonText))));
}

function FormTextInput(props) {
  var label = props.label,
      propsForInput = _objectWithoutProperties(props, ["label"]);

  var formInputComponent = /*#__PURE__*/createElement(CompoundForm.Input, propsForInput);
  return /*#__PURE__*/createElement(CompoundForm.Group, {
    label: label
  }, formInputComponent);
}

function FormCheckboxInput(props) {
  var formCheckboxComponent = /*#__PURE__*/createElement(CompoundForm.Checkbox, props);
  return /*#__PURE__*/createElement(CompoundForm.Group, null, formCheckboxComponent);
}

/**
 * Returns an object of fields with values set based on the touched and error values
 * If a value is both touched and has a non-empty error string it is returned as the fields value
 */

function touchedErrors() {
  var touched = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var errors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var fields = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return fields.reduce(function (acc, cur) {
    return Object.assign(acc, _defineProperty({}, cur, touched && touched[cur] && errors ? errors[cur] : ""));
  }, {});
}
/**
 * A HOC that modifies the errors propso that it only returns errors if the the field
 * has also been touched
 * First takes an array of the field names, followed by the component
 */


function withTouchedErrors() {
  var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return function withComponent(Component) {
    return function WithTouchedErrors(props) {
      var errors = touchedErrors(props.touched, props.errors, fields);
      return /*#__PURE__*/createElement(Component, _extends({}, props, {
        errors: errors
      }));
    };
  };
}

var strings$2 = {
  title: "Login to your Account",
  buttonText: "Login",
  emailLabel: "Email Address",
  emailPlaceholder: "Enter email",
  passwordLabel: "Password",
  passwordPlaceholder: "Password"
};

/**
 * A login page
 * Can be easily wrapped with form libraries like formik and redux-form
 */
function LoginPage(props) {
  var action = props.action,
      method = props.method,
      onSubmit = props.onSubmit,
      onChange = props.onChange,
      onBlur = props.onBlur,
      values = props.values,
      _props$strings = props.strings,
      strings = _props$strings === void 0 ? {} : _props$strings,
      errors = props.errors,
      logoUrl = props.logoUrl;
  return /*#__PURE__*/createElement(StandaloneFormPage, {
    imageURL: logoUrl
  }, /*#__PURE__*/createElement(FormCard, {
    buttonText: strings.buttonText || strings$2.buttonText,
    title: strings.title || strings$2.title,
    onSubmit: onSubmit,
    action: action,
    method: method
  }, /*#__PURE__*/createElement(FormTextInput, {
    name: "email",
    label: strings.emailLabel || strings$2.emailLabel,
    placeholder: strings.emailPlaceholder || strings$2.emailPlaceholder,
    onChange: onChange,
    onBlur: onBlur,
    value: values && values.email,
    error: errors && errors.email
  }), /*#__PURE__*/createElement(FormTextInput, {
    name: "password",
    type: "password",
    label: strings.passwordLabel || strings$2.passwordLabel,
    placeholder: strings.passwordPlaceholder || strings$2.passwordPlaceholder,
    onChange: onChange,
    onBlur: onBlur,
    value: values && values.password,
    error: errors && errors.password
  })));
}

var LoginPageWithTouchedErrors = withTouchedErrors(["email", "password"])(LoginPage);

var strings$1 = {
  title: "Create New Account",
  buttonText: "Create Account",
  nameLabel: "Name",
  namePlaceholder: "Enter name",
  emailLabel: "Email Address",
  emailPlaceholder: "Enter email",
  passwordLabel: "Password",
  passwordPlaceholder: "Password",
  termsLabel: "Agree to the terms and policy"
};

/**
 * A register page
 * Can be easily wrapped with form libraries like formik and redux-form
 */
function RegisterPage(props) {
  var action = props.action,
      method = props.method,
      onSubmit = props.onSubmit,
      onChange = props.onChange,
      onBlur = props.onBlur,
      values = props.values,
      _props$strings = props.strings,
      strings = _props$strings === void 0 ? {} : _props$strings,
      errors = props.errors,
      logoUrl = props.logoUrl;
  return /*#__PURE__*/createElement(StandaloneFormPage, {
    imageURL: logoUrl
  }, /*#__PURE__*/createElement(FormCard, {
    buttonText: strings.buttonText || strings$1.buttonText,
    title: strings.title || strings$1.title,
    onSubmit: onSubmit,
    action: action,
    method: method
  }, /*#__PURE__*/createElement(FormTextInput, {
    name: "name",
    label: strings.nameLabel || strings$1.nameLabel,
    placeholder: strings.namePlaceholder || strings$1.namePlaceholder,
    onChange: onChange,
    onBlur: onBlur,
    value: values && values.name,
    error: errors && errors.name
  }), /*#__PURE__*/createElement(FormTextInput, {
    name: "email",
    label: strings.emailLabel || strings$1.emailLabel,
    placeholder: strings.emailPlaceholder || strings$1.emailPlaceholder,
    onChange: onChange,
    onBlur: onBlur,
    value: values && values.email,
    error: errors && errors.email
  }), /*#__PURE__*/createElement(FormTextInput, {
    name: "password",
    type: "password",
    label: strings.passwordLabel || strings$1.passwordLabel,
    placeholder: strings.passwordPlaceholder || strings$1.passwordPlaceholder,
    onChange: onChange,
    onBlur: onBlur,
    value: values && values.password,
    error: errors && errors.password
  }), /*#__PURE__*/createElement(FormCheckboxInput, {
    onChange: onChange,
    onBlur: onBlur,
    value: values && values.terms,
    name: "terms",
    label: strings.termsLabel || strings$1.termsLabel
  })));
}

var RegisterPageWithTouchedErrors = withTouchedErrors(["name", "email", "password", "terms"])(RegisterPage);

var strings = {
  title: "Forgot Password",
  buttonText: "Request Password Change",
  emailLabel: "Email Address",
  emailPlaceholder: "Enter email",
  instructions: "Enter your email address and your password will be reset and emailed to you."
};

/**
 * A forgot password page
 * Can be easily wrapped with form libraries like formik and redux-form
 */
function ForgotPasswordPage(props) {
  var action = props.action,
      method = props.method,
      onSubmit = props.onSubmit,
      onChange = props.onChange,
      onBlur = props.onBlur,
      values = props.values,
      _props$strings = props.strings,
      strings$1 = _props$strings === void 0 ? {} : _props$strings,
      errors = props.errors,
      logoUrl = props.logoUrl;
  return /*#__PURE__*/createElement(StandaloneFormPage, {
    imageURL: logoUrl
  }, /*#__PURE__*/createElement(FormCard, {
    buttonText: strings$1.buttonText || strings.buttonText,
    title: strings$1.title || strings.title,
    onSubmit: onSubmit,
    action: action,
    method: method
  }, /*#__PURE__*/createElement("p", {
    className: "text-muted"
  }, strings$1.instructions || strings.instructions), /*#__PURE__*/createElement(FormTextInput, {
    name: "email",
    label: strings$1.emailLabel || strings.emailLabel,
    placeholder: strings$1.emailPlaceholder || strings.emailPlaceholder,
    onChange: onChange,
    onBlur: onBlur,
    value: values && values.email,
    error: errors && errors.email
  })));
}

var ForgotPasswordPageWithTouchedErrors = withTouchedErrors(["email"])(ForgotPasswordPage);

export { AccountDropdown, CompoundAlert as Alert, Avatar, CompoundBadge as Badge, BlogCard, Breadcrumb, BreadcrumbItem, CompoundButton as Button, CompoundCard as Card, Comment, CommentsCard, ContactCard, Container, DefaultErrorPage, Dimmer, CompoundDropdown as Dropdown, El, Error400Page, Error401Page, Error403Page, Error404Page, Error500Page, Error503Page, ForgotPasswordPageWithTouchedErrors as ForgotPasswordPage, CompoundForm as Form, FormCard, FormCheckboxInput, FormTextInput, GalleryCard, Grid, CompoundHeader as Header, Icon, Image, Label, List, Loader, LoginPageWithTouchedErrors as LoginPage, CompoundMedia as Media, CompoundNav as Nav, NavItem, NavLink, NavLinkIcon, NavLinkTitle, NavLinkToggle, NavSubItem, NavSubNav, NavSubmenu, NavSubmenuItem, CompoundNavbar as Navbar, NavbarBrand, NavbarHeading, NavbarNav, NavbarToggler, NavbarTogglerIcon, CompoundNotification as Notification, CompoundNotification as NotificationProps, CompoundPage as Page, PricingCard, Profile, Progress, ProgressCard, RegisterPageWithTouchedErrors as RegisterPage, Ribbon, RouterContextProvider, CompoundSite as Site, SocialNetworksList, Stamp, StampCard, StandaloneFormPage, StatsCard, CompoundSteps as Steps, StoreCard, SubHeader, Tab, TabbedCard, TabbedContainer, TabbedHeader, Table, Tabs, CompoundTag as Tag, CompoundText as Text, CompoundTimeline as Timeline, CompoundToast as Toast, Tooltip, additionalColors, colors, extraColors, lightColors, socialColors, softColors, standardColors };
